{
    "openapi": "3.0.1",
    "info": {
        "title": "Ritz Carlton Web API",
        "version": "1.0.2"
    },
    "paths": {
        "/api/v1/alert-settings": {
            "get": {
                "tags": ["Alert Settings"],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/AlertSettingResult"
                                }
                            }
                        }
                    }
                }
            },
            "put": {
                "tags": ["Alert Settings"],
                "requestBody": {
                    "content": {
                        "application/json": {
                            "schema": {
                                "$ref": "#/components/schemas/AlertSettingUpdateRequest"
                            }
                        }
                    },
                    "required": true
                },
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/AlertSettingResult"
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/alert-subscribers": {
            "get": {
                "tags": ["Alert Subscribers"],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "type": "array",
                                    "items": {
                                        "$ref": "#/components/schemas/AlertSubscriberResult"
                                    }
                                }
                            }
                        }
                    }
                }
            },
            "post": {
                "tags": ["Alert Subscribers"],
                "requestBody": {
                    "content": {
                        "application/json": {
                            "schema": {
                                "$ref": "#/components/schemas/AlertSubscriberCreateRequest"
                            }
                        }
                    },
                    "required": true
                },
                "responses": {
                    "201": {
                        "description": "Created",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/AlertSubscriberResult"
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/alert-subscribers/{id}": {
            "get": {
                "tags": ["Alert Subscribers"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/AlertSubscriberResult"
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            },
            "put": {
                "tags": ["Alert Subscribers"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "requestBody": {
                    "content": {
                        "application/json": {
                            "schema": {
                                "$ref": "#/components/schemas/AlertSubscriberUpdateRequest"
                            }
                        }
                    },
                    "required": true
                },
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/AlertSubscriberResult"
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            },
            "delete": {
                "tags": ["Alert Subscribers"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "204": {
                        "description": "No Content"
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            }
        },
        "/api/v1/anagraphic-import/generate-seed-code": {
            "post": {
                "tags": ["Anagraphic Import (Dev Only)"],
                "requestBody": {
                    "content": {
                        "multipart/form-data": {
                            "schema": {
                                "required": ["file"],
                                "type": "object",
                                "properties": {
                                    "file": {
                                        "type": "string",
                                        "format": "binary"
                                    }
                                }
                            },
                            "encoding": {
                                "file": {
                                    "style": "form"
                                }
                            }
                        }
                    }
                },
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/AnagraphicImportResult"
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/anagraphic-import/generate-seed-code-dev": {
            "get": {
                "tags": ["Anagraphic Import (Dev Only)"],
                "parameters": [
                    {
                        "name": "filePath",
                        "in": "query",
                        "schema": {
                            "type": "string"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/AnagraphicImportResult"
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/anagraphic-import/import-port-agents": {
            "post": {
                "tags": ["Anagraphic Import (Dev Only)"],
                "requestBody": {
                    "content": {
                        "multipart/form-data": {
                            "schema": {
                                "required": ["file"],
                                "type": "object",
                                "properties": {
                                    "file": {
                                        "type": "string",
                                        "format": "binary"
                                    }
                                }
                            },
                            "encoding": {
                                "file": {
                                    "style": "form"
                                }
                            }
                        }
                    }
                },
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/PortAgentImportResult"
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/logs": {
            "get": {
                "tags": ["Application Logs"],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/LoadResult"
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/logs/statistics": {
            "get": {
                "tags": ["Application Logs"],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/ApplicationLogStatisticsResult"
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/logs/seed-sample": {
            "post": {
                "tags": ["Application Logs"],
                "summary": "Seed sample logs for testing",
                "responses": {
                    "200": {
                        "description": "OK"
                    }
                }
            }
        },
        "/api/v1/dashboard/statistics": {
            "get": {
                "tags": ["Dashboard"],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/DashboardStatisticsResult"
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/dashboard/kpis": {
            "get": {
                "tags": ["Dashboard"],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/DashboardKpisResult"
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/dashboard-settings": {
            "get": {
                "tags": ["Dashboard Settings"],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/DashboardSettingResult"
                                }
                            }
                        }
                    }
                }
            },
            "put": {
                "tags": ["Dashboard Settings"],
                "requestBody": {
                    "content": {
                        "application/json": {
                            "schema": {
                                "$ref": "#/components/schemas/DashboardSettingUpdateRequest"
                            }
                        }
                    },
                    "required": true
                },
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/DashboardSettingResult"
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/documentation": {
            "get": {
                "tags": ["Documentation"],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "type": "array",
                                    "items": {
                                        "$ref": "#/components/schemas/DocumentationSectionResult"
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/documentation/roles/{roleCode}": {
            "get": {
                "tags": ["Documentation"],
                "parameters": [
                    {
                        "name": "roleCode",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "type": "array",
                                    "items": {
                                        "$ref": "#/components/schemas/DocumentationSectionResult"
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/documentation/roles/{roleCode}/sections": {
            "post": {
                "tags": ["Documentation"],
                "parameters": [
                    {
                        "name": "roleCode",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string"
                        }
                    }
                ],
                "requestBody": {
                    "content": {
                        "application/json": {
                            "schema": {
                                "$ref": "#/components/schemas/DocumentationSectionCreateRequest"
                            }
                        }
                    },
                    "required": true
                },
                "responses": {
                    "201": {
                        "description": "Created",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/DocumentationSectionResult"
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/documentation/sections/{id}": {
            "put": {
                "tags": ["Documentation"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "requestBody": {
                    "content": {
                        "application/json": {
                            "schema": {
                                "$ref": "#/components/schemas/DocumentationSectionUpdateRequest"
                            }
                        }
                    },
                    "required": true
                },
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/DocumentationSectionResult"
                                }
                            }
                        }
                    }
                }
            },
            "delete": {
                "tags": ["Documentation"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "204": {
                        "description": "No Content"
                    }
                }
            }
        },
        "/api/v1/documentation/roles/{roleCode}/reorder": {
            "put": {
                "tags": ["Documentation"],
                "parameters": [
                    {
                        "name": "roleCode",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string"
                        }
                    }
                ],
                "requestBody": {
                    "content": {
                        "application/json": {
                            "schema": {
                                "$ref": "#/components/schemas/DocumentationSectionReorderRequest"
                            }
                        }
                    },
                    "required": true
                },
                "responses": {
                    "204": {
                        "description": "No Content"
                    }
                }
            }
        },
        "/api/v1/lga-documents": {
            "get": {
                "tags": ["LGA Documents"],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/LoadResult"
                                }
                            }
                        }
                    }
                }
            },
            "post": {
                "tags": ["LGA Documents"],
                "requestBody": {
                    "content": {
                        "application/json": {
                            "schema": {
                                "$ref": "#/components/schemas/LgaDocumentCreateRequest"
                            }
                        }
                    },
                    "required": true
                },
                "responses": {
                    "201": {
                        "description": "Created",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/LgaDocumentResult"
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/lga-documents/list": {
            "get": {
                "tags": ["LGA Documents"],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "type": "array",
                                    "items": {
                                        "$ref": "#/components/schemas/LgaDocumentListDto"
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/lga-documents/{id}": {
            "get": {
                "tags": ["LGA Documents"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/LgaDocumentResult"
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            },
            "put": {
                "tags": ["LGA Documents"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "requestBody": {
                    "content": {
                        "application/json": {
                            "schema": {
                                "$ref": "#/components/schemas/LgaDocumentUpdateRequest"
                            }
                        }
                    },
                    "required": true
                },
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/LgaDocumentResult"
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            },
            "delete": {
                "tags": ["LGA Documents"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "204": {
                        "description": "No Content"
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            }
        },
        "/api/v1/lga-documents/{lgaDocId}/line-items": {
            "get": {
                "tags": ["LGA Documents"],
                "parameters": [
                    {
                        "name": "lgaDocId",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "type": "array",
                                    "items": {
                                        "$ref": "#/components/schemas/LgaLineItemResult"
                                    }
                                }
                            }
                        }
                    }
                }
            },
            "post": {
                "tags": ["LGA Documents"],
                "parameters": [
                    {
                        "name": "lgaDocId",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "requestBody": {
                    "content": {
                        "application/json": {
                            "schema": {
                                "$ref": "#/components/schemas/LgaLineItemRequest"
                            }
                        }
                    },
                    "required": true
                },
                "responses": {
                    "201": {
                        "description": "Created",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/LgaLineItemResult"
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/lga-documents/{lgaDocId}/line-items/{itemId}": {
            "get": {
                "tags": ["LGA Documents"],
                "parameters": [
                    {
                        "name": "lgaDocId",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    },
                    {
                        "name": "itemId",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/LgaLineItemResult"
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            },
            "put": {
                "tags": ["LGA Documents"],
                "parameters": [
                    {
                        "name": "lgaDocId",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    },
                    {
                        "name": "itemId",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "requestBody": {
                    "content": {
                        "application/json": {
                            "schema": {
                                "$ref": "#/components/schemas/LgaLineItemRequest"
                            }
                        }
                    },
                    "required": true
                },
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/LgaLineItemResult"
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            },
            "delete": {
                "tags": ["LGA Documents"],
                "parameters": [
                    {
                        "name": "lgaDocId",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    },
                    {
                        "name": "itemId",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "204": {
                        "description": "No Content"
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            }
        },
        "/api/v1/lga-documents/{lgaDocId}/route/segments": {
            "get": {
                "tags": ["LGA Documents"],
                "parameters": [
                    {
                        "name": "lgaDocId",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "type": "array",
                                    "items": {
                                        "$ref": "#/components/schemas/RouteSegmentResult"
                                    }
                                }
                            }
                        }
                    }
                }
            },
            "post": {
                "tags": ["LGA Documents"],
                "parameters": [
                    {
                        "name": "lgaDocId",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "requestBody": {
                    "content": {
                        "application/json": {
                            "schema": {
                                "$ref": "#/components/schemas/RouteSegmentCreateRequest"
                            }
                        }
                    },
                    "required": true
                },
                "responses": {
                    "201": {
                        "description": "Created",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/RouteSegmentResult"
                                }
                            }
                        }
                    },
                    "400": {
                        "description": "Bad Request"
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            }
        },
        "/api/v1/lga-documents/{lgaDocId}/route/segments/{segId}": {
            "put": {
                "tags": ["LGA Documents"],
                "parameters": [
                    {
                        "name": "lgaDocId",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    },
                    {
                        "name": "segId",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "requestBody": {
                    "content": {
                        "application/json": {
                            "schema": {
                                "$ref": "#/components/schemas/RouteSegmentUpdateRequest"
                            }
                        }
                    },
                    "required": true
                },
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/RouteSegmentResult"
                                }
                            }
                        }
                    },
                    "400": {
                        "description": "Bad Request"
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            },
            "delete": {
                "tags": ["LGA Documents"],
                "parameters": [
                    {
                        "name": "lgaDocId",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    },
                    {
                        "name": "segId",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "204": {
                        "description": "No Content"
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            }
        },
        "/api/v1/lga-documents/{lgaDocId}/route/segments/reorder": {
            "put": {
                "tags": ["LGA Documents"],
                "parameters": [
                    {
                        "name": "lgaDocId",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "requestBody": {
                    "content": {
                        "application/json": {
                            "schema": {
                                "$ref": "#/components/schemas/RouteSegmentReorderRequest"
                            }
                        }
                    },
                    "required": true
                },
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "type": "array",
                                    "items": {
                                        "$ref": "#/components/schemas/RouteSegmentResult"
                                    }
                                }
                            }
                        }
                    },
                    "400": {
                        "description": "Bad Request"
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            }
        },
        "/api/v1/lga-documents/{lgaDocId}/route/map": {
            "get": {
                "tags": ["LGA Documents"],
                "parameters": [
                    {
                        "name": "lgaDocId",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/RouteMapResult"
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/lga-documents/{lgaDocId}/tracking": {
            "get": {
                "tags": ["LGA Documents"],
                "parameters": [
                    {
                        "name": "lgaDocId",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/ShipmentTrackingResult"
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            },
            "post": {
                "tags": ["LGA Documents"],
                "parameters": [
                    {
                        "name": "lgaDocId",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "requestBody": {
                    "content": {
                        "multipart/form-data": {
                            "schema": {
                                "required": ["request"],
                                "type": "object",
                                "properties": {
                                    "request": {
                                        "$ref": "#/components/schemas/LgaLocationScanRequest"
                                    }
                                }
                            },
                            "encoding": {
                                "request": {
                                    "style": "form"
                                }
                            }
                        }
                    }
                },
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/ShipmentLocationResult"
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            }
        },
        "/api/v1/lga-documents/{lgaDocId}/changelog": {
            "get": {
                "tags": ["LGA Documents"],
                "parameters": [
                    {
                        "name": "lgaDocId",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "type": "array",
                                    "items": {
                                        "$ref": "#/components/schemas/RouteChangeLogResult"
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/lga-documents/{lgaDocId}/attachments": {
            "get": {
                "tags": ["LGA Documents"],
                "parameters": [
                    {
                        "name": "lgaDocId",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "type": "array",
                                    "items": {
                                        "$ref": "#/components/schemas/LgaDocumentAttachmentResult"
                                    }
                                }
                            }
                        }
                    }
                }
            },
            "post": {
                "tags": ["LGA Documents"],
                "parameters": [
                    {
                        "name": "lgaDocId",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "requestBody": {
                    "content": {
                        "multipart/form-data": {
                            "schema": {
                                "required": ["file"],
                                "type": "object",
                                "properties": {
                                    "file": {
                                        "type": "string",
                                        "format": "binary"
                                    },
                                    "caption": {
                                        "type": "string"
                                    },
                                    "kind": {
                                        "type": "string"
                                    },
                                    "documentTypeId": {
                                        "type": "string",
                                        "format": "uuid"
                                    }
                                }
                            },
                            "encoding": {
                                "file": {
                                    "style": "form"
                                },
                                "caption": {
                                    "style": "form"
                                },
                                "kind": {
                                    "style": "form"
                                },
                                "documentTypeId": {
                                    "style": "form"
                                }
                            }
                        }
                    }
                },
                "responses": {
                    "201": {
                        "description": "Created",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/LgaDocumentAttachmentResult"
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/lga-documents/{lgaDocId}/attachments/{attachmentId}/download": {
            "get": {
                "tags": ["LGA Documents"],
                "parameters": [
                    {
                        "name": "lgaDocId",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    },
                    {
                        "name": "attachmentId",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK"
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            }
        },
        "/api/v1/lga-documents/{lgaDocId}/attachments/{attachmentId}": {
            "delete": {
                "tags": ["LGA Documents"],
                "parameters": [
                    {
                        "name": "lgaDocId",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    },
                    {
                        "name": "attachmentId",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "204": {
                        "description": "No Content"
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            }
        },
        "/api/v1/lookups/vendors": {
            "get": {
                "tags": ["Lookups"],
                "parameters": [
                    {
                        "name": "activeOnly",
                        "in": "query",
                        "schema": {
                            "type": "boolean"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "type": "array",
                                    "items": {
                                        "$ref": "#/components/schemas/VendorLookupResult"
                                    }
                                }
                            }
                        }
                    }
                }
            },
            "post": {
                "tags": ["Lookups"],
                "requestBody": {
                    "content": {
                        "application/json": {
                            "schema": {
                                "$ref": "#/components/schemas/VendorCreateRequest"
                            }
                        }
                    },
                    "required": true
                },
                "responses": {
                    "201": {
                        "description": "Created",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/VendorLookupResult"
                                }
                            }
                        }
                    },
                    "400": {
                        "description": "Bad Request",
                        "content": {
                            "application/problem+json": {
                                "schema": {
                                    "$ref": "#/components/schemas/HttpValidationProblemDetails"
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/lookups/vendors/search": {
            "get": {
                "tags": ["Lookups"],
                "parameters": [
                    {
                        "name": "searchTerm",
                        "in": "query",
                        "schema": {
                            "type": "string"
                        }
                    },
                    {
                        "name": "skip",
                        "in": "query",
                        "schema": {
                            "type": "integer",
                            "format": "int32"
                        }
                    },
                    {
                        "name": "take",
                        "in": "query",
                        "schema": {
                            "type": "integer",
                            "format": "int32"
                        }
                    },
                    {
                        "name": "activeOnly",
                        "in": "query",
                        "schema": {
                            "type": "boolean"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/VendorLookupResultPagedLookupResult"
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/lookups/vendors/{id}": {
            "get": {
                "tags": ["Lookups"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/VendorLookupResult"
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            },
            "put": {
                "tags": ["Lookups"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "requestBody": {
                    "content": {
                        "application/json": {
                            "schema": {
                                "$ref": "#/components/schemas/VendorUpdateRequest"
                            }
                        }
                    },
                    "required": true
                },
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/VendorLookupResult"
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            },
            "delete": {
                "tags": ["Lookups"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "204": {
                        "description": "No Content"
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            }
        },
        "/api/v1/lookups/vessels": {
            "get": {
                "tags": ["Lookups"],
                "parameters": [
                    {
                        "name": "activeOnly",
                        "in": "query",
                        "schema": {
                            "type": "boolean"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "type": "array",
                                    "items": {
                                        "$ref": "#/components/schemas/VesselLookupResult"
                                    }
                                }
                            }
                        }
                    }
                }
            },
            "post": {
                "tags": ["Lookups"],
                "requestBody": {
                    "content": {
                        "application/json": {
                            "schema": {
                                "$ref": "#/components/schemas/VesselCreateRequest"
                            }
                        }
                    },
                    "required": true
                },
                "responses": {
                    "201": {
                        "description": "Created",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/VesselLookupResult"
                                }
                            }
                        }
                    },
                    "400": {
                        "description": "Bad Request",
                        "content": {
                            "application/problem+json": {
                                "schema": {
                                    "$ref": "#/components/schemas/HttpValidationProblemDetails"
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/lookups/vessels/search": {
            "get": {
                "tags": ["Lookups"],
                "parameters": [
                    {
                        "name": "searchTerm",
                        "in": "query",
                        "schema": {
                            "type": "string"
                        }
                    },
                    {
                        "name": "skip",
                        "in": "query",
                        "schema": {
                            "type": "integer",
                            "format": "int32"
                        }
                    },
                    {
                        "name": "take",
                        "in": "query",
                        "schema": {
                            "type": "integer",
                            "format": "int32"
                        }
                    },
                    {
                        "name": "activeOnly",
                        "in": "query",
                        "schema": {
                            "type": "boolean"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/VesselLookupResultPagedLookupResult"
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/lookups/vessels/{id}": {
            "get": {
                "tags": ["Lookups"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/VesselLookupResult"
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            },
            "put": {
                "tags": ["Lookups"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "requestBody": {
                    "content": {
                        "application/json": {
                            "schema": {
                                "$ref": "#/components/schemas/VesselUpdateRequest"
                            }
                        }
                    },
                    "required": true
                },
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/VesselLookupResult"
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            },
            "delete": {
                "tags": ["Lookups"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "204": {
                        "description": "No Content"
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            }
        },
        "/api/v1/lookups/countries": {
            "get": {
                "tags": ["Lookups"],
                "parameters": [
                    {
                        "name": "activeOnly",
                        "in": "query",
                        "schema": {
                            "type": "boolean"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "type": "array",
                                    "items": {
                                        "$ref": "#/components/schemas/CountryLookupResult"
                                    }
                                }
                            }
                        }
                    }
                }
            },
            "post": {
                "tags": ["Lookups"],
                "requestBody": {
                    "content": {
                        "application/json": {
                            "schema": {
                                "$ref": "#/components/schemas/CountryCreateRequest"
                            }
                        }
                    },
                    "required": true
                },
                "responses": {
                    "201": {
                        "description": "Created",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/CountryLookupResult"
                                }
                            }
                        }
                    },
                    "400": {
                        "description": "Bad Request",
                        "content": {
                            "application/problem+json": {
                                "schema": {
                                    "$ref": "#/components/schemas/HttpValidationProblemDetails"
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/lookups/countries/{id}": {
            "get": {
                "tags": ["Lookups"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/CountryLookupResult"
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            },
            "put": {
                "tags": ["Lookups"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "requestBody": {
                    "content": {
                        "application/json": {
                            "schema": {
                                "$ref": "#/components/schemas/CountryUpdateRequest"
                            }
                        }
                    },
                    "required": true
                },
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/CountryLookupResult"
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            },
            "delete": {
                "tags": ["Lookups"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "204": {
                        "description": "No Content"
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            }
        },
        "/api/v1/lookups/localities": {
            "get": {
                "tags": ["Lookups"],
                "parameters": [
                    {
                        "name": "countryId",
                        "in": "query",
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    },
                    {
                        "name": "activeOnly",
                        "in": "query",
                        "schema": {
                            "type": "boolean"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "type": "array",
                                    "items": {
                                        "$ref": "#/components/schemas/LocalityLookupResult"
                                    }
                                }
                            }
                        }
                    }
                }
            },
            "post": {
                "tags": ["Lookups"],
                "requestBody": {
                    "content": {
                        "application/json": {
                            "schema": {
                                "$ref": "#/components/schemas/LocalityCreateRequest"
                            }
                        }
                    },
                    "required": true
                },
                "responses": {
                    "201": {
                        "description": "Created",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/LocalityLookupResult"
                                }
                            }
                        }
                    },
                    "400": {
                        "description": "Bad Request",
                        "content": {
                            "application/problem+json": {
                                "schema": {
                                    "$ref": "#/components/schemas/HttpValidationProblemDetails"
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/lookups/localities/{id}": {
            "get": {
                "tags": ["Lookups"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/LocalityLookupResult"
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            },
            "put": {
                "tags": ["Lookups"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "requestBody": {
                    "content": {
                        "application/json": {
                            "schema": {
                                "$ref": "#/components/schemas/LocalityUpdateRequest"
                            }
                        }
                    },
                    "required": true
                },
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/LocalityLookupResult"
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            },
            "delete": {
                "tags": ["Lookups"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "204": {
                        "description": "No Content"
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            }
        },
        "/api/v1/lookups/statuses": {
            "get": {
                "tags": ["Lookups"],
                "parameters": [
                    {
                        "name": "activeOnly",
                        "in": "query",
                        "schema": {
                            "type": "boolean"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "type": "array",
                                    "items": {
                                        "$ref": "#/components/schemas/StatusLookupResult"
                                    }
                                }
                            }
                        }
                    }
                }
            },
            "post": {
                "tags": ["Lookups"],
                "requestBody": {
                    "content": {
                        "application/json": {
                            "schema": {
                                "$ref": "#/components/schemas/StatusCreateRequest"
                            }
                        }
                    },
                    "required": true
                },
                "responses": {
                    "201": {
                        "description": "Created",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/StatusLookupResult"
                                }
                            }
                        }
                    },
                    "400": {
                        "description": "Bad Request",
                        "content": {
                            "application/problem+json": {
                                "schema": {
                                    "$ref": "#/components/schemas/HttpValidationProblemDetails"
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/lookups/statuses/{id}": {
            "get": {
                "tags": ["Lookups"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/StatusLookupResult"
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            },
            "put": {
                "tags": ["Lookups"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "requestBody": {
                    "content": {
                        "application/json": {
                            "schema": {
                                "$ref": "#/components/schemas/StatusUpdateRequest"
                            }
                        }
                    },
                    "required": true
                },
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/StatusLookupResult"
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            },
            "delete": {
                "tags": ["Lookups"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "204": {
                        "description": "No Content"
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            }
        },
        "/api/v1/lookups/statuses/visibility": {
            "get": {
                "tags": ["Lookups"],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/StatusVisibilityMatrixResult"
                                }
                            }
                        }
                    }
                }
            },
            "put": {
                "tags": ["Lookups"],
                "requestBody": {
                    "content": {
                        "application/json": {
                            "schema": {
                                "$ref": "#/components/schemas/StatusVisibilityUpdateRequest"
                            }
                        }
                    },
                    "required": true
                },
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/StatusVisibilityMatrixResult"
                                }
                            }
                        }
                    },
                    "400": {
                        "description": "Bad Request",
                        "content": {
                            "application/problem+json": {
                                "schema": {
                                    "$ref": "#/components/schemas/HttpValidationProblemDetails"
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/lookups/status-options": {
            "get": {
                "tags": ["Lookups"],
                "parameters": [
                    {
                        "name": "activeOnly",
                        "in": "query",
                        "schema": {
                            "type": "boolean"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "type": "array",
                                    "items": {
                                        "$ref": "#/components/schemas/StatusOptionLookupResult"
                                    }
                                }
                            }
                        }
                    }
                }
            },
            "post": {
                "tags": ["Lookups"],
                "requestBody": {
                    "content": {
                        "application/json": {
                            "schema": {
                                "$ref": "#/components/schemas/StatusOptionCreateRequest"
                            }
                        }
                    },
                    "required": true
                },
                "responses": {
                    "201": {
                        "description": "Created",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/StatusOptionLookupResult"
                                }
                            }
                        }
                    },
                    "400": {
                        "description": "Bad Request",
                        "content": {
                            "application/problem+json": {
                                "schema": {
                                    "$ref": "#/components/schemas/HttpValidationProblemDetails"
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/lookups/status-options/{id}": {
            "get": {
                "tags": ["Lookups"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/StatusOptionLookupResult"
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            },
            "put": {
                "tags": ["Lookups"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "requestBody": {
                    "content": {
                        "application/json": {
                            "schema": {
                                "$ref": "#/components/schemas/StatusOptionUpdateRequest"
                            }
                        }
                    },
                    "required": true
                },
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/StatusOptionLookupResult"
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            },
            "delete": {
                "tags": ["Lookups"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "204": {
                        "description": "No Content"
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            }
        },
        "/api/v1/lookups/warehouses": {
            "get": {
                "tags": ["Lookups"],
                "parameters": [
                    {
                        "name": "activeOnly",
                        "in": "query",
                        "schema": {
                            "type": "boolean"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "type": "array",
                                    "items": {
                                        "$ref": "#/components/schemas/WarehouseLookupResult"
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/lookups/warehouses/search": {
            "get": {
                "tags": ["Lookups"],
                "parameters": [
                    {
                        "name": "searchTerm",
                        "in": "query",
                        "schema": {
                            "type": "string"
                        }
                    },
                    {
                        "name": "skip",
                        "in": "query",
                        "schema": {
                            "type": "integer",
                            "format": "int32"
                        }
                    },
                    {
                        "name": "take",
                        "in": "query",
                        "schema": {
                            "type": "integer",
                            "format": "int32"
                        }
                    },
                    {
                        "name": "activeOnly",
                        "in": "query",
                        "schema": {
                            "type": "boolean"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/WarehouseLookupResultPagedLookupResult"
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/lookups/port-agents": {
            "get": {
                "tags": ["Lookups"],
                "parameters": [
                    {
                        "name": "activeOnly",
                        "in": "query",
                        "schema": {
                            "type": "boolean"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "type": "array",
                                    "items": {
                                        "$ref": "#/components/schemas/PortAgentLookupResult"
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/lookups/port-agents/search": {
            "get": {
                "tags": ["Lookups"],
                "parameters": [
                    {
                        "name": "searchTerm",
                        "in": "query",
                        "schema": {
                            "type": "string"
                        }
                    },
                    {
                        "name": "skip",
                        "in": "query",
                        "schema": {
                            "type": "integer",
                            "format": "int32"
                        }
                    },
                    {
                        "name": "take",
                        "in": "query",
                        "schema": {
                            "type": "integer",
                            "format": "int32"
                        }
                    },
                    {
                        "name": "activeOnly",
                        "in": "query",
                        "schema": {
                            "type": "boolean"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/PortAgentLookupResultPagedLookupResult"
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/lookups/sources": {
            "get": {
                "tags": ["Lookups"],
                "parameters": [
                    {
                        "name": "activeOnly",
                        "in": "query",
                        "schema": {
                            "type": "boolean"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "type": "array",
                                    "items": {
                                        "$ref": "#/components/schemas/SourceLookupResult"
                                    }
                                }
                            }
                        }
                    }
                }
            },
            "post": {
                "tags": ["Lookups"],
                "requestBody": {
                    "content": {
                        "application/json": {
                            "schema": {
                                "$ref": "#/components/schemas/SourceCreateRequest"
                            }
                        }
                    },
                    "required": true
                },
                "responses": {
                    "201": {
                        "description": "Created",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/SourceLookupResult"
                                }
                            }
                        }
                    },
                    "400": {
                        "description": "Bad Request",
                        "content": {
                            "application/problem+json": {
                                "schema": {
                                    "$ref": "#/components/schemas/HttpValidationProblemDetails"
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/lookups/sources/{id}": {
            "get": {
                "tags": ["Lookups"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/SourceLookupResult"
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            },
            "put": {
                "tags": ["Lookups"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "requestBody": {
                    "content": {
                        "application/json": {
                            "schema": {
                                "$ref": "#/components/schemas/SourceUpdateRequest"
                            }
                        }
                    },
                    "required": true
                },
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/SourceLookupResult"
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            },
            "delete": {
                "tags": ["Lookups"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "204": {
                        "description": "No Content"
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            }
        },
        "/api/v1/lookups/transport-types": {
            "get": {
                "tags": ["Lookups"],
                "parameters": [
                    {
                        "name": "activeOnly",
                        "in": "query",
                        "schema": {
                            "type": "boolean"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "type": "array",
                                    "items": {
                                        "$ref": "#/components/schemas/TransportTypeLookupResult"
                                    }
                                }
                            }
                        }
                    }
                }
            },
            "post": {
                "tags": ["Lookups"],
                "requestBody": {
                    "content": {
                        "application/json": {
                            "schema": {
                                "$ref": "#/components/schemas/TransportTypeCreateRequest"
                            }
                        }
                    },
                    "required": true
                },
                "responses": {
                    "201": {
                        "description": "Created",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/TransportTypeLookupResult"
                                }
                            }
                        }
                    },
                    "400": {
                        "description": "Bad Request",
                        "content": {
                            "application/problem+json": {
                                "schema": {
                                    "$ref": "#/components/schemas/HttpValidationProblemDetails"
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/lookups/transport-types/{id}": {
            "get": {
                "tags": ["Lookups"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/TransportTypeLookupResult"
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            },
            "put": {
                "tags": ["Lookups"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "requestBody": {
                    "content": {
                        "application/json": {
                            "schema": {
                                "$ref": "#/components/schemas/TransportTypeUpdateRequest"
                            }
                        }
                    },
                    "required": true
                },
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/TransportTypeLookupResult"
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            },
            "delete": {
                "tags": ["Lookups"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "204": {
                        "description": "No Content"
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            }
        },
        "/api/v1/lookups/step-types": {
            "get": {
                "tags": ["Lookups"],
                "parameters": [
                    {
                        "name": "activeOnly",
                        "in": "query",
                        "schema": {
                            "type": "boolean"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "type": "array",
                                    "items": {
                                        "$ref": "#/components/schemas/StepTypeLookupResult"
                                    }
                                }
                            }
                        }
                    }
                }
            },
            "post": {
                "tags": ["Lookups"],
                "requestBody": {
                    "content": {
                        "application/json": {
                            "schema": {
                                "$ref": "#/components/schemas/StepTypeCreateRequest"
                            }
                        }
                    },
                    "required": true
                },
                "responses": {
                    "201": {
                        "description": "Created",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/StepTypeLookupResult"
                                }
                            }
                        }
                    },
                    "400": {
                        "description": "Bad Request",
                        "content": {
                            "application/problem+json": {
                                "schema": {
                                    "$ref": "#/components/schemas/HttpValidationProblemDetails"
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/lookups/step-types/{id}": {
            "get": {
                "tags": ["Lookups"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/StepTypeLookupResult"
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            },
            "put": {
                "tags": ["Lookups"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "requestBody": {
                    "content": {
                        "application/json": {
                            "schema": {
                                "$ref": "#/components/schemas/StepTypeUpdateRequest"
                            }
                        }
                    },
                    "required": true
                },
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/StepTypeLookupResult"
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            },
            "delete": {
                "tags": ["Lookups"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "204": {
                        "description": "No Content"
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            }
        },
        "/api/v1/lookups/picture-types": {
            "get": {
                "tags": ["Lookups"],
                "parameters": [
                    {
                        "name": "activeOnly",
                        "in": "query",
                        "schema": {
                            "type": "boolean"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "type": "array",
                                    "items": {
                                        "$ref": "#/components/schemas/PictureTypeLookupResult"
                                    }
                                }
                            }
                        }
                    }
                }
            },
            "post": {
                "tags": ["Lookups"],
                "requestBody": {
                    "content": {
                        "application/json": {
                            "schema": {
                                "$ref": "#/components/schemas/PictureTypeCreateRequest"
                            }
                        }
                    },
                    "required": true
                },
                "responses": {
                    "201": {
                        "description": "Created",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/PictureTypeLookupResult"
                                }
                            }
                        }
                    },
                    "400": {
                        "description": "Bad Request",
                        "content": {
                            "application/problem+json": {
                                "schema": {
                                    "$ref": "#/components/schemas/HttpValidationProblemDetails"
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/lookups/picture-types/{id}": {
            "get": {
                "tags": ["Lookups"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/PictureTypeLookupResult"
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            },
            "put": {
                "tags": ["Lookups"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "requestBody": {
                    "content": {
                        "application/json": {
                            "schema": {
                                "$ref": "#/components/schemas/PictureTypeUpdateRequest"
                            }
                        }
                    },
                    "required": true
                },
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/PictureTypeLookupResult"
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            },
            "delete": {
                "tags": ["Lookups"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "204": {
                        "description": "No Content"
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            }
        },
        "/api/v1/lookups/document-types": {
            "get": {
                "tags": ["Lookups"],
                "parameters": [
                    {
                        "name": "activeOnly",
                        "in": "query",
                        "schema": {
                            "type": "boolean"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "type": "array",
                                    "items": {
                                        "$ref": "#/components/schemas/DocumentTypeLookupResult"
                                    }
                                }
                            }
                        }
                    }
                }
            },
            "post": {
                "tags": ["Lookups"],
                "requestBody": {
                    "content": {
                        "application/json": {
                            "schema": {
                                "$ref": "#/components/schemas/DocumentTypeCreateRequest"
                            }
                        }
                    },
                    "required": true
                },
                "responses": {
                    "201": {
                        "description": "Created",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/DocumentTypeLookupResult"
                                }
                            }
                        }
                    },
                    "400": {
                        "description": "Bad Request",
                        "content": {
                            "application/problem+json": {
                                "schema": {
                                    "$ref": "#/components/schemas/HttpValidationProblemDetails"
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/lookups/document-types/{id}": {
            "get": {
                "tags": ["Lookups"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/DocumentTypeLookupResult"
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            },
            "put": {
                "tags": ["Lookups"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "requestBody": {
                    "content": {
                        "application/json": {
                            "schema": {
                                "$ref": "#/components/schemas/DocumentTypeUpdateRequest"
                            }
                        }
                    },
                    "required": true
                },
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/DocumentTypeLookupResult"
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            },
            "delete": {
                "tags": ["Lookups"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "204": {
                        "description": "No Content"
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            }
        },
        "/api/v1/lookups/hazmat": {
            "get": {
                "tags": ["Lookups"],
                "parameters": [
                    {
                        "name": "activeOnly",
                        "in": "query",
                        "schema": {
                            "type": "boolean"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "type": "array",
                                    "items": {
                                        "$ref": "#/components/schemas/HazmatTypeLookupResult"
                                    }
                                }
                            }
                        }
                    }
                }
            },
            "post": {
                "tags": ["Lookups"],
                "requestBody": {
                    "content": {
                        "application/json": {
                            "schema": {
                                "$ref": "#/components/schemas/HazmatCreateRequest"
                            }
                        }
                    },
                    "required": true
                },
                "responses": {
                    "201": {
                        "description": "Created",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/HazmatTypeLookupResult"
                                }
                            }
                        }
                    },
                    "400": {
                        "description": "Bad Request",
                        "content": {
                            "application/problem+json": {
                                "schema": {
                                    "$ref": "#/components/schemas/HttpValidationProblemDetails"
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/lookups/hazmat/{id}": {
            "get": {
                "tags": ["Lookups"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/HazmatTypeLookupResult"
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            },
            "put": {
                "tags": ["Lookups"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "requestBody": {
                    "content": {
                        "application/json": {
                            "schema": {
                                "$ref": "#/components/schemas/HazmatUpdateRequest"
                            }
                        }
                    },
                    "required": true
                },
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/HazmatTypeLookupResult"
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            },
            "delete": {
                "tags": ["Lookups"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "204": {
                        "description": "No Content"
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            }
        },
        "/api/v1/lookups/value-currency": {
            "get": {
                "tags": ["Lookups"],
                "parameters": [
                    {
                        "name": "activeOnly",
                        "in": "query",
                        "schema": {
                            "type": "boolean"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "type": "array",
                                    "items": {
                                        "$ref": "#/components/schemas/ValueCurrencyTypeLookupResult"
                                    }
                                }
                            }
                        }
                    }
                }
            },
            "post": {
                "tags": ["Lookups"],
                "requestBody": {
                    "content": {
                        "application/json": {
                            "schema": {
                                "$ref": "#/components/schemas/ValueCurrencyCreateRequest"
                            }
                        }
                    },
                    "required": true
                },
                "responses": {
                    "201": {
                        "description": "Created",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/ValueCurrencyTypeLookupResult"
                                }
                            }
                        }
                    },
                    "400": {
                        "description": "Bad Request",
                        "content": {
                            "application/problem+json": {
                                "schema": {
                                    "$ref": "#/components/schemas/HttpValidationProblemDetails"
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/lookups/value-currency/{id}": {
            "get": {
                "tags": ["Lookups"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/ValueCurrencyTypeLookupResult"
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            },
            "put": {
                "tags": ["Lookups"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "requestBody": {
                    "content": {
                        "application/json": {
                            "schema": {
                                "$ref": "#/components/schemas/ValueCurrencyUpdateRequest"
                            }
                        }
                    },
                    "required": true
                },
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/ValueCurrencyTypeLookupResult"
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            },
            "delete": {
                "tags": ["Lookups"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "204": {
                        "description": "No Content"
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            }
        },
        "/api/v1/lookups/lga-shipping-method": {
            "get": {
                "tags": ["Lookups"],
                "parameters": [
                    {
                        "name": "activeOnly",
                        "in": "query",
                        "schema": {
                            "type": "boolean"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "type": "array",
                                    "items": {
                                        "$ref": "#/components/schemas/LgaShippingMethodTypeLookupResult"
                                    }
                                }
                            }
                        }
                    }
                }
            },
            "post": {
                "tags": ["Lookups"],
                "requestBody": {
                    "content": {
                        "application/json": {
                            "schema": {
                                "$ref": "#/components/schemas/LgaShippingMethodCreateRequest"
                            }
                        }
                    },
                    "required": true
                },
                "responses": {
                    "201": {
                        "description": "Created",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/LgaShippingMethodTypeLookupResult"
                                }
                            }
                        }
                    },
                    "400": {
                        "description": "Bad Request",
                        "content": {
                            "application/problem+json": {
                                "schema": {
                                    "$ref": "#/components/schemas/HttpValidationProblemDetails"
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/lookups/lga-shipping-method/{id}": {
            "get": {
                "tags": ["Lookups"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/LgaShippingMethodTypeLookupResult"
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            },
            "put": {
                "tags": ["Lookups"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "requestBody": {
                    "content": {
                        "application/json": {
                            "schema": {
                                "$ref": "#/components/schemas/LgaShippingMethodUpdateRequest"
                            }
                        }
                    },
                    "required": true
                },
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/LgaShippingMethodTypeLookupResult"
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            },
            "delete": {
                "tags": ["Lookups"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "204": {
                        "description": "No Content"
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            }
        },
        "/api/v1/lookups/lga-reason-for-landing": {
            "get": {
                "tags": ["Lookups"],
                "parameters": [
                    {
                        "name": "activeOnly",
                        "in": "query",
                        "schema": {
                            "type": "boolean"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "type": "array",
                                    "items": {
                                        "$ref": "#/components/schemas/LgaReasonsTypeLookupResult"
                                    }
                                }
                            }
                        }
                    }
                }
            },
            "post": {
                "tags": ["Lookups"],
                "requestBody": {
                    "content": {
                        "application/json": {
                            "schema": {
                                "$ref": "#/components/schemas/LgaReasonForLandingCreateRequest"
                            }
                        }
                    },
                    "required": true
                },
                "responses": {
                    "201": {
                        "description": "Created",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/LgaReasonsTypeLookupResult"
                                }
                            }
                        }
                    },
                    "400": {
                        "description": "Bad Request",
                        "content": {
                            "application/problem+json": {
                                "schema": {
                                    "$ref": "#/components/schemas/HttpValidationProblemDetails"
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/lookups/lga-reason-for-landing/{id}": {
            "get": {
                "tags": ["Lookups"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/LgaReasonsTypeLookupResult"
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            },
            "put": {
                "tags": ["Lookups"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "requestBody": {
                    "content": {
                        "application/json": {
                            "schema": {
                                "$ref": "#/components/schemas/LgaReasonForLandingUpdateRequest"
                            }
                        }
                    },
                    "required": true
                },
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/LgaReasonsTypeLookupResult"
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            },
            "delete": {
                "tags": ["Lookups"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "204": {
                        "description": "No Content"
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            }
        },
        "/api/v1/lookups/pending-confirmation-statuses": {
            "get": {
                "tags": ["Lookups"],
                "parameters": [
                    {
                        "name": "activeOnly",
                        "in": "query",
                        "schema": {
                            "type": "boolean"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "type": "array",
                                    "items": {
                                        "$ref": "#/components/schemas/PendingConfirmationStatusLookupResult"
                                    }
                                }
                            }
                        }
                    }
                }
            },
            "post": {
                "tags": ["Lookups"],
                "requestBody": {
                    "content": {
                        "application/json": {
                            "schema": {
                                "$ref": "#/components/schemas/PendingConfirmationStatusCreateRequest"
                            }
                        }
                    },
                    "required": true
                },
                "responses": {
                    "201": {
                        "description": "Created",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/PendingConfirmationStatusLookupResult"
                                }
                            }
                        }
                    },
                    "400": {
                        "description": "Bad Request",
                        "content": {
                            "application/problem+json": {
                                "schema": {
                                    "$ref": "#/components/schemas/HttpValidationProblemDetails"
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/lookups/pending-confirmation-statuses/{id}": {
            "get": {
                "tags": ["Lookups"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/PendingConfirmationStatusLookupResult"
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            },
            "put": {
                "tags": ["Lookups"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "requestBody": {
                    "content": {
                        "application/json": {
                            "schema": {
                                "$ref": "#/components/schemas/PendingConfirmationStatusUpdateRequest"
                            }
                        }
                    },
                    "required": true
                },
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/PendingConfirmationStatusLookupResult"
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            },
            "delete": {
                "tags": ["Lookups"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "204": {
                        "description": "No Content"
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            }
        },
        "/api/v1/mock-data/generate": {
            "post": {
                "tags": ["Mock Data"],
                "summary": "Generate mock data",
                "description": "Generates comprehensive mock data for development and testing. **Admin only**. Use with caution - can clear existing data if ClearExistingData is true.",
                "operationId": "GenerateMockData",
                "requestBody": {
                    "content": {
                        "application/json": {
                            "schema": {
                                "$ref": "#/components/schemas/MockDataGenerationOptions"
                            }
                        }
                    },
                    "required": true
                },
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/MockDataGenerationResult"
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/mock-data/generate/quick": {
            "post": {
                "tags": ["Mock Data"],
                "summary": "Generate quick mock data",
                "description": "Generates a small set of mock data for quick testing. **Admin only**. Preset values: 20 users, 50 shipments, 100 QR codes, 15 purchase orders, 5 pending confirmations.",
                "operationId": "GenerateQuickMockData",
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/MockDataGenerationResult"
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/mock-data/generate/full": {
            "post": {
                "tags": ["Mock Data"],
                "summary": "Generate full mock data",
                "description": "Generates a comprehensive set of mock data for performance testing. **Admin only**. Preset values: 100 users, 300 shipments, 1000 QR codes, 50 purchase orders, 15 pending confirmations.",
                "operationId": "GenerateFullMockData",
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/MockDataGenerationResult"
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/mock-data/clear": {
            "delete": {
                "tags": ["Mock Data"],
                "summary": "Clear all mock data",
                "description": "**DANGER**: Clears ALL MOCK DATA from the database (Users, Shipments, QR Codes, etc.). **PRESERVES SEED DATA** (Countries, Localities, Vendors, Vessels, Statuses, Sources, Warehouses). **Admin only**. This operation cannot be undone. Use with extreme caution!",
                "operationId": "ClearAllData",
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/ClearDataResult"
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/no-conformities/drafts": {
            "get": {
                "tags": ["No-Conformities"],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/LoadResult"
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/no-conformities/active": {
            "get": {
                "tags": ["No-Conformities"],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/LoadResult"
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/no-conformities/resolved": {
            "get": {
                "tags": ["No-Conformities"],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/LoadResult"
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/no-conformities": {
            "get": {
                "tags": ["No-Conformities"],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/LoadResult"
                                }
                            }
                        }
                    }
                }
            },
            "post": {
                "tags": ["No-Conformities"],
                "requestBody": {
                    "content": {
                        "application/json": {
                            "schema": {
                                "$ref": "#/components/schemas/NoConformityCreateRequest"
                            }
                        }
                    },
                    "required": true
                },
                "responses": {
                    "201": {
                        "description": "Created",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/NoConformityDetailResult"
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/no-conformities/{id}": {
            "get": {
                "tags": ["No-Conformities"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/NoConformityDetailResult"
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            },
            "put": {
                "tags": ["No-Conformities"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "requestBody": {
                    "content": {
                        "application/json": {
                            "schema": {
                                "$ref": "#/components/schemas/NoConformityUpdateRequest"
                            }
                        }
                    },
                    "required": true
                },
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/NoConformityDetailResult"
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            },
            "delete": {
                "tags": ["No-Conformities"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "204": {
                        "description": "No Content"
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            }
        },
        "/api/v1/no-conformities/{id}/status": {
            "get": {
                "tags": ["No-Conformities"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/NoConformityStatusInfoResult"
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            },
            "put": {
                "tags": ["No-Conformities"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "requestBody": {
                    "content": {
                        "application/json": {
                            "schema": {
                                "$ref": "#/components/schemas/NoConformityStatusChangeRequest"
                            }
                        }
                    },
                    "required": true
                },
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/NoConformityDetailResult"
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            }
        },
        "/api/v1/no-conformities/{id}/assign": {
            "put": {
                "tags": ["No-Conformities"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "requestBody": {
                    "content": {
                        "application/json": {
                            "schema": {
                                "$ref": "#/components/schemas/NoConformityAssignRequest"
                            }
                        }
                    },
                    "required": true
                },
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/NoConformityDetailResult"
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            }
        },
        "/api/v1/no-conformities/{id}/comments": {
            "get": {
                "tags": ["No-Conformities"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "type": "array",
                                    "items": {
                                        "$ref": "#/components/schemas/NoConformityCommentResult"
                                    }
                                }
                            }
                        }
                    }
                }
            },
            "post": {
                "tags": ["No-Conformities"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "requestBody": {
                    "content": {
                        "multipart/form-data": {
                            "schema": {
                                "required": ["comment", "isInternal"],
                                "type": "object",
                                "properties": {
                                    "comment": {
                                        "type": "string"
                                    },
                                    "isInternal": {
                                        "type": "boolean"
                                    }
                                }
                            },
                            "encoding": {
                                "comment": {
                                    "style": "form"
                                },
                                "isInternal": {
                                    "style": "form"
                                }
                            }
                        },
                        "application/x-www-form-urlencoded": {
                            "schema": {
                                "required": ["comment", "isInternal"],
                                "type": "object",
                                "properties": {
                                    "comment": {
                                        "type": "string"
                                    },
                                    "isInternal": {
                                        "type": "boolean"
                                    }
                                }
                            },
                            "encoding": {
                                "comment": {
                                    "style": "form"
                                },
                                "isInternal": {
                                    "style": "form"
                                }
                            }
                        }
                    }
                },
                "responses": {
                    "201": {
                        "description": "Created",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/NoConformityCommentResult"
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/no-conformities/{id}/comments/{commentId}": {
            "delete": {
                "tags": ["No-Conformities"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    },
                    {
                        "name": "commentId",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "204": {
                        "description": "No Content"
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            }
        },
        "/api/v1/no-conformities/{id}/comments/{commentId}/attachments/{attachmentId}/download": {
            "get": {
                "tags": ["No-Conformities"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    },
                    {
                        "name": "commentId",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    },
                    {
                        "name": "attachmentId",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "type": "string",
                                    "format": "binary"
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            }
        },
        "/api/v1/no-conformities/{id}/attachments": {
            "post": {
                "tags": ["No-Conformities"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "requestBody": {
                    "content": {
                        "multipart/form-data": {
                            "schema": {
                                "type": "string",
                                "format": "binary"
                            }
                        }
                    },
                    "required": true
                },
                "responses": {
                    "201": {
                        "description": "Created",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/NoConformityAttachmentResult"
                                }
                            }
                        }
                    },
                    "400": {
                        "description": "Bad Request"
                    }
                }
            }
        },
        "/api/v1/no-conformities/{id}/attachments/{attachmentId}": {
            "delete": {
                "tags": ["No-Conformities"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    },
                    {
                        "name": "attachmentId",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "204": {
                        "description": "No Content"
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            }
        },
        "/api/v1/no-conformities/{id}/attachments/{attachmentId}/download": {
            "get": {
                "tags": ["No-Conformities"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    },
                    {
                        "name": "attachmentId",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "type": "string",
                                    "format": "binary"
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            }
        },
        "/api/v1/no-conformities/{id}/history": {
            "get": {
                "tags": ["No-Conformities"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "type": "array",
                                    "items": {
                                        "$ref": "#/components/schemas/NoConformityHistoryResult"
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/pending-confirmations/list": {
            "get": {
                "tags": ["Pending Confirmations"],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "type": "array",
                                    "items": {
                                        "$ref": "#/components/schemas/PendingConfirmationResult"
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/pending-confirmations": {
            "get": {
                "tags": ["Pending Confirmations"],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/LoadResult"
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/pending-confirmations/{id}": {
            "get": {
                "tags": ["Pending Confirmations"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/PendingConfirmationResult"
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            },
            "put": {
                "tags": ["Pending Confirmations"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "requestBody": {
                    "content": {
                        "application/json": {
                            "schema": {
                                "$ref": "#/components/schemas/UpdatePendingConfirmationRequest"
                            }
                        }
                    },
                    "required": true
                },
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/PendingConfirmationResult"
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    },
                    "400": {
                        "description": "Bad Request"
                    }
                }
            }
        },
        "/api/v1/pending-confirmations/{id}/approve": {
            "post": {
                "tags": ["Pending Confirmations"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/PurchaseOrderResult"
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    },
                    "400": {
                        "description": "Bad Request"
                    }
                }
            }
        },
        "/api/v1/pending-confirmations/{id}/reject": {
            "post": {
                "tags": ["Pending Confirmations"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK"
                    },
                    "404": {
                        "description": "Not Found"
                    },
                    "400": {
                        "description": "Bad Request"
                    }
                }
            }
        },
        "/api/v1/pending-confirmations/po-upload": {
            "post": {
                "tags": ["Pending Confirmations"],
                "requestBody": {
                    "content": {
                        "multipart/form-data": {
                            "schema": {
                                "required": ["file"],
                                "type": "object",
                                "properties": {
                                    "file": {
                                        "type": "string",
                                        "format": "binary"
                                    }
                                }
                            },
                            "encoding": {
                                "file": {
                                    "style": "form"
                                }
                            }
                        }
                    }
                },
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/PoUploadResult"
                                }
                            }
                        }
                    },
                    "400": {
                        "description": "Bad Request"
                    }
                }
            }
        },
        "/api/v1/pending-confirmations/{id}/file": {
            "get": {
                "tags": ["Pending Confirmations"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/pdf": {
                                "schema": {
                                    "type": "string",
                                    "format": "binary"
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            }
        },
        "/api/v1/port-agent": {
            "get": {
                "tags": ["PortAgent"],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/LoadResult"
                                }
                            }
                        }
                    }
                }
            },
            "post": {
                "tags": ["PortAgent"],
                "requestBody": {
                    "content": {
                        "application/json": {
                            "schema": {
                                "$ref": "#/components/schemas/PortAgentCreateRequest"
                            }
                        }
                    },
                    "required": true
                },
                "responses": {
                    "201": {
                        "description": "Created",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/PortAgentResult"
                                }
                            }
                        }
                    },
                    "400": {
                        "description": "Bad Request",
                        "content": {
                            "application/problem+json": {
                                "schema": {
                                    "$ref": "#/components/schemas/HttpValidationProblemDetails"
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/port-agent/{id}": {
            "get": {
                "tags": ["PortAgent"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/PortAgentResult"
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            },
            "put": {
                "tags": ["PortAgent"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "requestBody": {
                    "content": {
                        "application/json": {
                            "schema": {
                                "$ref": "#/components/schemas/PortAgentUpdateRequest"
                            }
                        }
                    },
                    "required": true
                },
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/PortAgentResult"
                                }
                            }
                        }
                    },
                    "400": {
                        "description": "Bad Request",
                        "content": {
                            "application/problem+json": {
                                "schema": {
                                    "$ref": "#/components/schemas/HttpValidationProblemDetails"
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            }
        },
        "/api/v1/purchase-orders/{poId}/attachments": {
            "get": {
                "tags": ["Purchase Order Attachments"],
                "operationId": "GetAttachmentsByPoId",
                "parameters": [
                    {
                        "name": "poId",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    },
                    {
                        "name": "kind",
                        "in": "query",
                        "schema": {
                            "type": "string"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "type": "array",
                                    "items": {
                                        "$ref": "#/components/schemas/PurchaseOrderAttachmentResult"
                                    }
                                }
                            }
                        }
                    }
                }
            },
            "post": {
                "tags": ["Purchase Order Attachments"],
                "operationId": "UploadAttachmentForPo",
                "parameters": [
                    {
                        "name": "poId",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "requestBody": {
                    "content": {
                        "multipart/form-data": {
                            "schema": {
                                "required": ["file", "kind"],
                                "type": "object",
                                "properties": {
                                    "file": {
                                        "type": "string",
                                        "format": "binary"
                                    },
                                    "kind": {
                                        "type": "string"
                                    },
                                    "documentTypeId": {
                                        "type": "string",
                                        "format": "uuid"
                                    },
                                    "pictureTypeId": {
                                        "type": "string",
                                        "format": "uuid"
                                    },
                                    "description": {
                                        "type": "string"
                                    },
                                    "caption": {
                                        "type": "string"
                                    }
                                }
                            },
                            "encoding": {
                                "file": {
                                    "style": "form"
                                },
                                "kind": {
                                    "style": "form"
                                },
                                "documentTypeId": {
                                    "style": "form"
                                },
                                "pictureTypeId": {
                                    "style": "form"
                                },
                                "description": {
                                    "style": "form"
                                },
                                "caption": {
                                    "style": "form"
                                }
                            }
                        }
                    }
                },
                "responses": {
                    "201": {
                        "description": "Created"
                    },
                    "400": {
                        "description": "Bad Request"
                    },
                    "500": {
                        "description": "Internal Server Error"
                    }
                }
            }
        },
        "/api/v1/purchase-orders/{poId}/attachments/{attachmentId}": {
            "get": {
                "tags": ["Purchase Order Attachments"],
                "operationId": "DownloadAttachmentByPo",
                "parameters": [
                    {
                        "name": "poId",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    },
                    {
                        "name": "attachmentId",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK"
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            },
            "delete": {
                "tags": ["Purchase Order Attachments"],
                "operationId": "DeleteAttachmentByPo",
                "parameters": [
                    {
                        "name": "poId",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    },
                    {
                        "name": "attachmentId",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "204": {
                        "description": "No Content"
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            }
        },
        "/api/v1/purchase-orders/{poId}/attachments/{attachmentId}/extracted-data": {
            "get": {
                "tags": ["Purchase Order Attachments"],
                "operationId": "GetAttachmentExtractedData",
                "parameters": [
                    {
                        "name": "poId",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    },
                    {
                        "name": "attachmentId",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK"
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            }
        },
        "/api/v1/purchase-orders/{poNumber}/changelog": {
            "get": {
                "tags": ["Purchase Order Change Log"],
                "operationId": "GetRouteChangeLog",
                "parameters": [
                    {
                        "name": "poNumber",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "type": "array",
                                    "items": {
                                        "$ref": "#/components/schemas/RouteChangeLogResult"
                                    }
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            }
        },
        "/api/v1/virtual-purchase-orders/{virtualPoId}/changelog": {
            "get": {
                "tags": ["Purchase Order Change Log"],
                "operationId": "GetVirtualPoRouteChangeLog",
                "parameters": [
                    {
                        "name": "virtualPoId",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "type": "array",
                                    "items": {
                                        "$ref": "#/components/schemas/RouteChangeLogResult"
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/purchase-orders/{poNumber}/route/segments": {
            "get": {
                "tags": ["Purchase Order Route Segments"],
                "operationId": "GetRouteSegments",
                "parameters": [
                    {
                        "name": "poNumber",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "type": "array",
                                    "items": {
                                        "$ref": "#/components/schemas/RouteSegmentResult"
                                    }
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            },
            "post": {
                "tags": ["Purchase Order Route Segments"],
                "operationId": "CreateRouteSegment",
                "parameters": [
                    {
                        "name": "poNumber",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string"
                        }
                    }
                ],
                "requestBody": {
                    "content": {
                        "application/json": {
                            "schema": {
                                "$ref": "#/components/schemas/RouteSegmentCreateRequest"
                            }
                        }
                    },
                    "required": true
                },
                "responses": {
                    "201": {
                        "description": "Created",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/RouteSegmentResult"
                                }
                            }
                        }
                    },
                    "400": {
                        "description": "Bad Request"
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            }
        },
        "/api/v1/purchase-orders/{poNumber}/route/segments/{segmentId}": {
            "put": {
                "tags": ["Purchase Order Route Segments"],
                "operationId": "UpdateRouteSegment",
                "parameters": [
                    {
                        "name": "poNumber",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string"
                        }
                    },
                    {
                        "name": "segmentId",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "requestBody": {
                    "content": {
                        "application/json": {
                            "schema": {
                                "$ref": "#/components/schemas/RouteSegmentUpdateRequest"
                            }
                        }
                    },
                    "required": true
                },
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/RouteSegmentResult"
                                }
                            }
                        }
                    },
                    "400": {
                        "description": "Bad Request"
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            },
            "delete": {
                "tags": ["Purchase Order Route Segments"],
                "operationId": "DeleteRouteSegment",
                "parameters": [
                    {
                        "name": "poNumber",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string"
                        }
                    },
                    {
                        "name": "segmentId",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "204": {
                        "description": "No Content"
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            }
        },
        "/api/v1/purchase-orders/{poNumber}/route/segments/reorder": {
            "put": {
                "tags": ["Purchase Order Route Segments"],
                "operationId": "ReorderRouteSegments",
                "parameters": [
                    {
                        "name": "poNumber",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string"
                        }
                    }
                ],
                "requestBody": {
                    "content": {
                        "application/json": {
                            "schema": {
                                "$ref": "#/components/schemas/RouteSegmentReorderRequest"
                            }
                        }
                    },
                    "required": true
                },
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "type": "array",
                                    "items": {
                                        "$ref": "#/components/schemas/RouteSegmentResult"
                                    }
                                }
                            }
                        }
                    },
                    "400": {
                        "description": "Bad Request"
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            }
        },
        "/api/v1/purchase-orders/{poNumber}/route/map": {
            "get": {
                "tags": ["Purchase Order Route Segments"],
                "operationId": "GetRouteMap",
                "parameters": [
                    {
                        "name": "poNumber",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/RouteMapResult"
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            }
        },
        "/api/v1/purchase-orders/recent": {
            "get": {
                "tags": ["Purchase Orders"],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/LoadResult"
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/purchase-orders/list": {
            "get": {
                "tags": ["Purchase Orders"],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "type": "array",
                                    "items": {
                                        "$ref": "#/components/schemas/PurchaseOrderResult"
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/purchase-orders": {
            "get": {
                "tags": ["Purchase Orders"],
                "parameters": [
                    {
                        "name": "dashboardFilter",
                        "in": "query",
                        "schema": {
                            "type": "string"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/LoadResult"
                                }
                            }
                        }
                    }
                }
            },
            "post": {
                "tags": ["Purchase Orders"],
                "requestBody": {
                    "content": {
                        "application/json": {
                            "schema": {
                                "$ref": "#/components/schemas/PurchaseOrderResult"
                            }
                        }
                    },
                    "required": true
                },
                "responses": {
                    "201": {
                        "description": "Created",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/PurchaseOrderResult"
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/purchase-orders/{id}": {
            "get": {
                "tags": ["Purchase Orders"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/PurchaseOrderResult"
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            },
            "put": {
                "tags": ["Purchase Orders"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "requestBody": {
                    "content": {
                        "application/json": {
                            "schema": {
                                "$ref": "#/components/schemas/PurchaseOrderResult"
                            }
                        }
                    },
                    "required": true
                },
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/PurchaseOrderResult"
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            },
            "delete": {
                "tags": ["Purchase Orders"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "204": {
                        "description": "No Content"
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            }
        },
        "/api/v1/purchase-orders/by-po-number/{poNumber}": {
            "get": {
                "tags": ["Purchase Orders"],
                "parameters": [
                    {
                        "name": "poNumber",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/PurchaseOrderResult"
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            }
        },
        "/api/v1/purchase-orders/{id}/is-virtual": {
            "get": {
                "tags": ["Purchase Orders"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "type": "boolean"
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/purchase-orders/{id}/is-route-completed": {
            "get": {
                "tags": ["Purchase Orders"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "type": "boolean"
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/purchase-orders/{id}/virtual-parent": {
            "get": {
                "tags": ["Purchase Orders"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "type": "string",
                                    "format": "uuid"
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/purchase-orders/{id}/tracking": {
            "get": {
                "tags": ["Purchase Orders"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/ShipmentTrackingResult"
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            }
        },
        "/api/v1/purchase-orders/tracking/{poNumber}": {
            "get": {
                "tags": ["Purchase Orders"],
                "parameters": [
                    {
                        "name": "poNumber",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/ShipmentTrackingResult"
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            }
        },
        "/api/v1/purchase-orders/{poId}/consolidated-shipments": {
            "get": {
                "tags": ["Purchase Orders"],
                "parameters": [
                    {
                        "name": "poId",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/LoadResult"
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            }
        },
        "/api/v1/purchase-orders/{virtualPoId}/virtual-purchase-orders": {
            "put": {
                "tags": ["Purchase Orders"],
                "parameters": [
                    {
                        "name": "virtualPoId",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "requestBody": {
                    "content": {
                        "application/json": {
                            "schema": {
                                "$ref": "#/components/schemas/UpdatePurchaseOrderVirtualRequest"
                            }
                        }
                    },
                    "required": true
                },
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "type": "array",
                                    "items": {
                                        "$ref": "#/components/schemas/VirtualPurchaseOrderLinkResult"
                                    }
                                }
                            }
                        }
                    },
                    "400": {
                        "description": "Bad Request"
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            }
        },
        "/api/v1/purchase-orders/{virtualPoId}/consolidated-shipment": {
            "delete": {
                "tags": ["Purchase Orders"],
                "parameters": [
                    {
                        "name": "virtualPoId",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "204": {
                        "description": "No Content"
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            }
        },
        "/api/v1/purchase-orders/{virtualPoId}/virtual-purchase-orders/{linkId}": {
            "delete": {
                "tags": ["Purchase Orders"],
                "parameters": [
                    {
                        "name": "virtualPoId",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    },
                    {
                        "name": "linkId",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "204": {
                        "description": "No Content"
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            }
        },
        "/api/v1/qrcode/generate": {
            "post": {
                "tags": ["QR Code"],
                "requestBody": {
                    "content": {
                        "application/json": {
                            "schema": {
                                "$ref": "#/components/schemas/QrCodeGenerationRequest"
                            }
                        }
                    },
                    "required": true
                },
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/QrCodeResult"
                                }
                            }
                        }
                    },
                    "400": {
                        "description": "Bad Request",
                        "content": {
                            "application/problem+json": {
                                "schema": {
                                    "$ref": "#/components/schemas/HttpValidationProblemDetails"
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/qrcode/{id}/download": {
            "get": {
                "tags": ["QR Code"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "image/png": {
                                "schema": {
                                    "type": "string",
                                    "format": "byte"
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            }
        },
        "/api/v1/qrcode/{id}/download-label": {
            "get": {
                "tags": ["QR Code"],
                "summary": "Download a printable PDF label for a QR code",
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/pdf": {
                                "schema": {
                                    "type": "string",
                                    "format": "byte"
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            }
        },
        "/api/v1/qrcode/{id}/label-preview": {
            "get": {
                "tags": ["QR Code"],
                "summary": "Get a PNG preview of the label for a QR code",
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "image/png": {
                                "schema": {
                                    "type": "string",
                                    "format": "byte"
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            }
        },
        "/api/v1/qrcode/po/{poId}": {
            "get": {
                "tags": ["QR Code"],
                "summary": "Get QR code for a Purchase Order",
                "parameters": [
                    {
                        "name": "poId",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/QrCodeResult"
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            }
        },
        "/api/v1/qrcode/virtual-po/{virtualPoId}": {
            "get": {
                "tags": ["QR Code"],
                "summary": "Get QR code for a Virtual Purchase Order",
                "parameters": [
                    {
                        "name": "virtualPoId",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/QrCodeResult"
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            }
        },
        "/api/v1/qrcode/lga/{lgaDocumentId}/download-label": {
            "get": {
                "tags": ["QR Code"],
                "summary": "Download a printable PDF label for an LGA document",
                "parameters": [
                    {
                        "name": "lgaDocumentId",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/pdf": {
                                "schema": {
                                    "type": "string",
                                    "format": "byte"
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            }
        },
        "/api/v1/qrcode/lga/{lgaDocumentId}/label-preview": {
            "get": {
                "tags": ["QR Code"],
                "summary": "Get a PNG preview of the label for an LGA document",
                "parameters": [
                    {
                        "name": "lgaDocumentId",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "image/png": {
                                "schema": {
                                    "type": "string",
                                    "format": "byte"
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            }
        },
        "/api/v1/qrcode/lga/{lgaDocumentId}": {
            "get": {
                "tags": ["QR Code"],
                "summary": "Get QR code for an LGA document",
                "parameters": [
                    {
                        "name": "lgaDocumentId",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/LgaQrCodeResult"
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            }
        },
        "/api/v1/qrcode/{id}/details": {
            "get": {
                "tags": ["QR Code"],
                "summary": "Get QR code details for prefilling scanner (anonymous access)",
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/QrCodeDetailsResult"
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            }
        },
        "/api/v1/qrcode/entity-details": {
            "get": {
                "tags": ["QR Code"],
                "summary": "Get entity details by type and ID for QR code scanner (anonymous access)",
                "parameters": [
                    {
                        "name": "type",
                        "in": "query",
                        "required": true,
                        "schema": {
                            "type": "string"
                        }
                    },
                    {
                        "name": "id",
                        "in": "query",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/QrEntityDetailsResult"
                                }
                            }
                        }
                    },
                    "400": {
                        "description": "Bad Request"
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            }
        },
        "/api/v1/qrcode/scan": {
            "post": {
                "tags": ["QR Code"],
                "requestBody": {
                    "content": {
                        "multipart/form-data": {
                            "schema": {
                                "required": ["request"],
                                "type": "object",
                                "properties": {
                                    "request": {
                                        "$ref": "#/components/schemas/QrCodeScanRequest"
                                    }
                                }
                            },
                            "encoding": {
                                "request": {
                                    "style": "form"
                                }
                            }
                        }
                    }
                },
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/QrCodeScanResult"
                                }
                            }
                        }
                    },
                    "400": {
                        "description": "Bad Request",
                        "content": {
                            "application/problem+json": {
                                "schema": {
                                    "$ref": "#/components/schemas/HttpValidationProblemDetails"
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/qrcode/scan/virtual-batch": {
            "post": {
                "tags": ["QR Code"],
                "summary": "Batch scan all POs in a virtual container",
                "requestBody": {
                    "content": {
                        "application/json": {
                            "schema": {
                                "$ref": "#/components/schemas/VirtualBatchScanRequest"
                            }
                        }
                    },
                    "required": true
                },
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/VirtualBatchScanResult"
                                }
                            }
                        }
                    },
                    "400": {
                        "description": "Bad Request"
                    }
                }
            }
        },
        "/api/v1/qrcode/scan/anonymous": {
            "post": {
                "tags": ["QR Code"],
                "requestBody": {
                    "content": {
                        "application/json": {
                            "schema": {
                                "$ref": "#/components/schemas/AnonymousQrCodeScanRequest"
                            }
                        }
                    },
                    "required": true
                },
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/QrCodeScanResult"
                                }
                            }
                        }
                    },
                    "400": {
                        "description": "Bad Request",
                        "content": {
                            "application/problem+json": {
                                "schema": {
                                    "$ref": "#/components/schemas/HttpValidationProblemDetails"
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/qrcode/warehouse/closest": {
            "get": {
                "tags": ["QR Code"],
                "parameters": [
                    {
                        "name": "latitude",
                        "in": "query",
                        "required": true,
                        "schema": {
                            "type": "number",
                            "format": "double"
                        }
                    },
                    {
                        "name": "longitude",
                        "in": "query",
                        "required": true,
                        "schema": {
                            "type": "number",
                            "format": "double"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/WarehouseResult"
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            }
        },
        "/api/v1/qrcode/scan/{scanId}/attachments": {
            "post": {
                "tags": ["QR Code"],
                "summary": "Upload an attachment (image/PDF) for a QR code scan (authenticated users only)",
                "parameters": [
                    {
                        "name": "scanId",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "requestBody": {
                    "content": {
                        "multipart/form-data": {
                            "schema": {
                                "required": ["file"],
                                "type": "object",
                                "properties": {
                                    "file": {
                                        "type": "string",
                                        "format": "binary"
                                    }
                                }
                            },
                            "encoding": {
                                "file": {
                                    "style": "form"
                                }
                            }
                        }
                    }
                },
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/QrCodeScanAttachmentResult"
                                }
                            }
                        }
                    },
                    "400": {
                        "description": "Bad Request"
                    }
                }
            },
            "get": {
                "tags": ["QR Code"],
                "summary": "Get all attachments for a QR code scan",
                "parameters": [
                    {
                        "name": "scanId",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "type": "array",
                                    "items": {
                                        "$ref": "#/components/schemas/QrCodeScanAttachmentResult"
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/qrcode/attachments/{attachmentId}/download": {
            "get": {
                "tags": ["QR Code"],
                "summary": "Download an attachment file",
                "parameters": [
                    {
                        "name": "attachmentId",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "type": "string",
                                    "format": "byte"
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            }
        },
        "/api/v1/qrcode/attachments/{attachmentId}": {
            "delete": {
                "tags": ["QR Code"],
                "summary": "Delete an attachment",
                "parameters": [
                    {
                        "name": "attachmentId",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "204": {
                        "description": "No Content"
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            }
        },
        "/api/v1/reports/filter-options": {
            "get": {
                "tags": ["Reports"],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/ReportFilterOptionsResult"
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/reports/shipping-volume-by-port": {
            "post": {
                "tags": ["Reports"],
                "requestBody": {
                    "content": {
                        "application/json": {
                            "schema": {
                                "$ref": "#/components/schemas/ReportFilterRequest"
                            }
                        }
                    },
                    "required": true
                },
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/ShippingVolumeByPortResult"
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/reports/kpi-summary": {
            "get": {
                "tags": ["Reports"],
                "parameters": [
                    {
                        "name": "ReportType",
                        "in": "query",
                        "schema": {
                            "type": "string"
                        }
                    },
                    {
                        "name": "Ship",
                        "in": "query",
                        "schema": {
                            "type": "string"
                        }
                    },
                    {
                        "name": "GoodsCategory",
                        "in": "query",
                        "schema": {
                            "type": "string"
                        }
                    },
                    {
                        "name": "Port",
                        "in": "query",
                        "schema": {
                            "type": "string"
                        }
                    },
                    {
                        "name": "TransportType",
                        "in": "query",
                        "schema": {
                            "type": "string"
                        }
                    },
                    {
                        "name": "StartDate",
                        "in": "query",
                        "schema": {
                            "type": "string",
                            "format": "date-time"
                        }
                    },
                    {
                        "name": "EndDate",
                        "in": "query",
                        "schema": {
                            "type": "string",
                            "format": "date-time"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/ReportKpisResult"
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/reports/delivery-time-trend": {
            "get": {
                "tags": ["Reports"],
                "parameters": [
                    {
                        "name": "ReportType",
                        "in": "query",
                        "schema": {
                            "type": "string"
                        }
                    },
                    {
                        "name": "Ship",
                        "in": "query",
                        "schema": {
                            "type": "string"
                        }
                    },
                    {
                        "name": "GoodsCategory",
                        "in": "query",
                        "schema": {
                            "type": "string"
                        }
                    },
                    {
                        "name": "Port",
                        "in": "query",
                        "schema": {
                            "type": "string"
                        }
                    },
                    {
                        "name": "TransportType",
                        "in": "query",
                        "schema": {
                            "type": "string"
                        }
                    },
                    {
                        "name": "StartDate",
                        "in": "query",
                        "schema": {
                            "type": "string",
                            "format": "date-time"
                        }
                    },
                    {
                        "name": "EndDate",
                        "in": "query",
                        "schema": {
                            "type": "string",
                            "format": "date-time"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "type": "array",
                                    "items": {
                                        "$ref": "#/components/schemas/ChartDataPointResult"
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/reports/non-conformities-by-category": {
            "get": {
                "tags": ["Reports"],
                "parameters": [
                    {
                        "name": "ReportType",
                        "in": "query",
                        "schema": {
                            "type": "string"
                        }
                    },
                    {
                        "name": "Ship",
                        "in": "query",
                        "schema": {
                            "type": "string"
                        }
                    },
                    {
                        "name": "GoodsCategory",
                        "in": "query",
                        "schema": {
                            "type": "string"
                        }
                    },
                    {
                        "name": "Port",
                        "in": "query",
                        "schema": {
                            "type": "string"
                        }
                    },
                    {
                        "name": "TransportType",
                        "in": "query",
                        "schema": {
                            "type": "string"
                        }
                    },
                    {
                        "name": "StartDate",
                        "in": "query",
                        "schema": {
                            "type": "string",
                            "format": "date-time"
                        }
                    },
                    {
                        "name": "EndDate",
                        "in": "query",
                        "schema": {
                            "type": "string",
                            "format": "date-time"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "type": "array",
                                    "items": {
                                        "$ref": "#/components/schemas/ChartDataPointResult"
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/reports/status-update-metrics": {
            "get": {
                "tags": ["Reports"],
                "parameters": [
                    {
                        "name": "ReportType",
                        "in": "query",
                        "schema": {
                            "type": "string"
                        }
                    },
                    {
                        "name": "Ship",
                        "in": "query",
                        "schema": {
                            "type": "string"
                        }
                    },
                    {
                        "name": "GoodsCategory",
                        "in": "query",
                        "schema": {
                            "type": "string"
                        }
                    },
                    {
                        "name": "Port",
                        "in": "query",
                        "schema": {
                            "type": "string"
                        }
                    },
                    {
                        "name": "TransportType",
                        "in": "query",
                        "schema": {
                            "type": "string"
                        }
                    },
                    {
                        "name": "StartDate",
                        "in": "query",
                        "schema": {
                            "type": "string",
                            "format": "date-time"
                        }
                    },
                    {
                        "name": "EndDate",
                        "in": "query",
                        "schema": {
                            "type": "string",
                            "format": "date-time"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/StatusUpdateMetricsResult"
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/reports/financial-amount-to-invoice": {
            "get": {
                "tags": ["Reports"],
                "parameters": [
                    {
                        "name": "ReportType",
                        "in": "query",
                        "schema": {
                            "type": "string"
                        }
                    },
                    {
                        "name": "Ship",
                        "in": "query",
                        "schema": {
                            "type": "string"
                        }
                    },
                    {
                        "name": "GoodsCategory",
                        "in": "query",
                        "schema": {
                            "type": "string"
                        }
                    },
                    {
                        "name": "Port",
                        "in": "query",
                        "schema": {
                            "type": "string"
                        }
                    },
                    {
                        "name": "TransportType",
                        "in": "query",
                        "schema": {
                            "type": "string"
                        }
                    },
                    {
                        "name": "StartDate",
                        "in": "query",
                        "schema": {
                            "type": "string",
                            "format": "date-time"
                        }
                    },
                    {
                        "name": "EndDate",
                        "in": "query",
                        "schema": {
                            "type": "string",
                            "format": "date-time"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/FinancialReportResult"
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/reports/invoicing-status/by-transport-type": {
            "get": {
                "tags": ["Reports"],
                "parameters": [
                    {
                        "name": "ReportType",
                        "in": "query",
                        "schema": {
                            "type": "string"
                        }
                    },
                    {
                        "name": "Ship",
                        "in": "query",
                        "schema": {
                            "type": "string"
                        }
                    },
                    {
                        "name": "GoodsCategory",
                        "in": "query",
                        "schema": {
                            "type": "string"
                        }
                    },
                    {
                        "name": "Port",
                        "in": "query",
                        "schema": {
                            "type": "string"
                        }
                    },
                    {
                        "name": "TransportType",
                        "in": "query",
                        "schema": {
                            "type": "string"
                        }
                    },
                    {
                        "name": "StartDate",
                        "in": "query",
                        "schema": {
                            "type": "string",
                            "format": "date-time"
                        }
                    },
                    {
                        "name": "EndDate",
                        "in": "query",
                        "schema": {
                            "type": "string",
                            "format": "date-time"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/InvoiceStatusByTransportTypeReportResult"
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/reports/invoicing-status/by-month": {
            "get": {
                "tags": ["Reports"],
                "parameters": [
                    {
                        "name": "ReportType",
                        "in": "query",
                        "schema": {
                            "type": "string"
                        }
                    },
                    {
                        "name": "Ship",
                        "in": "query",
                        "schema": {
                            "type": "string"
                        }
                    },
                    {
                        "name": "GoodsCategory",
                        "in": "query",
                        "schema": {
                            "type": "string"
                        }
                    },
                    {
                        "name": "Port",
                        "in": "query",
                        "schema": {
                            "type": "string"
                        }
                    },
                    {
                        "name": "TransportType",
                        "in": "query",
                        "schema": {
                            "type": "string"
                        }
                    },
                    {
                        "name": "StartDate",
                        "in": "query",
                        "schema": {
                            "type": "string",
                            "format": "date-time"
                        }
                    },
                    {
                        "name": "EndDate",
                        "in": "query",
                        "schema": {
                            "type": "string",
                            "format": "date-time"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/InvoiceStatusByMonthTypeReportResult"
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/reports/invoicing-status/totals": {
            "get": {
                "tags": ["Reports"],
                "parameters": [
                    {
                        "name": "ReportType",
                        "in": "query",
                        "schema": {
                            "type": "string"
                        }
                    },
                    {
                        "name": "Ship",
                        "in": "query",
                        "schema": {
                            "type": "string"
                        }
                    },
                    {
                        "name": "GoodsCategory",
                        "in": "query",
                        "schema": {
                            "type": "string"
                        }
                    },
                    {
                        "name": "Port",
                        "in": "query",
                        "schema": {
                            "type": "string"
                        }
                    },
                    {
                        "name": "TransportType",
                        "in": "query",
                        "schema": {
                            "type": "string"
                        }
                    },
                    {
                        "name": "StartDate",
                        "in": "query",
                        "schema": {
                            "type": "string",
                            "format": "date-time"
                        }
                    },
                    {
                        "name": "EndDate",
                        "in": "query",
                        "schema": {
                            "type": "string",
                            "format": "date-time"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/InvoiceStatusByTotalsTypeReportResult"
                                }
                            }
                        }
                    }
                }
            }
        },
        "/health": {
            "get": {
                "tags": ["Ryyc.Navirina.WebApi"],
                "responses": {
                    "200": {
                        "description": "OK"
                    }
                }
            }
        },
        "/api/v1/purchase-orders/{id}/map": {
            "get": {
                "tags": ["Unified Map"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/UnifiedMapResult"
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            }
        },
        "/api/v1/virtual-purchase-orders/{id}/map": {
            "get": {
                "tags": ["Unified Map"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/UnifiedMapResult"
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/lga-documents/{id}/map": {
            "get": {
                "tags": ["Unified Map"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/UnifiedMapResult"
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/users/lookup": {
            "get": {
                "tags": ["Users"],
                "summary": "Get users for lookup/dropdown",
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "type": "array",
                                    "items": {
                                        "$ref": "#/components/schemas/UserLookupResult"
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/users/me/permissions": {
            "get": {
                "tags": ["Users"],
                "summary": "Get current user's permissions map",
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/UserPermissionsResult"
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/users/roles": {
            "get": {
                "tags": ["Users"],
                "summary": "Get all available realm roles",
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "type": "array",
                                    "items": {
                                        "$ref": "#/components/schemas/RoleResult"
                                    }
                                }
                            }
                        }
                    }
                }
            },
            "post": {
                "tags": ["Users"],
                "summary": "Create a new realm role",
                "requestBody": {
                    "content": {
                        "application/json": {
                            "schema": {
                                "$ref": "#/components/schemas/CreateRoleRequest"
                            }
                        }
                    },
                    "required": true
                },
                "responses": {
                    "201": {
                        "description": "Created",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/RoleResult"
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/users/roles/{roleName}": {
            "delete": {
                "tags": ["Users"],
                "summary": "Delete a realm role",
                "parameters": [
                    {
                        "name": "roleName",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string"
                        }
                    }
                ],
                "responses": {
                    "204": {
                        "description": "No Content"
                    }
                }
            }
        },
        "/api/v1/users/permissions": {
            "get": {
                "tags": ["Users"],
                "summary": "Get all available client permissions",
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "type": "array",
                                    "items": {
                                        "$ref": "#/components/schemas/PermissionResult"
                                    }
                                }
                            }
                        }
                    }
                }
            },
            "post": {
                "tags": ["Users"],
                "summary": "Create a new client permission",
                "requestBody": {
                    "content": {
                        "application/json": {
                            "schema": {
                                "$ref": "#/components/schemas/CreatePermissionRequest"
                            }
                        }
                    },
                    "required": true
                },
                "responses": {
                    "201": {
                        "description": "Created",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/PermissionResult"
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/users/permissions/{permissionName}": {
            "delete": {
                "tags": ["Users"],
                "summary": "Delete a client permission",
                "parameters": [
                    {
                        "name": "permissionName",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string"
                        }
                    }
                ],
                "responses": {
                    "204": {
                        "description": "No Content"
                    }
                }
            }
        },
        "/api/v1/users/roles/{roleName}/permissions": {
            "get": {
                "tags": ["Users"],
                "summary": "Get permissions (client roles) assigned to a realm role",
                "parameters": [
                    {
                        "name": "roleName",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "type": "array",
                                    "items": {
                                        "type": "string"
                                    }
                                }
                            }
                        }
                    }
                }
            },
            "put": {
                "tags": ["Users"],
                "summary": "Set permissions (client roles) for a realm role",
                "parameters": [
                    {
                        "name": "roleName",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string"
                        }
                    }
                ],
                "requestBody": {
                    "content": {
                        "application/json": {
                            "schema": {
                                "$ref": "#/components/schemas/UpdateRolePermissionsRequest"
                            }
                        }
                    },
                    "required": true
                },
                "responses": {
                    "204": {
                        "description": "No Content"
                    }
                }
            }
        },
        "/api/v1/users": {
            "get": {
                "tags": ["Users"],
                "summary": "Get all users from Keycloak",
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "type": "array",
                                    "items": {
                                        "$ref": "#/components/schemas/UserDetailResult"
                                    }
                                }
                            }
                        }
                    }
                }
            },
            "post": {
                "tags": ["Users"],
                "summary": "Create a new user (Keycloak + DB)",
                "requestBody": {
                    "content": {
                        "application/json": {
                            "schema": {
                                "$ref": "#/components/schemas/CreateUserRequest"
                            }
                        }
                    },
                    "required": true
                },
                "responses": {
                    "201": {
                        "description": "Created",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/UserDetailResult"
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/users/{userId}": {
            "get": {
                "tags": ["Users"],
                "summary": "Get user details with roles and permissions",
                "parameters": [
                    {
                        "name": "userId",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/UserDetailResult"
                                }
                            }
                        }
                    }
                }
            },
            "put": {
                "tags": ["Users"],
                "summary": "Update user details (Keycloak + DB)",
                "parameters": [
                    {
                        "name": "userId",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string"
                        }
                    }
                ],
                "requestBody": {
                    "content": {
                        "application/json": {
                            "schema": {
                                "$ref": "#/components/schemas/UpdateUserRequest"
                            }
                        }
                    },
                    "required": true
                },
                "responses": {
                    "204": {
                        "description": "No Content"
                    }
                }
            },
            "delete": {
                "tags": ["Users"],
                "summary": "Disable user (Keycloak) and soft-delete (DB)",
                "parameters": [
                    {
                        "name": "userId",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string"
                        }
                    }
                ],
                "responses": {
                    "204": {
                        "description": "No Content"
                    }
                }
            }
        },
        "/api/v1/users/{userId}/roles": {
            "get": {
                "tags": ["Users"],
                "summary": "Get user's assigned realm roles",
                "parameters": [
                    {
                        "name": "userId",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "type": "array",
                                    "items": {
                                        "type": "string"
                                    }
                                }
                            }
                        }
                    }
                }
            },
            "put": {
                "tags": ["Users"],
                "summary": "Update user's realm roles",
                "parameters": [
                    {
                        "name": "userId",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string"
                        }
                    }
                ],
                "requestBody": {
                    "content": {
                        "application/json": {
                            "schema": {
                                "$ref": "#/components/schemas/UpdateUserRolesRequest"
                            }
                        }
                    },
                    "required": true
                },
                "responses": {
                    "204": {
                        "description": "No Content"
                    }
                }
            }
        },
        "/api/v1/users/{userId}/permissions": {
            "get": {
                "tags": ["Users"],
                "summary": "Get user's assigned client permissions",
                "parameters": [
                    {
                        "name": "userId",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "type": "array",
                                    "items": {
                                        "type": "string"
                                    }
                                }
                            }
                        }
                    }
                }
            },
            "put": {
                "tags": ["Users"],
                "summary": "Update user's client permissions",
                "parameters": [
                    {
                        "name": "userId",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string"
                        }
                    }
                ],
                "requestBody": {
                    "content": {
                        "application/json": {
                            "schema": {
                                "$ref": "#/components/schemas/UpdateUserPermissionsRequest"
                            }
                        }
                    },
                    "required": true
                },
                "responses": {
                    "204": {
                        "description": "No Content"
                    }
                }
            }
        },
        "/api/v1/users/{userId}/reset-password": {
            "post": {
                "tags": ["Users"],
                "summary": "Send reset password email to user",
                "parameters": [
                    {
                        "name": "userId",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string"
                        }
                    }
                ],
                "responses": {
                    "204": {
                        "description": "No Content"
                    }
                }
            }
        },
        "/api/v1/users/{userId}/impersonate": {
            "post": {
                "tags": ["Users"],
                "summary": "Impersonate a user via Keycloak Token Exchange",
                "parameters": [
                    {
                        "name": "userId",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/ImpersonationResult"
                                }
                            }
                        }
                    },
                    "400": {
                        "description": "Bad Request"
                    },
                    "403": {
                        "description": "Forbidden"
                    }
                }
            }
        },
        "/api/v1/version/api": {
            "get": {
                "tags": ["Version"],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/VersionRet"
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/virtual-purchase-orders/{virtualPoId}/route/segments": {
            "get": {
                "tags": ["Virtual PO Route Segments"],
                "operationId": "GetVirtualPoRouteSegments",
                "parameters": [
                    {
                        "name": "virtualPoId",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "type": "array",
                                    "items": {
                                        "$ref": "#/components/schemas/RouteSegmentResult"
                                    }
                                }
                            }
                        }
                    }
                }
            },
            "post": {
                "tags": ["Virtual PO Route Segments"],
                "operationId": "CreateVirtualPoRouteSegment",
                "parameters": [
                    {
                        "name": "virtualPoId",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "requestBody": {
                    "content": {
                        "application/json": {
                            "schema": {
                                "$ref": "#/components/schemas/RouteSegmentCreateRequest"
                            }
                        }
                    },
                    "required": true
                },
                "responses": {
                    "201": {
                        "description": "Created",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/RouteSegmentResult"
                                }
                            }
                        }
                    },
                    "400": {
                        "description": "Bad Request"
                    }
                }
            }
        },
        "/api/v1/virtual-purchase-orders/{virtualPoId}/route/segments/{segmentId}": {
            "put": {
                "tags": ["Virtual PO Route Segments"],
                "operationId": "UpdateVirtualPoRouteSegment",
                "parameters": [
                    {
                        "name": "virtualPoId",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    },
                    {
                        "name": "segmentId",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "requestBody": {
                    "content": {
                        "application/json": {
                            "schema": {
                                "$ref": "#/components/schemas/RouteSegmentUpdateRequest"
                            }
                        }
                    },
                    "required": true
                },
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/RouteSegmentResult"
                                }
                            }
                        }
                    },
                    "400": {
                        "description": "Bad Request"
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            },
            "delete": {
                "tags": ["Virtual PO Route Segments"],
                "operationId": "DeleteVirtualPoRouteSegment",
                "parameters": [
                    {
                        "name": "virtualPoId",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    },
                    {
                        "name": "segmentId",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "204": {
                        "description": "No Content"
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            }
        },
        "/api/v1/virtual-purchase-orders/{virtualPoId}/route/segments/reorder": {
            "put": {
                "tags": ["Virtual PO Route Segments"],
                "operationId": "ReorderVirtualPoRouteSegments",
                "parameters": [
                    {
                        "name": "virtualPoId",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "requestBody": {
                    "content": {
                        "application/json": {
                            "schema": {
                                "$ref": "#/components/schemas/RouteSegmentReorderRequest"
                            }
                        }
                    },
                    "required": true
                },
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "type": "array",
                                    "items": {
                                        "$ref": "#/components/schemas/RouteSegmentResult"
                                    }
                                }
                            }
                        }
                    },
                    "400": {
                        "description": "Bad Request"
                    }
                }
            }
        },
        "/api/v1/virtual-purchase-orders/{virtualPoId}/route/map": {
            "get": {
                "tags": ["Virtual PO Route Segments"],
                "operationId": "GetVirtualPoRouteMap",
                "parameters": [
                    {
                        "name": "virtualPoId",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/RouteMapResult"
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/virtual-purchase-orders/{virtualPoId}/attachments": {
            "get": {
                "tags": ["Virtual Purchase Order Attachments"],
                "operationId": "GetAttachmentsByVirtualPoId",
                "parameters": [
                    {
                        "name": "virtualPoId",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    },
                    {
                        "name": "kind",
                        "in": "query",
                        "schema": {
                            "type": "string"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "type": "array",
                                    "items": {
                                        "$ref": "#/components/schemas/PurchaseOrderAttachmentResult"
                                    }
                                }
                            }
                        }
                    }
                }
            },
            "post": {
                "tags": ["Virtual Purchase Order Attachments"],
                "operationId": "UploadAttachmentForVirtualPo",
                "parameters": [
                    {
                        "name": "virtualPoId",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "requestBody": {
                    "content": {
                        "multipart/form-data": {
                            "schema": {
                                "required": ["file", "kind"],
                                "type": "object",
                                "properties": {
                                    "file": {
                                        "type": "string",
                                        "format": "binary"
                                    },
                                    "kind": {
                                        "type": "string"
                                    },
                                    "documentTypeId": {
                                        "type": "string",
                                        "format": "uuid"
                                    },
                                    "pictureTypeId": {
                                        "type": "string",
                                        "format": "uuid"
                                    },
                                    "description": {
                                        "type": "string"
                                    },
                                    "caption": {
                                        "type": "string"
                                    }
                                }
                            },
                            "encoding": {
                                "file": {
                                    "style": "form"
                                },
                                "kind": {
                                    "style": "form"
                                },
                                "documentTypeId": {
                                    "style": "form"
                                },
                                "pictureTypeId": {
                                    "style": "form"
                                },
                                "description": {
                                    "style": "form"
                                },
                                "caption": {
                                    "style": "form"
                                }
                            }
                        }
                    }
                },
                "responses": {
                    "201": {
                        "description": "Created"
                    },
                    "400": {
                        "description": "Bad Request"
                    },
                    "500": {
                        "description": "Internal Server Error"
                    }
                }
            }
        },
        "/api/v1/virtual-purchase-orders/{virtualPoId}/attachments/{attachmentId}": {
            "get": {
                "tags": ["Virtual Purchase Order Attachments"],
                "operationId": "DownloadAttachmentByVirtualPo",
                "parameters": [
                    {
                        "name": "virtualPoId",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    },
                    {
                        "name": "attachmentId",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK"
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            },
            "delete": {
                "tags": ["Virtual Purchase Order Attachments"],
                "operationId": "DeleteAttachmentByVirtualPo",
                "parameters": [
                    {
                        "name": "virtualPoId",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    },
                    {
                        "name": "attachmentId",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "204": {
                        "description": "No Content"
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            }
        },
        "/api/v1/virtual-purchase-orders": {
            "get": {
                "tags": ["Virtual Purchase Orders"],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "type": "array",
                                    "items": {
                                        "$ref": "#/components/schemas/VirtualPurchaseOrderResult"
                                    }
                                }
                            }
                        }
                    }
                }
            },
            "post": {
                "tags": ["Virtual Purchase Orders"],
                "requestBody": {
                    "content": {
                        "application/json": {
                            "schema": {
                                "$ref": "#/components/schemas/CreateVirtualPurchaseOrderRequest"
                            }
                        }
                    },
                    "required": true
                },
                "responses": {
                    "201": {
                        "description": "Created",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/VirtualPurchaseOrderResult"
                                }
                            }
                        }
                    },
                    "400": {
                        "description": "Bad Request"
                    }
                }
            }
        },
        "/api/v1/virtual-purchase-orders/{id}": {
            "get": {
                "tags": ["Virtual Purchase Orders"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/VirtualPurchaseOrderResult"
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            },
            "put": {
                "tags": ["Virtual Purchase Orders"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "requestBody": {
                    "content": {
                        "application/json": {
                            "schema": {
                                "$ref": "#/components/schemas/UpdateVirtualPurchaseOrderRequest"
                            }
                        }
                    },
                    "required": true
                },
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/VirtualPurchaseOrderResult"
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            },
            "delete": {
                "tags": ["Virtual Purchase Orders"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "204": {
                        "description": "No Content"
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            }
        },
        "/api/v1/virtual-purchase-orders/{id}/links": {
            "get": {
                "tags": ["Virtual Purchase Orders"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/LoadResult"
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/virtual-purchase-orders/{id}/tracking": {
            "get": {
                "tags": ["Virtual Purchase Orders"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/ShipmentTrackingResult"
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            }
        },
        "/api/v1/virtual-purchase-orders/{id}/purge": {
            "delete": {
                "tags": ["Virtual Purchase Orders"],
                "summary": "Purge VPO — hard-delete VPO, all its links and all route segments propagated to POs",
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "204": {
                        "description": "No Content"
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            }
        },
        "/api/v1/warehouse": {
            "get": {
                "tags": ["Warehouse"],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/LoadResult"
                                }
                            }
                        }
                    }
                }
            },
            "post": {
                "tags": ["Warehouse"],
                "requestBody": {
                    "content": {
                        "application/json": {
                            "schema": {
                                "$ref": "#/components/schemas/WarehouseCreateRequest"
                            }
                        }
                    },
                    "required": true
                },
                "responses": {
                    "201": {
                        "description": "Created",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/WarehouseResult"
                                }
                            }
                        }
                    },
                    "400": {
                        "description": "Bad Request",
                        "content": {
                            "application/problem+json": {
                                "schema": {
                                    "$ref": "#/components/schemas/HttpValidationProblemDetails"
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/warehouse/{id}": {
            "get": {
                "tags": ["Warehouse"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/WarehouseResult"
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            },
            "put": {
                "tags": ["Warehouse"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "requestBody": {
                    "content": {
                        "application/json": {
                            "schema": {
                                "$ref": "#/components/schemas/WarehouseUpdateRequest"
                            }
                        }
                    },
                    "required": true
                },
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/WarehouseResult"
                                }
                            }
                        }
                    },
                    "400": {
                        "description": "Bad Request",
                        "content": {
                            "application/problem+json": {
                                "schema": {
                                    "$ref": "#/components/schemas/HttpValidationProblemDetails"
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            }
        },
        "/api/v1/warehouse/filter": {
            "get": {
                "tags": ["Warehouse"],
                "parameters": [
                    {
                        "name": "localityId",
                        "in": "query",
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    },
                    {
                        "name": "isActive",
                        "in": "query",
                        "schema": {
                            "type": "boolean"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "type": "array",
                                    "items": {
                                        "$ref": "#/components/schemas/WarehouseResult"
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/warehouse/closest": {
            "get": {
                "tags": ["Warehouse"],
                "parameters": [
                    {
                        "name": "latitude",
                        "in": "query",
                        "required": true,
                        "schema": {
                            "type": "number",
                            "format": "double"
                        }
                    },
                    {
                        "name": "longitude",
                        "in": "query",
                        "required": true,
                        "schema": {
                            "type": "number",
                            "format": "double"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/WarehouseResult"
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            }
        },
        "/api/v1/warehouse/statistics": {
            "get": {
                "tags": ["Warehouse"],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/WarehouseStatisticsResult"
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/warehouse/map-locations": {
            "get": {
                "tags": ["Warehouse"],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "type": "array",
                                    "items": {
                                        "$ref": "#/components/schemas/WarehouseMapLocationResult"
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/warehouse/inventory": {
            "get": {
                "tags": ["Warehouse"],
                "parameters": [
                    {
                        "name": "localityId",
                        "in": "query",
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    },
                    {
                        "name": "warehouseId",
                        "in": "query",
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "type": "array",
                                    "items": {
                                        "$ref": "#/components/schemas/PurchaseOrderResult"
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/warehouse/arrivals": {
            "get": {
                "tags": ["Warehouse"],
                "parameters": [
                    {
                        "name": "localityId",
                        "in": "query",
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    },
                    {
                        "name": "warehouseId",
                        "in": "query",
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "type": "array",
                                    "items": {
                                        "$ref": "#/components/schemas/PurchaseOrderResult"
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/warehouse/late": {
            "get": {
                "tags": ["Warehouse"],
                "parameters": [
                    {
                        "name": "localityId",
                        "in": "query",
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    },
                    {
                        "name": "warehouseId",
                        "in": "query",
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "type": "array",
                                    "items": {
                                        "$ref": "#/components/schemas/PurchaseOrderResult"
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        "/api/v1/warehouse/{id}/inventory/available-for-grouping": {
            "get": {
                "tags": ["Warehouse"],
                "summary": "Get POs available for virtual grouping at a warehouse",
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "type": "array",
                                    "items": {
                                        "$ref": "#/components/schemas/PurchaseOrderResult"
                                    }
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            }
        },
        "/api/v1/warehouse/{id}/inventory/all-available-for-grouping": {
            "get": {
                "tags": ["Warehouse"],
                "summary": "Get all POs available for virtual grouping (not at this warehouse, not in any virtual PO)",
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "type": "array",
                                    "items": {
                                        "$ref": "#/components/schemas/PurchaseOrderResult"
                                    }
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            }
        },
        "/api/v1/warehouse/{id}/inventory/arriving-at-warehouse": {
            "get": {
                "tags": ["Warehouse"],
                "summary": "Get POs with route segments arriving at this warehouse locality (not as final destination)",
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "type": "array",
                                    "items": {
                                        "$ref": "#/components/schemas/PurchaseOrderResult"
                                    }
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            }
        },
        "/api/v1/warehouse/{id}/inventory/already-consolidated": {
            "get": {
                "tags": ["Warehouse"],
                "summary": "Get all POs already linked to a virtual/consolidated PO",
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "type": "array",
                                    "items": {
                                        "$ref": "#/components/schemas/AlreadyConsolidatedItemResult"
                                    }
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            }
        },
        "/api/v1/warehouse/{id}/inventory/grid": {
            "get": {
                "tags": ["Warehouse"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/LoadResult"
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            }
        },
        "/api/v1/warehouse/{id}/expected-arrivals/grid": {
            "get": {
                "tags": ["Warehouse"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/LoadResult"
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            }
        },
        "/api/v1/warehouse/{id}/late-arrivals/grid": {
            "get": {
                "tags": ["Warehouse"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/LoadResult"
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            }
        },
        "/api/v1/warehouse/{id}/consolidated-shipments/grid": {
            "get": {
                "tags": ["Warehouse"],
                "parameters": [
                    {
                        "name": "id",
                        "in": "path",
                        "required": true,
                        "schema": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                ],
                "responses": {
                    "200": {
                        "description": "OK",
                        "content": {
                            "application/json": {
                                "schema": {
                                    "$ref": "#/components/schemas/LoadResult"
                                }
                            }
                        }
                    },
                    "404": {
                        "description": "Not Found"
                    }
                }
            }
        }
    },
    "components": {
        "schemas": {
            "AlertSettingResult": {
                "type": "object",
                "properties": {
                    "enabled": {
                        "type": "boolean"
                    },
                    "cronExpression": {
                        "type": "string",
                        "nullable": true
                    },
                    "delayThresholdDays": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "updatedAt": {
                        "type": "string",
                        "format": "date-time"
                    },
                    "updatedBy": {
                        "type": "string",
                        "nullable": true
                    }
                },
                "additionalProperties": false
            },
            "AlertSettingUpdateRequest": {
                "required": ["cronExpression"],
                "type": "object",
                "properties": {
                    "enabled": {
                        "type": "boolean"
                    },
                    "cronExpression": {
                        "maxLength": 100,
                        "minLength": 0,
                        "type": "string"
                    },
                    "delayThresholdDays": {
                        "maximum": 365,
                        "minimum": 1,
                        "type": "integer",
                        "format": "int32"
                    }
                },
                "additionalProperties": false
            },
            "AlertSubscriberCreateRequest": {
                "required": ["email", "name"],
                "type": "object",
                "properties": {
                    "email": {
                        "maxLength": 320,
                        "minLength": 0,
                        "type": "string",
                        "format": "email"
                    },
                    "name": {
                        "maxLength": 200,
                        "minLength": 0,
                        "type": "string"
                    },
                    "isActive": {
                        "type": "boolean"
                    }
                },
                "additionalProperties": false
            },
            "AlertSubscriberResult": {
                "type": "object",
                "properties": {
                    "id": {
                        "type": "string",
                        "format": "uuid"
                    },
                    "email": {
                        "type": "string",
                        "nullable": true
                    },
                    "name": {
                        "type": "string",
                        "nullable": true
                    },
                    "isActive": {
                        "type": "boolean"
                    },
                    "createdAt": {
                        "type": "string",
                        "format": "date-time"
                    }
                },
                "additionalProperties": false
            },
            "AlertSubscriberUpdateRequest": {
                "required": ["email", "name"],
                "type": "object",
                "properties": {
                    "email": {
                        "maxLength": 320,
                        "minLength": 0,
                        "type": "string",
                        "format": "email"
                    },
                    "name": {
                        "maxLength": 200,
                        "minLength": 0,
                        "type": "string"
                    },
                    "isActive": {
                        "type": "boolean"
                    }
                },
                "additionalProperties": false
            },
            "AlreadyConsolidatedItemResult": {
                "type": "object",
                "properties": {
                    "id": {
                        "type": "string",
                        "format": "uuid"
                    },
                    "poNumber": {
                        "type": "string",
                        "nullable": true
                    },
                    "vendorName": {
                        "type": "string",
                        "nullable": true
                    },
                    "virtualPoId": {
                        "type": "string",
                        "format": "uuid"
                    },
                    "virtualPoNumber": {
                        "type": "string",
                        "nullable": true
                    }
                },
                "additionalProperties": false
            },
            "AnagraphicImportResult": {
                "type": "object",
                "properties": {
                    "vendorsSeedCode": {
                        "type": "string",
                        "nullable": true
                    },
                    "vesselsSeedCode": {
                        "type": "string",
                        "nullable": true
                    },
                    "countriesSeedCode": {
                        "type": "string",
                        "nullable": true
                    },
                    "localitiesSeedCode": {
                        "type": "string",
                        "nullable": true
                    },
                    "statusesSeedCode": {
                        "type": "string",
                        "nullable": true
                    },
                    "vendorsCount": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "vesselsCount": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "countriesCount": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "localitiesCount": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "statusesCount": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "warnings": {
                        "type": "array",
                        "items": {
                            "type": "string"
                        },
                        "nullable": true
                    }
                },
                "additionalProperties": false
            },
            "AnonymousQrCodeScanRequest": {
                "required": ["latitude", "locality", "longitude", "qrCodeId"],
                "type": "object",
                "properties": {
                    "qrCodeId": {
                        "type": "string",
                        "format": "uuid"
                    },
                    "locality": {
                        "maxLength": 200,
                        "minLength": 1,
                        "type": "string"
                    },
                    "notes": {
                        "maxLength": 500,
                        "type": "string",
                        "nullable": true
                    },
                    "latitude": {
                        "type": "number",
                        "format": "double"
                    },
                    "longitude": {
                        "type": "number",
                        "format": "double"
                    }
                },
                "additionalProperties": false
            },
            "ApplicationLogStatisticsResult": {
                "type": "object",
                "properties": {
                    "total": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "errors": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "warnings": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "critical": {
                        "type": "integer",
                        "format": "int32"
                    }
                },
                "additionalProperties": false
            },
            "ChartDataPointResult": {
                "type": "object",
                "properties": {
                    "label": {
                        "type": "string",
                        "nullable": true
                    },
                    "value": {
                        "type": "number",
                        "format": "double"
                    }
                },
                "additionalProperties": false
            },
            "ClearDataResult": {
                "type": "object",
                "properties": {
                    "attachmentsDeleted": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "scansDeleted": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "documentsDeleted": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "picturesDeleted": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "routeChangeLogsDeleted": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "webhooksDeleted": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "pendingConfirmationsDeleted": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "qrCodesDeleted": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "purchaseOrdersDeleted": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "routeSegmentsDeleted": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "virtualPurchaseOrderLinksDeleted": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "noConformitiesDeleted": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "lgaDocumentsDeleted": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "warehousesDeleted": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "activitiesDeleted": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "usersDeleted": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "totalDeleted": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "duration": {
                        "type": "string",
                        "format": "date-span"
                    },
                    "message": {
                        "type": "string",
                        "nullable": true
                    },
                    "preservedTables": {
                        "type": "array",
                        "items": {
                            "type": "string"
                        },
                        "nullable": true
                    }
                },
                "additionalProperties": false
            },
            "CommentAttachmentResult": {
                "type": "object",
                "properties": {
                    "id": {
                        "type": "string",
                        "format": "uuid"
                    },
                    "fileName": {
                        "type": "string",
                        "nullable": true
                    },
                    "fileSize": {
                        "type": "integer",
                        "format": "int64"
                    },
                    "fileType": {
                        "type": "string",
                        "nullable": true
                    },
                    "url": {
                        "type": "string",
                        "nullable": true
                    },
                    "uploadedAt": {
                        "type": "string",
                        "format": "date-time"
                    }
                },
                "additionalProperties": false
            },
            "ContainedPurchaseOrderResult": {
                "type": "object",
                "properties": {
                    "id": {
                        "type": "string",
                        "format": "uuid"
                    },
                    "scanId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "poNumber": {
                        "type": "string",
                        "nullable": true
                    },
                    "lgaUniqueId": {
                        "type": "string",
                        "nullable": true
                    },
                    "description": {
                        "type": "string",
                        "nullable": true
                    },
                    "vendorName": {
                        "type": "string",
                        "nullable": true
                    },
                    "statusId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "statusName": {
                        "type": "string",
                        "nullable": true
                    }
                },
                "additionalProperties": false
            },
            "CountryCreateRequest": {
                "required": ["name"],
                "type": "object",
                "properties": {
                    "name": {
                        "minLength": 1,
                        "type": "string"
                    },
                    "code": {
                        "type": "string",
                        "nullable": true
                    },
                    "isActive": {
                        "type": "boolean"
                    }
                },
                "additionalProperties": false
            },
            "CountryLookupResult": {
                "type": "object",
                "properties": {
                    "id": {
                        "type": "string",
                        "format": "uuid"
                    },
                    "name": {
                        "type": "string",
                        "nullable": true
                    },
                    "code": {
                        "type": "string",
                        "nullable": true
                    },
                    "isActive": {
                        "type": "boolean"
                    }
                },
                "additionalProperties": false
            },
            "CountryUpdateRequest": {
                "required": ["name"],
                "type": "object",
                "properties": {
                    "name": {
                        "minLength": 1,
                        "type": "string"
                    },
                    "code": {
                        "type": "string",
                        "nullable": true
                    },
                    "isActive": {
                        "type": "boolean"
                    }
                },
                "additionalProperties": false
            },
            "CreatePermissionRequest": {
                "type": "object",
                "properties": {
                    "name": {
                        "type": "string",
                        "nullable": true
                    },
                    "description": {
                        "type": "string",
                        "nullable": true
                    }
                },
                "additionalProperties": false
            },
            "CreateRoleRequest": {
                "type": "object",
                "properties": {
                    "name": {
                        "type": "string",
                        "nullable": true
                    },
                    "description": {
                        "type": "string",
                        "nullable": true
                    }
                },
                "additionalProperties": false
            },
            "CreateUserRequest": {
                "type": "object",
                "properties": {
                    "email": {
                        "type": "string",
                        "nullable": true
                    },
                    "firstName": {
                        "type": "string",
                        "nullable": true
                    },
                    "lastName": {
                        "type": "string",
                        "nullable": true
                    },
                    "sendWelcomeEmail": {
                        "type": "boolean"
                    },
                    "vendorId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "portAgentId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "warehouseId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "vesselId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    }
                },
                "additionalProperties": false
            },
            "CreateVirtualPurchaseOrderRequest": {
                "required": ["virtualPoNumber"],
                "type": "object",
                "properties": {
                    "virtualPoNumber": {
                        "maxLength": 100,
                        "minLength": 1,
                        "type": "string"
                    },
                    "description": {
                        "maxLength": 1000,
                        "type": "string",
                        "nullable": true
                    },
                    "warehouseId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "statusId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "vesselId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "issuedBy": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "targetDob": {
                        "type": "string",
                        "format": "date-time",
                        "nullable": true
                    },
                    "purchaseOrderIds": {
                        "type": "array",
                        "items": {
                            "type": "string",
                            "format": "uuid"
                        },
                        "nullable": true
                    },
                    "lgaDocumentIds": {
                        "type": "array",
                        "items": {
                            "type": "string",
                            "format": "uuid"
                        },
                        "nullable": true
                    }
                },
                "additionalProperties": false
            },
            "DashboardKpisResult": {
                "type": "object",
                "properties": {
                    "totalShipments": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "shipmentsWeekOverWeekChange": {
                        "type": "number",
                        "format": "double"
                    },
                    "averageTransitTime": {
                        "type": "number",
                        "format": "double"
                    },
                    "transitTimeWeekOverWeekChange": {
                        "type": "number",
                        "format": "double"
                    },
                    "onTimeDeliveryRate": {
                        "type": "number",
                        "format": "double"
                    },
                    "delayedShipments": {
                        "type": "integer",
                        "format": "int32"
                    }
                },
                "additionalProperties": false
            },
            "DashboardSettingResult": {
                "type": "object",
                "properties": {
                    "arrivedAtDestinationHours": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "expectedArrivalsWindowDays": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "updatedAt": {
                        "type": "string",
                        "format": "date-time"
                    },
                    "updatedBy": {
                        "type": "string",
                        "nullable": true
                    }
                },
                "additionalProperties": false
            },
            "DashboardSettingUpdateRequest": {
                "required": ["arrivedAtDestinationHours", "expectedArrivalsWindowDays"],
                "type": "object",
                "properties": {
                    "arrivedAtDestinationHours": {
                        "maximum": 720,
                        "minimum": 1,
                        "type": "integer",
                        "format": "int32"
                    },
                    "expectedArrivalsWindowDays": {
                        "maximum": 365,
                        "minimum": 1,
                        "type": "integer",
                        "format": "int32"
                    }
                },
                "additionalProperties": false
            },
            "DashboardStatisticsResult": {
                "type": "object",
                "properties": {
                    "totalShipments": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "shipmentsThisWeek": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "shipmentsLastWeek": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "weekOverWeekChange": {
                        "type": "number",
                        "format": "double"
                    },
                    "averageTransitTime": {
                        "type": "number",
                        "format": "double"
                    },
                    "averageTransitTimeLastWeek": {
                        "type": "number",
                        "format": "double"
                    },
                    "transitTimeChange": {
                        "type": "number",
                        "format": "double"
                    },
                    "onTimeDeliveryRate": {
                        "type": "number",
                        "format": "double"
                    },
                    "delayedShipments": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "inTransitShipments": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "deliveredShipments": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "arrivedLast48hCount": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "pendingConfirmationCount": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "travellingOnTheWayCount": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "waitingForRouteDefinitionCount": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "openLgaCount": {
                        "type": "integer",
                        "format": "int32"
                    }
                },
                "additionalProperties": false
            },
            "DocumentTypeCreateRequest": {
                "required": ["code", "name"],
                "type": "object",
                "properties": {
                    "code": {
                        "minLength": 1,
                        "type": "string"
                    },
                    "name": {
                        "minLength": 1,
                        "type": "string"
                    },
                    "icon": {
                        "type": "string",
                        "nullable": true
                    },
                    "isActive": {
                        "type": "boolean"
                    }
                },
                "additionalProperties": false
            },
            "DocumentTypeLookupResult": {
                "type": "object",
                "properties": {
                    "id": {
                        "type": "string",
                        "format": "uuid"
                    },
                    "code": {
                        "type": "string",
                        "nullable": true
                    },
                    "name": {
                        "type": "string",
                        "nullable": true
                    },
                    "icon": {
                        "type": "string",
                        "nullable": true
                    },
                    "isActive": {
                        "type": "boolean"
                    }
                },
                "additionalProperties": false
            },
            "DocumentTypeUpdateRequest": {
                "required": ["code", "name"],
                "type": "object",
                "properties": {
                    "code": {
                        "minLength": 1,
                        "type": "string"
                    },
                    "name": {
                        "minLength": 1,
                        "type": "string"
                    },
                    "icon": {
                        "type": "string",
                        "nullable": true
                    },
                    "isActive": {
                        "type": "boolean"
                    }
                },
                "additionalProperties": false
            },
            "DocumentationSectionCreateRequest": {
                "required": ["content", "title"],
                "type": "object",
                "properties": {
                    "title": {
                        "maxLength": 200,
                        "minLength": 1,
                        "type": "string"
                    },
                    "content": {
                        "minLength": 1,
                        "type": "string"
                    }
                },
                "additionalProperties": false
            },
            "DocumentationSectionReorderRequest": {
                "required": ["sectionIds"],
                "type": "object",
                "properties": {
                    "sectionIds": {
                        "type": "array",
                        "items": {
                            "type": "string",
                            "format": "uuid"
                        }
                    }
                },
                "additionalProperties": false
            },
            "DocumentationSectionResult": {
                "type": "object",
                "properties": {
                    "id": {
                        "type": "string",
                        "format": "uuid"
                    },
                    "roleCode": {
                        "type": "string",
                        "nullable": true
                    },
                    "title": {
                        "type": "string",
                        "nullable": true
                    },
                    "content": {
                        "type": "string",
                        "nullable": true
                    },
                    "orderIndex": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "createdAt": {
                        "type": "string",
                        "format": "date-time"
                    },
                    "updatedAt": {
                        "type": "string",
                        "format": "date-time"
                    }
                },
                "additionalProperties": false
            },
            "DocumentationSectionUpdateRequest": {
                "required": ["content", "title"],
                "type": "object",
                "properties": {
                    "title": {
                        "maxLength": 200,
                        "minLength": 1,
                        "type": "string"
                    },
                    "content": {
                        "minLength": 1,
                        "type": "string"
                    }
                },
                "additionalProperties": false
            },
            "FinancialReportByCurrencyResult": {
                "type": "object",
                "properties": {
                    "currency": {
                        "type": "string",
                        "nullable": true
                    },
                    "totalPoValue": {
                        "type": "number",
                        "format": "double"
                    },
                    "purchaseOrderCount": {
                        "type": "integer",
                        "format": "int32"
                    }
                },
                "additionalProperties": false
            },
            "FinancialReportByTransportTypeResult": {
                "type": "object",
                "properties": {
                    "transportTypeCode": {
                        "type": "string",
                        "nullable": true
                    },
                    "transportTypeName": {
                        "type": "string",
                        "nullable": true
                    },
                    "totalPoValue": {
                        "type": "number",
                        "format": "double"
                    },
                    "totalFreightEstimated": {
                        "type": "number",
                        "format": "double"
                    },
                    "totalFreightFinal": {
                        "type": "number",
                        "format": "double"
                    },
                    "purchaseOrderCount": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "shipmentCount": {
                        "type": "integer",
                        "format": "int32"
                    }
                },
                "additionalProperties": false
            },
            "FinancialReportByVendorResult": {
                "type": "object",
                "properties": {
                    "vendorName": {
                        "type": "string",
                        "nullable": true
                    },
                    "totalPoValue": {
                        "type": "number",
                        "format": "double"
                    },
                    "totalFreightEstimated": {
                        "type": "number",
                        "format": "double"
                    },
                    "totalFreightFinal": {
                        "type": "number",
                        "format": "double"
                    },
                    "purchaseOrderCount": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "shipmentCount": {
                        "type": "integer",
                        "format": "int32"
                    }
                },
                "additionalProperties": false
            },
            "FinancialReportByVesselResult": {
                "type": "object",
                "properties": {
                    "vesselName": {
                        "type": "string",
                        "nullable": true
                    },
                    "totalPoValue": {
                        "type": "number",
                        "format": "double"
                    },
                    "totalFreightEstimated": {
                        "type": "number",
                        "format": "double"
                    },
                    "totalFreightFinal": {
                        "type": "number",
                        "format": "double"
                    },
                    "purchaseOrderCount": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "shipmentCount": {
                        "type": "integer",
                        "format": "int32"
                    }
                },
                "additionalProperties": false
            },
            "FinancialReportResult": {
                "type": "object",
                "properties": {
                    "byTransportType": {
                        "type": "array",
                        "items": {
                            "$ref": "#/components/schemas/FinancialReportByTransportTypeResult"
                        },
                        "nullable": true
                    },
                    "byCurrency": {
                        "type": "array",
                        "items": {
                            "$ref": "#/components/schemas/FinancialReportByCurrencyResult"
                        },
                        "nullable": true
                    },
                    "byVessel": {
                        "type": "array",
                        "items": {
                            "$ref": "#/components/schemas/FinancialReportByVesselResult"
                        },
                        "nullable": true
                    },
                    "byVendor": {
                        "type": "array",
                        "items": {
                            "$ref": "#/components/schemas/FinancialReportByVendorResult"
                        },
                        "nullable": true
                    },
                    "totalPoValue": {
                        "type": "number",
                        "format": "double"
                    },
                    "totalFreightEstimated": {
                        "type": "number",
                        "format": "double"
                    },
                    "totalFreightFinal": {
                        "type": "number",
                        "format": "double"
                    },
                    "totalPurchaseOrderCount": {
                        "type": "integer",
                        "format": "int32"
                    }
                },
                "additionalProperties": false
            },
            "HazmatCreateRequest": {
                "required": ["code", "name"],
                "type": "object",
                "properties": {
                    "code": {
                        "minLength": 1,
                        "type": "string"
                    },
                    "name": {
                        "minLength": 1,
                        "type": "string"
                    },
                    "icon": {
                        "type": "string",
                        "nullable": true
                    },
                    "isActive": {
                        "type": "boolean"
                    }
                },
                "additionalProperties": false
            },
            "HazmatTypeLookupResult": {
                "type": "object",
                "properties": {
                    "id": {
                        "type": "string",
                        "format": "uuid"
                    },
                    "code": {
                        "type": "string",
                        "nullable": true
                    },
                    "name": {
                        "type": "string",
                        "nullable": true
                    },
                    "icon": {
                        "type": "string",
                        "nullable": true
                    },
                    "isActive": {
                        "type": "boolean"
                    }
                },
                "additionalProperties": false
            },
            "HazmatUpdateRequest": {
                "required": ["code", "name"],
                "type": "object",
                "properties": {
                    "code": {
                        "minLength": 1,
                        "type": "string"
                    },
                    "name": {
                        "minLength": 1,
                        "type": "string"
                    },
                    "icon": {
                        "type": "string",
                        "nullable": true
                    },
                    "isActive": {
                        "type": "boolean"
                    }
                },
                "additionalProperties": false
            },
            "HttpValidationProblemDetails": {
                "type": "object",
                "properties": {
                    "type": {
                        "type": "string",
                        "nullable": true
                    },
                    "title": {
                        "type": "string",
                        "nullable": true
                    },
                    "status": {
                        "type": "integer",
                        "format": "int32",
                        "nullable": true
                    },
                    "detail": {
                        "type": "string",
                        "nullable": true
                    },
                    "instance": {
                        "type": "string",
                        "nullable": true
                    },
                    "errors": {
                        "type": "object",
                        "additionalProperties": {
                            "type": "array",
                            "items": {
                                "type": "string"
                            }
                        },
                        "nullable": true
                    },
                    "errorCode": {
                        "type": "string",
                        "description": "Application-specific error code (e.g., 'USER_NOT_FOUND', 'DUPLICATE_ENTRY')",
                        "nullable": true
                    },
                    "validationErrors": {
                        "type": "object",
                        "additionalProperties": {
                            "type": "array",
                            "items": {
                                "type": "string"
                            }
                        },
                        "description": "Dictionary of field-level validation errors",
                        "nullable": true
                    }
                },
                "additionalProperties": {}
            },
            "ImpersonationResult": {
                "type": "object",
                "properties": {
                    "accessToken": {
                        "type": "string",
                        "nullable": true
                    },
                    "refreshToken": {
                        "type": "string",
                        "nullable": true
                    },
                    "expiresIn": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "id": {
                        "type": "string",
                        "nullable": true
                    },
                    "username": {
                        "type": "string",
                        "nullable": true
                    },
                    "firstName": {
                        "type": "string",
                        "nullable": true
                    },
                    "lastName": {
                        "type": "string",
                        "nullable": true
                    },
                    "email": {
                        "type": "string",
                        "nullable": true
                    },
                    "roles": {
                        "type": "array",
                        "items": {
                            "type": "string"
                        },
                        "nullable": true
                    }
                },
                "additionalProperties": false
            },
            "InvoiceStatusByMonthTypeReportResult": {
                "type": "object",
                "properties": {
                    "byMonth": {
                        "type": "array",
                        "items": {
                            "$ref": "#/components/schemas/InvoicingStatusByMonthResult"
                        },
                        "nullable": true
                    }
                },
                "additionalProperties": false
            },
            "InvoiceStatusByTotalsTypeReportResult": {
                "type": "object",
                "properties": {
                    "totals": {
                        "$ref": "#/components/schemas/InvoicingStatusTotalsResult"
                    }
                },
                "additionalProperties": false
            },
            "InvoiceStatusByTransportTypeReportResult": {
                "type": "object",
                "properties": {
                    "byTransportType": {
                        "type": "array",
                        "items": {
                            "$ref": "#/components/schemas/InvoicingStatusByTransportTypeResult"
                        },
                        "nullable": true
                    }
                },
                "additionalProperties": false
            },
            "InvoicingStatusByMonthResult": {
                "type": "object",
                "properties": {
                    "year": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "month": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "label": {
                        "type": "string",
                        "nullable": true
                    },
                    "invoicedCount": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "nonInvoicedCount": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "totalEstimatedAmount": {
                        "type": "number",
                        "format": "double"
                    },
                    "totalFinalAmount": {
                        "type": "number",
                        "format": "double"
                    },
                    "outstandingAmount": {
                        "type": "number",
                        "format": "double"
                    }
                },
                "additionalProperties": false
            },
            "InvoicingStatusByPortResult": {
                "type": "object",
                "properties": {
                    "portName": {
                        "type": "string",
                        "nullable": true
                    },
                    "invoicedCount": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "nonInvoicedCount": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "totalEstimatedAmount": {
                        "type": "number",
                        "format": "double"
                    },
                    "totalFinalAmount": {
                        "type": "number",
                        "format": "double"
                    },
                    "outstandingAmount": {
                        "type": "number",
                        "format": "double"
                    }
                },
                "additionalProperties": false
            },
            "InvoicingStatusByTransportTypeResult": {
                "type": "object",
                "properties": {
                    "transportTypeCode": {
                        "type": "string",
                        "nullable": true
                    },
                    "transportTypeName": {
                        "type": "string",
                        "nullable": true
                    },
                    "invoicedCount": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "nonInvoicedCount": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "totalEstimatedAmount": {
                        "type": "number",
                        "format": "double"
                    },
                    "totalFinalAmount": {
                        "type": "number",
                        "format": "double"
                    },
                    "outstandingAmount": {
                        "type": "number",
                        "format": "double"
                    },
                    "ports": {
                        "type": "array",
                        "items": {
                            "$ref": "#/components/schemas/InvoicingStatusByPortResult"
                        },
                        "nullable": true
                    }
                },
                "additionalProperties": false
            },
            "InvoicingStatusTotalsResult": {
                "type": "object",
                "properties": {
                    "totalSegments": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "invoicedCount": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "nonInvoicedCount": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "totalEstimatedAmount": {
                        "type": "number",
                        "format": "double"
                    },
                    "totalFinalAmount": {
                        "type": "number",
                        "format": "double"
                    },
                    "outstandingAmount": {
                        "type": "number",
                        "format": "double"
                    }
                },
                "additionalProperties": false
            },
            "LgaDocumentAttachmentResult": {
                "type": "object",
                "properties": {
                    "id": {
                        "type": "string",
                        "format": "uuid"
                    },
                    "lgaDocumentId": {
                        "type": "string",
                        "format": "uuid"
                    },
                    "fileName": {
                        "type": "string",
                        "nullable": true
                    },
                    "fileType": {
                        "type": "string",
                        "nullable": true
                    },
                    "kind": {
                        "type": "string",
                        "nullable": true
                    },
                    "documentTypeId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "documentType": {
                        "type": "string",
                        "nullable": true
                    },
                    "fileSizeBytes": {
                        "type": "integer",
                        "format": "int64"
                    },
                    "filePath": {
                        "type": "string",
                        "nullable": true
                    },
                    "thumbnailPath": {
                        "type": "string",
                        "nullable": true
                    },
                    "caption": {
                        "type": "string",
                        "nullable": true
                    },
                    "uploadedBy": {
                        "type": "string",
                        "nullable": true
                    },
                    "uploadedAt": {
                        "type": "string",
                        "format": "date-time"
                    }
                },
                "additionalProperties": false
            },
            "LgaDocumentCreateRequest": {
                "required": [
                    "lineItems",
                    "offloadDate",
                    "portLanded",
                    "reasonForLandingId",
                    "requestorName",
                    "shippingMethodId",
                    "status",
                    "vesselName"
                ],
                "type": "object",
                "properties": {
                    "status": {
                        "$ref": "#/components/schemas/LgaDocumentStatusEnum"
                    },
                    "vesselId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "vesselName": {
                        "maxLength": 200,
                        "minLength": 0,
                        "type": "string"
                    },
                    "portLanded": {
                        "maxLength": 200,
                        "minLength": 0,
                        "type": "string"
                    },
                    "reasonForLandingId": {
                        "type": "string",
                        "format": "uuid"
                    },
                    "offloadDate": {
                        "type": "string",
                        "format": "date-time"
                    },
                    "notes": {
                        "maxLength": 2000,
                        "minLength": 0,
                        "type": "string",
                        "nullable": true
                    },
                    "landedWith": {
                        "maxLength": 500,
                        "minLength": 0,
                        "type": "string",
                        "nullable": true
                    },
                    "requestorName": {
                        "maxLength": 200,
                        "minLength": 0,
                        "type": "string"
                    },
                    "requestorPhone": {
                        "maxLength": 50,
                        "minLength": 0,
                        "type": "string",
                        "format": "tel",
                        "nullable": true
                    },
                    "requestorEmail": {
                        "maxLength": 200,
                        "minLength": 0,
                        "type": "string",
                        "format": "email",
                        "nullable": true
                    },
                    "destinationAddress": {
                        "maxLength": 500,
                        "minLength": 0,
                        "type": "string",
                        "nullable": true
                    },
                    "destinationCompany": {
                        "maxLength": 300,
                        "minLength": 0,
                        "type": "string",
                        "nullable": true
                    },
                    "destinationCity": {
                        "maxLength": 200,
                        "minLength": 0,
                        "type": "string",
                        "nullable": true
                    },
                    "destinationState": {
                        "maxLength": 200,
                        "minLength": 0,
                        "type": "string",
                        "nullable": true
                    },
                    "destinationCountry": {
                        "maxLength": 200,
                        "minLength": 0,
                        "type": "string",
                        "nullable": true
                    },
                    "destinationContact": {
                        "maxLength": 200,
                        "minLength": 0,
                        "type": "string",
                        "nullable": true
                    },
                    "destinationPhone": {
                        "maxLength": 50,
                        "minLength": 0,
                        "type": "string",
                        "format": "tel",
                        "nullable": true
                    },
                    "consigneeName": {
                        "maxLength": 200,
                        "minLength": 0,
                        "type": "string",
                        "nullable": true
                    },
                    "shippingMethodId": {
                        "type": "string",
                        "format": "uuid"
                    },
                    "shippingMethodDetails": {
                        "maxLength": 500,
                        "minLength": 0,
                        "type": "string",
                        "nullable": true
                    },
                    "specialInstructions": {
                        "maxLength": 2000,
                        "minLength": 0,
                        "type": "string",
                        "nullable": true
                    },
                    "personOffloading": {
                        "maxLength": 200,
                        "minLength": 0,
                        "type": "string",
                        "nullable": true
                    },
                    "chiefEngineer": {
                        "maxLength": 200,
                        "minLength": 0,
                        "type": "string",
                        "nullable": true
                    },
                    "master": {
                        "maxLength": 200,
                        "minLength": 0,
                        "type": "string",
                        "nullable": true
                    },
                    "lineItems": {
                        "minItems": 1,
                        "type": "array",
                        "items": {
                            "$ref": "#/components/schemas/LgaLineItemRequest"
                        }
                    }
                },
                "additionalProperties": false
            },
            "LgaDocumentListDto": {
                "type": "object",
                "properties": {
                    "id": {
                        "type": "string",
                        "format": "uuid"
                    },
                    "lgaUniqueId": {
                        "type": "string",
                        "nullable": true
                    },
                    "status": {
                        "$ref": "#/components/schemas/LgaDocumentStatusEnum"
                    },
                    "statusId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "statusName": {
                        "type": "string",
                        "nullable": true
                    },
                    "vesselId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "vesselName": {
                        "type": "string",
                        "nullable": true
                    },
                    "portLanded": {
                        "type": "string",
                        "nullable": true
                    },
                    "numberOfPackages": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "reasonForLandingId": {
                        "type": "string",
                        "format": "uuid"
                    },
                    "reasonForLandingName": {
                        "type": "string",
                        "nullable": true
                    },
                    "offloadDate": {
                        "type": "string",
                        "format": "date-time"
                    },
                    "departureDate": {
                        "type": "string",
                        "format": "date-time",
                        "nullable": true
                    },
                    "arrivalDate": {
                        "type": "string",
                        "format": "date-time",
                        "nullable": true
                    },
                    "requestorName": {
                        "type": "string",
                        "nullable": true
                    },
                    "destinationCompany": {
                        "type": "string",
                        "nullable": true
                    },
                    "destinationCountry": {
                        "type": "string",
                        "nullable": true
                    },
                    "shippingMethodId": {
                        "type": "string",
                        "format": "uuid"
                    },
                    "shippingMethodName": {
                        "type": "string",
                        "nullable": true
                    },
                    "createdBy": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "createdByName": {
                        "type": "string",
                        "nullable": true
                    },
                    "createdAt": {
                        "type": "string",
                        "format": "date-time"
                    },
                    "updatedAt": {
                        "type": "string",
                        "format": "date-time",
                        "nullable": true
                    }
                },
                "additionalProperties": false
            },
            "LgaDocumentResult": {
                "type": "object",
                "properties": {
                    "id": {
                        "type": "string",
                        "format": "uuid"
                    },
                    "lgaUniqueId": {
                        "type": "string",
                        "nullable": true
                    },
                    "status": {
                        "$ref": "#/components/schemas/LgaDocumentStatusEnum"
                    },
                    "statusId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "statusName": {
                        "type": "string",
                        "nullable": true
                    },
                    "vesselId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "vesselName": {
                        "type": "string",
                        "nullable": true
                    },
                    "portLanded": {
                        "type": "string",
                        "nullable": true
                    },
                    "numberOfPackages": {
                        "type": "integer",
                        "format": "int32",
                        "readOnly": true
                    },
                    "reasonForLandingId": {
                        "type": "string",
                        "format": "uuid"
                    },
                    "reasonForLandingName": {
                        "type": "string",
                        "nullable": true
                    },
                    "offloadDate": {
                        "type": "string",
                        "format": "date-time"
                    },
                    "notes": {
                        "type": "string",
                        "nullable": true
                    },
                    "landedWith": {
                        "type": "string",
                        "nullable": true
                    },
                    "requestorName": {
                        "type": "string",
                        "nullable": true
                    },
                    "requestorPhone": {
                        "type": "string",
                        "nullable": true
                    },
                    "requestorEmail": {
                        "type": "string",
                        "nullable": true
                    },
                    "destinationAddress": {
                        "type": "string",
                        "nullable": true
                    },
                    "destinationCompany": {
                        "type": "string",
                        "nullable": true
                    },
                    "destinationCity": {
                        "type": "string",
                        "nullable": true
                    },
                    "destinationState": {
                        "type": "string",
                        "nullable": true
                    },
                    "destinationCountry": {
                        "type": "string",
                        "nullable": true
                    },
                    "destinationContact": {
                        "type": "string",
                        "nullable": true
                    },
                    "destinationPhone": {
                        "type": "string",
                        "nullable": true
                    },
                    "consigneeName": {
                        "type": "string",
                        "nullable": true
                    },
                    "shippingMethodId": {
                        "type": "string",
                        "format": "uuid"
                    },
                    "shippingMethodName": {
                        "type": "string",
                        "nullable": true
                    },
                    "shippingMethodDetails": {
                        "type": "string",
                        "nullable": true
                    },
                    "specialInstructions": {
                        "type": "string",
                        "nullable": true
                    },
                    "personOffloading": {
                        "type": "string",
                        "nullable": true
                    },
                    "chiefEngineer": {
                        "type": "string",
                        "nullable": true
                    },
                    "master": {
                        "type": "string",
                        "nullable": true
                    },
                    "createdBy": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "createdByName": {
                        "type": "string",
                        "nullable": true
                    },
                    "createdAt": {
                        "type": "string",
                        "format": "date-time"
                    },
                    "updatedAt": {
                        "type": "string",
                        "format": "date-time",
                        "nullable": true
                    },
                    "lineItems": {
                        "type": "array",
                        "items": {
                            "$ref": "#/components/schemas/LgaLineItemResult"
                        },
                        "nullable": true
                    }
                },
                "additionalProperties": false
            },
            "LgaDocumentStatusEnum": {
                "enum": ["DRAFT", "PENDING", "APPROVED", "COMPLETED", "CANCELLED"],
                "type": "string"
            },
            "LgaDocumentUpdateRequest": {
                "required": [
                    "offloadDate",
                    "portLanded",
                    "reasonForLandingId",
                    "requestorName",
                    "shippingMethodId",
                    "status",
                    "vesselName"
                ],
                "type": "object",
                "properties": {
                    "status": {
                        "$ref": "#/components/schemas/LgaDocumentStatusEnum"
                    },
                    "vesselId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "vesselName": {
                        "maxLength": 200,
                        "minLength": 0,
                        "type": "string"
                    },
                    "portLanded": {
                        "maxLength": 200,
                        "minLength": 0,
                        "type": "string"
                    },
                    "reasonForLandingId": {
                        "type": "string",
                        "format": "uuid"
                    },
                    "offloadDate": {
                        "type": "string",
                        "format": "date-time"
                    },
                    "notes": {
                        "maxLength": 2000,
                        "minLength": 0,
                        "type": "string",
                        "nullable": true
                    },
                    "landedWith": {
                        "maxLength": 500,
                        "minLength": 0,
                        "type": "string",
                        "nullable": true
                    },
                    "requestorName": {
                        "maxLength": 200,
                        "minLength": 0,
                        "type": "string"
                    },
                    "requestorPhone": {
                        "maxLength": 50,
                        "minLength": 0,
                        "type": "string",
                        "format": "tel",
                        "nullable": true
                    },
                    "requestorEmail": {
                        "maxLength": 200,
                        "minLength": 0,
                        "type": "string",
                        "format": "email",
                        "nullable": true
                    },
                    "destinationAddress": {
                        "maxLength": 500,
                        "minLength": 0,
                        "type": "string",
                        "nullable": true
                    },
                    "destinationCompany": {
                        "maxLength": 300,
                        "minLength": 0,
                        "type": "string",
                        "nullable": true
                    },
                    "destinationCity": {
                        "maxLength": 200,
                        "minLength": 0,
                        "type": "string",
                        "nullable": true
                    },
                    "destinationState": {
                        "maxLength": 200,
                        "minLength": 0,
                        "type": "string",
                        "nullable": true
                    },
                    "destinationCountry": {
                        "maxLength": 200,
                        "minLength": 0,
                        "type": "string",
                        "nullable": true
                    },
                    "destinationContact": {
                        "maxLength": 200,
                        "minLength": 0,
                        "type": "string",
                        "nullable": true
                    },
                    "destinationPhone": {
                        "maxLength": 50,
                        "minLength": 0,
                        "type": "string",
                        "format": "tel",
                        "nullable": true
                    },
                    "consigneeName": {
                        "maxLength": 200,
                        "minLength": 0,
                        "type": "string",
                        "nullable": true
                    },
                    "shippingMethodId": {
                        "type": "string",
                        "format": "uuid"
                    },
                    "shippingMethodDetails": {
                        "maxLength": 500,
                        "minLength": 0,
                        "type": "string",
                        "nullable": true
                    },
                    "specialInstructions": {
                        "maxLength": 2000,
                        "minLength": 0,
                        "type": "string",
                        "nullable": true
                    },
                    "personOffloading": {
                        "maxLength": 200,
                        "minLength": 0,
                        "type": "string",
                        "nullable": true
                    },
                    "chiefEngineer": {
                        "maxLength": 200,
                        "minLength": 0,
                        "type": "string",
                        "nullable": true
                    },
                    "master": {
                        "maxLength": 200,
                        "minLength": 0,
                        "type": "string",
                        "nullable": true
                    }
                },
                "additionalProperties": false
            },
            "LgaLineItemRequest": {
                "required": ["description", "hazmatId", "lineNumber", "quantity", "valueAmount", "valueCurrencyId", "weightKg"],
                "type": "object",
                "properties": {
                    "id": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "lineNumber": {
                        "maximum": 2147483647,
                        "minimum": 1,
                        "type": "integer",
                        "format": "int32"
                    },
                    "description": {
                        "maxLength": 1000,
                        "minLength": 0,
                        "type": "string"
                    },
                    "quantity": {
                        "maximum": 2147483647,
                        "minimum": 1,
                        "type": "integer",
                        "format": "int32"
                    },
                    "hazmatId": {
                        "type": "string",
                        "format": "uuid"
                    },
                    "weightKg": {
                        "minimum": 0.01,
                        "type": "number",
                        "format": "double"
                    },
                    "valueAmount": {
                        "minimum": 0,
                        "type": "number",
                        "format": "double"
                    },
                    "valueCurrencyId": {
                        "type": "string",
                        "format": "uuid"
                    }
                },
                "additionalProperties": false
            },
            "LgaLineItemResult": {
                "type": "object",
                "properties": {
                    "id": {
                        "type": "string",
                        "format": "uuid"
                    },
                    "lgaDocumentId": {
                        "type": "string",
                        "format": "uuid"
                    },
                    "lineNumber": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "description": {
                        "type": "string",
                        "nullable": true
                    },
                    "quantity": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "hazmatId": {
                        "type": "string",
                        "format": "uuid"
                    },
                    "hazmatName": {
                        "type": "string",
                        "nullable": true
                    },
                    "weightKg": {
                        "type": "number",
                        "format": "double"
                    },
                    "valueAmount": {
                        "type": "number",
                        "format": "double"
                    },
                    "valueCurrencyId": {
                        "type": "string",
                        "format": "uuid"
                    },
                    "valueCurrencyName": {
                        "type": "string",
                        "nullable": true
                    },
                    "createdAt": {
                        "type": "string",
                        "format": "date-time"
                    },
                    "updatedAt": {
                        "type": "string",
                        "format": "date-time",
                        "nullable": true
                    }
                },
                "additionalProperties": false
            },
            "LgaLocationScanRequest": {
                "type": "object",
                "properties": {
                    "localityId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "warehouseId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "vesselId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "transportTypeId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "statusId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "statusOptionId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "notes": {
                        "maxLength": 500,
                        "type": "string",
                        "nullable": true
                    },
                    "latitude": {
                        "type": "number",
                        "format": "double",
                        "nullable": true
                    },
                    "longitude": {
                        "type": "number",
                        "format": "double",
                        "nullable": true
                    },
                    "scanDate": {
                        "type": "string",
                        "format": "date-time",
                        "nullable": true
                    },
                    "image": {
                        "type": "string",
                        "format": "binary",
                        "nullable": true
                    }
                },
                "additionalProperties": false
            },
            "LgaQrCodeResult": {
                "type": "object",
                "properties": {
                    "lgaDocumentId": {
                        "type": "string",
                        "format": "uuid"
                    },
                    "lgaUniqueId": {
                        "type": "string",
                        "nullable": true
                    },
                    "base64Image": {
                        "type": "string",
                        "nullable": true
                    },
                    "contentType": {
                        "type": "string",
                        "nullable": true
                    },
                    "encodedData": {
                        "type": "string",
                        "nullable": true
                    }
                },
                "additionalProperties": false
            },
            "LgaReasonForLandingCreateRequest": {
                "required": ["code", "name"],
                "type": "object",
                "properties": {
                    "code": {
                        "minLength": 1,
                        "type": "string"
                    },
                    "name": {
                        "minLength": 1,
                        "type": "string"
                    },
                    "icon": {
                        "type": "string",
                        "nullable": true
                    },
                    "isActive": {
                        "type": "boolean"
                    }
                },
                "additionalProperties": false
            },
            "LgaReasonForLandingUpdateRequest": {
                "required": ["code", "name"],
                "type": "object",
                "properties": {
                    "code": {
                        "minLength": 1,
                        "type": "string"
                    },
                    "name": {
                        "minLength": 1,
                        "type": "string"
                    },
                    "icon": {
                        "type": "string",
                        "nullable": true
                    },
                    "isActive": {
                        "type": "boolean"
                    }
                },
                "additionalProperties": false
            },
            "LgaReasonsTypeLookupResult": {
                "type": "object",
                "properties": {
                    "id": {
                        "type": "string",
                        "format": "uuid"
                    },
                    "code": {
                        "type": "string",
                        "nullable": true
                    },
                    "name": {
                        "type": "string",
                        "nullable": true
                    },
                    "icon": {
                        "type": "string",
                        "nullable": true
                    },
                    "isActive": {
                        "type": "boolean"
                    }
                },
                "additionalProperties": false
            },
            "LgaShippingMethodCreateRequest": {
                "required": ["code", "name"],
                "type": "object",
                "properties": {
                    "code": {
                        "minLength": 1,
                        "type": "string"
                    },
                    "name": {
                        "minLength": 1,
                        "type": "string"
                    },
                    "icon": {
                        "type": "string",
                        "nullable": true
                    },
                    "isActive": {
                        "type": "boolean"
                    }
                },
                "additionalProperties": false
            },
            "LgaShippingMethodTypeLookupResult": {
                "type": "object",
                "properties": {
                    "id": {
                        "type": "string",
                        "format": "uuid"
                    },
                    "code": {
                        "type": "string",
                        "nullable": true
                    },
                    "name": {
                        "type": "string",
                        "nullable": true
                    },
                    "icon": {
                        "type": "string",
                        "nullable": true
                    },
                    "isActive": {
                        "type": "boolean"
                    }
                },
                "additionalProperties": false
            },
            "LgaShippingMethodUpdateRequest": {
                "required": ["code", "name"],
                "type": "object",
                "properties": {
                    "code": {
                        "minLength": 1,
                        "type": "string"
                    },
                    "name": {
                        "minLength": 1,
                        "type": "string"
                    },
                    "icon": {
                        "type": "string",
                        "nullable": true
                    },
                    "isActive": {
                        "type": "boolean"
                    }
                },
                "additionalProperties": false
            },
            "LoadResult": {
                "type": "object",
                "properties": {
                    "data": {
                        "type": "array",
                        "items": {},
                        "nullable": true
                    },
                    "totalCount": {
                        "type": "integer",
                        "format": "int32",
                        "default": -1
                    },
                    "groupCount": {
                        "type": "integer",
                        "format": "int32",
                        "default": -1
                    },
                    "summary": {
                        "type": "array",
                        "items": {},
                        "nullable": true
                    }
                },
                "additionalProperties": false
            },
            "LocalityCreateRequest": {
                "required": ["code", "name"],
                "type": "object",
                "properties": {
                    "code": {
                        "minLength": 1,
                        "type": "string"
                    },
                    "name": {
                        "minLength": 1,
                        "type": "string"
                    },
                    "countryId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "latitude": {
                        "type": "number",
                        "format": "double",
                        "nullable": true
                    },
                    "longitude": {
                        "type": "number",
                        "format": "double",
                        "nullable": true
                    },
                    "isActive": {
                        "type": "boolean"
                    }
                },
                "additionalProperties": false
            },
            "LocalityLookupResult": {
                "type": "object",
                "properties": {
                    "id": {
                        "type": "string",
                        "format": "uuid"
                    },
                    "code": {
                        "type": "string",
                        "nullable": true
                    },
                    "name": {
                        "type": "string",
                        "nullable": true
                    },
                    "isActive": {
                        "type": "boolean"
                    },
                    "countryId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "countryName": {
                        "type": "string",
                        "nullable": true
                    },
                    "latitude": {
                        "type": "number",
                        "format": "double",
                        "nullable": true
                    },
                    "longitude": {
                        "type": "number",
                        "format": "double",
                        "nullable": true
                    }
                },
                "additionalProperties": false
            },
            "LocalityUpdateRequest": {
                "required": ["code", "name"],
                "type": "object",
                "properties": {
                    "code": {
                        "minLength": 1,
                        "type": "string"
                    },
                    "name": {
                        "minLength": 1,
                        "type": "string"
                    },
                    "countryId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "latitude": {
                        "type": "number",
                        "format": "double",
                        "nullable": true
                    },
                    "longitude": {
                        "type": "number",
                        "format": "double",
                        "nullable": true
                    },
                    "isActive": {
                        "type": "boolean"
                    }
                },
                "additionalProperties": false
            },
            "MockDataGenerationOptions": {
                "type": "object",
                "properties": {
                    "userCount": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "warehouseCount": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "qrCodeCount": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "scanCount": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "purchaseOrderCount": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "pendingConfirmationCount": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "clearExistingData": {
                        "type": "boolean"
                    },
                    "seed": {
                        "type": "integer",
                        "format": "int32",
                        "nullable": true
                    }
                },
                "additionalProperties": false
            },
            "MockDataGenerationResult": {
                "type": "object",
                "properties": {
                    "usersGenerated": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "qrCodesGenerated": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "scansGenerated": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "purchaseOrdersGenerated": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "pendingConfirmationsGenerated": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "duration": {
                        "type": "string",
                        "format": "date-span"
                    },
                    "message": {
                        "type": "string",
                        "nullable": true
                    }
                },
                "additionalProperties": false
            },
            "NoConformityAssignRequest": {
                "type": "object",
                "properties": {
                    "assignedTo": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    }
                },
                "additionalProperties": false
            },
            "NoConformityAttachmentResult": {
                "type": "object",
                "properties": {
                    "id": {
                        "type": "string",
                        "format": "uuid"
                    },
                    "fileName": {
                        "type": "string",
                        "nullable": true
                    },
                    "fileSize": {
                        "type": "integer",
                        "format": "int64"
                    },
                    "mimeType": {
                        "type": "string",
                        "nullable": true
                    },
                    "url": {
                        "type": "string",
                        "nullable": true
                    },
                    "thumbnailUrl": {
                        "type": "string",
                        "nullable": true
                    },
                    "caption": {
                        "type": "string",
                        "nullable": true
                    },
                    "uploadedAt": {
                        "type": "string",
                        "format": "date-time"
                    },
                    "uploadedBy": {
                        "type": "string",
                        "format": "uuid"
                    },
                    "uploadedByName": {
                        "type": "string",
                        "nullable": true
                    }
                },
                "additionalProperties": false
            },
            "NoConformityCommentResult": {
                "type": "object",
                "properties": {
                    "id": {
                        "type": "string",
                        "format": "uuid"
                    },
                    "userId": {
                        "type": "string",
                        "format": "uuid"
                    },
                    "userName": {
                        "type": "string",
                        "nullable": true
                    },
                    "comment": {
                        "type": "string",
                        "nullable": true
                    },
                    "timestamp": {
                        "type": "string",
                        "format": "date-time"
                    },
                    "isInternal": {
                        "type": "boolean"
                    },
                    "attachments": {
                        "type": "array",
                        "items": {
                            "$ref": "#/components/schemas/CommentAttachmentResult"
                        },
                        "nullable": true
                    }
                },
                "additionalProperties": false
            },
            "NoConformityCreateRequest": {
                "required": ["description", "severity", "title", "type"],
                "type": "object",
                "properties": {
                    "title": {
                        "maxLength": 200,
                        "minLength": 0,
                        "type": "string"
                    },
                    "type": {
                        "$ref": "#/components/schemas/NoConformityTypeEnum"
                    },
                    "severity": {
                        "$ref": "#/components/schemas/NoConformitySeverityEnum"
                    },
                    "description": {
                        "maxLength": 4000,
                        "minLength": 0,
                        "type": "string"
                    },
                    "poId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "lgaDocumentId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "itemId": {
                        "maxLength": 100,
                        "minLength": 0,
                        "type": "string",
                        "nullable": true
                    },
                    "warehouseId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "portAgentId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "vendorId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "dueDate": {
                        "type": "string",
                        "format": "date-time",
                        "nullable": true
                    },
                    "isDraft": {
                        "type": "boolean"
                    }
                },
                "additionalProperties": false
            },
            "NoConformityDetailResult": {
                "type": "object",
                "properties": {
                    "id": {
                        "type": "string",
                        "format": "uuid"
                    },
                    "referenceNumber": {
                        "type": "string",
                        "nullable": true
                    },
                    "poId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "poNumber": {
                        "type": "string",
                        "nullable": true
                    },
                    "lgaDocumentId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "lgaUniqueId": {
                        "type": "string",
                        "nullable": true
                    },
                    "itemId": {
                        "type": "string",
                        "nullable": true
                    },
                    "warehouseId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "warehouse": {
                        "$ref": "#/components/schemas/WarehouseResult"
                    },
                    "portAgentId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "portAgentName": {
                        "type": "string",
                        "nullable": true
                    },
                    "vendorId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "vendorName": {
                        "type": "string",
                        "nullable": true
                    },
                    "type": {
                        "$ref": "#/components/schemas/NoConformityTypeEnum"
                    },
                    "status": {
                        "$ref": "#/components/schemas/NoConformityStatusEnum"
                    },
                    "severity": {
                        "$ref": "#/components/schemas/NoConformitySeverityEnum"
                    },
                    "title": {
                        "type": "string",
                        "nullable": true
                    },
                    "description": {
                        "type": "string",
                        "nullable": true
                    },
                    "rootCause": {
                        "type": "string",
                        "nullable": true
                    },
                    "correctiveAction": {
                        "type": "string",
                        "nullable": true
                    },
                    "preventiveAction": {
                        "type": "string",
                        "nullable": true
                    },
                    "resolution": {
                        "type": "string",
                        "nullable": true
                    },
                    "reportedAt": {
                        "type": "string",
                        "format": "date-time"
                    },
                    "reportedBy": {
                        "type": "string",
                        "format": "uuid"
                    },
                    "reportedByName": {
                        "type": "string",
                        "nullable": true
                    },
                    "createdBy": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "createdByName": {
                        "type": "string",
                        "nullable": true
                    },
                    "assignedTo": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "assignedToName": {
                        "type": "string",
                        "nullable": true
                    },
                    "dueDate": {
                        "type": "string",
                        "format": "date-time",
                        "nullable": true
                    },
                    "resolvedAt": {
                        "type": "string",
                        "format": "date-time",
                        "nullable": true
                    },
                    "resolvedBy": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "resolvedByName": {
                        "type": "string",
                        "nullable": true
                    },
                    "createdAt": {
                        "type": "string",
                        "format": "date-time"
                    },
                    "updatedAt": {
                        "type": "string",
                        "format": "date-time",
                        "nullable": true
                    },
                    "comments": {
                        "type": "array",
                        "items": {
                            "$ref": "#/components/schemas/NoConformityCommentResult"
                        },
                        "nullable": true
                    },
                    "attachments": {
                        "type": "array",
                        "items": {
                            "$ref": "#/components/schemas/NoConformityAttachmentResult"
                        },
                        "nullable": true
                    },
                    "statusChanges": {
                        "type": "array",
                        "items": {
                            "$ref": "#/components/schemas/NoConformityStatusChangeResult"
                        },
                        "nullable": true
                    },
                    "fieldChanges": {
                        "type": "array",
                        "items": {
                            "$ref": "#/components/schemas/NoConformityFieldChangeResult"
                        },
                        "nullable": true
                    }
                },
                "additionalProperties": false
            },
            "NoConformityFieldChangeResult": {
                "type": "object",
                "properties": {
                    "id": {
                        "type": "string",
                        "format": "uuid"
                    },
                    "fieldName": {
                        "type": "string",
                        "nullable": true
                    },
                    "oldValue": {
                        "type": "string",
                        "nullable": true
                    },
                    "newValue": {
                        "type": "string",
                        "nullable": true
                    },
                    "changedBy": {
                        "type": "string",
                        "format": "uuid"
                    },
                    "changedByName": {
                        "type": "string",
                        "nullable": true
                    },
                    "timestamp": {
                        "type": "string",
                        "format": "date-time"
                    }
                },
                "additionalProperties": false
            },
            "NoConformityHistoryResult": {
                "type": "object",
                "properties": {
                    "id": {
                        "type": "string",
                        "format": "uuid"
                    },
                    "type": {
                        "type": "string",
                        "nullable": true
                    },
                    "timestamp": {
                        "type": "string",
                        "format": "date-time"
                    },
                    "userName": {
                        "type": "string",
                        "nullable": true
                    },
                    "description": {
                        "type": "string",
                        "nullable": true
                    },
                    "details": {
                        "nullable": true
                    }
                },
                "additionalProperties": false
            },
            "NoConformitySeverityEnum": {
                "enum": ["LOW", "MEDIUM", "HIGH", "CRITICAL"],
                "type": "string"
            },
            "NoConformityStatusChangeRequest": {
                "required": ["status"],
                "type": "object",
                "properties": {
                    "status": {
                        "$ref": "#/components/schemas/NoConformityStatusEnum"
                    },
                    "comment": {
                        "maxLength": 2000,
                        "minLength": 0,
                        "type": "string",
                        "nullable": true
                    }
                },
                "additionalProperties": false
            },
            "NoConformityStatusChangeResult": {
                "type": "object",
                "properties": {
                    "id": {
                        "type": "string",
                        "format": "uuid"
                    },
                    "fromStatus": {
                        "$ref": "#/components/schemas/NoConformityStatusEnum"
                    },
                    "toStatus": {
                        "$ref": "#/components/schemas/NoConformityStatusEnum"
                    },
                    "changedBy": {
                        "type": "string",
                        "format": "uuid"
                    },
                    "changedByName": {
                        "type": "string",
                        "nullable": true
                    },
                    "timestamp": {
                        "type": "string",
                        "format": "date-time"
                    },
                    "comment": {
                        "type": "string",
                        "nullable": true
                    }
                },
                "additionalProperties": false
            },
            "NoConformityStatusEnum": {
                "enum": ["DRAFT", "OPEN", "IN_PROGRESS", "PENDING_REVIEW", "RESOLVED", "CLOSED", "REJECTED"],
                "type": "string"
            },
            "NoConformityStatusInfoResult": {
                "type": "object",
                "properties": {
                    "noConformityId": {
                        "type": "string",
                        "format": "uuid"
                    },
                    "referenceNumber": {
                        "type": "string",
                        "nullable": true
                    },
                    "currentStatus": {
                        "$ref": "#/components/schemas/NoConformityStatusEnum"
                    },
                    "previousStatus": {
                        "$ref": "#/components/schemas/NoConformityStatusEnum"
                    },
                    "allowedTransitions": {
                        "type": "array",
                        "items": {
                            "$ref": "#/components/schemas/NoConformityStatusEnum"
                        },
                        "nullable": true
                    }
                },
                "additionalProperties": false
            },
            "NoConformityTypeEnum": {
                "enum": ["DAMAGED", "MISSING", "WRONG_ITEM", "DELAYED_DELIVERY", "QUALITY_ISSUE", "DOCUMENTATION_ERROR"],
                "type": "string"
            },
            "NoConformityUpdateRequest": {
                "type": "object",
                "properties": {
                    "title": {
                        "maxLength": 200,
                        "minLength": 0,
                        "type": "string",
                        "nullable": true
                    },
                    "description": {
                        "maxLength": 4000,
                        "minLength": 0,
                        "type": "string",
                        "nullable": true
                    },
                    "type": {
                        "$ref": "#/components/schemas/NoConformityTypeEnum"
                    },
                    "severity": {
                        "$ref": "#/components/schemas/NoConformitySeverityEnum"
                    },
                    "rootCause": {
                        "maxLength": 4000,
                        "minLength": 0,
                        "type": "string",
                        "nullable": true
                    },
                    "correctiveAction": {
                        "maxLength": 4000,
                        "minLength": 0,
                        "type": "string",
                        "nullable": true
                    },
                    "preventiveAction": {
                        "maxLength": 4000,
                        "minLength": 0,
                        "type": "string",
                        "nullable": true
                    },
                    "resolution": {
                        "maxLength": 4000,
                        "minLength": 0,
                        "type": "string",
                        "nullable": true
                    },
                    "dueDate": {
                        "type": "string",
                        "format": "date-time",
                        "nullable": true
                    },
                    "poId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "lgaDocumentId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "warehouseId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "portAgentId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "vendorId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "itemId": {
                        "maxLength": 100,
                        "minLength": 0,
                        "type": "string",
                        "nullable": true
                    }
                },
                "additionalProperties": false
            },
            "PendingConfirmationResult": {
                "type": "object",
                "properties": {
                    "id": {
                        "type": "string",
                        "format": "uuid"
                    },
                    "poNumber": {
                        "type": "string",
                        "nullable": true
                    },
                    "sourceId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "sourceName": {
                        "type": "string",
                        "nullable": true
                    },
                    "vendorId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "vendorName": {
                        "type": "string",
                        "nullable": true
                    },
                    "description": {
                        "type": "string",
                        "nullable": true
                    },
                    "vesselId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "vesselName": {
                        "type": "string",
                        "nullable": true
                    },
                    "value": {
                        "type": "number",
                        "format": "double"
                    },
                    "currency": {
                        "type": "string",
                        "nullable": true
                    },
                    "issuedById": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "issuedByName": {
                        "type": "string",
                        "nullable": true
                    },
                    "confidenceScore": {
                        "type": "number",
                        "format": "double"
                    },
                    "warnings": {
                        "type": "array",
                        "items": {
                            "type": "string"
                        },
                        "nullable": true
                    },
                    "pendingConfirmationStatusId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "statusName": {
                        "type": "string",
                        "nullable": true
                    },
                    "isMops": {
                        "type": "boolean",
                        "nullable": true
                    },
                    "weight": {
                        "type": "number",
                        "format": "double",
                        "nullable": true
                    },
                    "targetDob": {
                        "type": "string",
                        "format": "date-time",
                        "nullable": true
                    },
                    "originalFileName": {
                        "type": "string",
                        "nullable": true
                    },
                    "createdAt": {
                        "type": "string",
                        "format": "date-time"
                    },
                    "reviewedAt": {
                        "type": "string",
                        "format": "date-time",
                        "nullable": true
                    },
                    "reviewedById": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "reviewedByName": {
                        "type": "string",
                        "nullable": true
                    }
                },
                "additionalProperties": false
            },
            "PendingConfirmationStatusCreateRequest": {
                "required": ["code", "name"],
                "type": "object",
                "properties": {
                    "code": {
                        "minLength": 1,
                        "type": "string"
                    },
                    "name": {
                        "minLength": 1,
                        "type": "string"
                    },
                    "description": {
                        "type": "string",
                        "nullable": true
                    },
                    "sortOrder": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "isActive": {
                        "type": "boolean"
                    }
                },
                "additionalProperties": false
            },
            "PendingConfirmationStatusLookupResult": {
                "type": "object",
                "properties": {
                    "id": {
                        "type": "string",
                        "format": "uuid"
                    },
                    "code": {
                        "type": "string",
                        "nullable": true
                    },
                    "name": {
                        "type": "string",
                        "nullable": true
                    },
                    "description": {
                        "type": "string",
                        "nullable": true
                    },
                    "sortOrder": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "isActive": {
                        "type": "boolean"
                    }
                },
                "additionalProperties": false
            },
            "PendingConfirmationStatusUpdateRequest": {
                "required": ["code", "name"],
                "type": "object",
                "properties": {
                    "code": {
                        "minLength": 1,
                        "type": "string"
                    },
                    "name": {
                        "minLength": 1,
                        "type": "string"
                    },
                    "description": {
                        "type": "string",
                        "nullable": true
                    },
                    "sortOrder": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "isActive": {
                        "type": "boolean"
                    }
                },
                "additionalProperties": false
            },
            "PermissionResult": {
                "type": "object",
                "properties": {
                    "name": {
                        "type": "string",
                        "nullable": true
                    },
                    "description": {
                        "type": "string",
                        "nullable": true
                    }
                },
                "additionalProperties": false
            },
            "PictureTypeCreateRequest": {
                "required": ["code", "name"],
                "type": "object",
                "properties": {
                    "code": {
                        "minLength": 1,
                        "type": "string"
                    },
                    "name": {
                        "minLength": 1,
                        "type": "string"
                    },
                    "isActive": {
                        "type": "boolean"
                    }
                },
                "additionalProperties": false
            },
            "PictureTypeLookupResult": {
                "type": "object",
                "properties": {
                    "id": {
                        "type": "string",
                        "format": "uuid"
                    },
                    "code": {
                        "type": "string",
                        "nullable": true
                    },
                    "name": {
                        "type": "string",
                        "nullable": true
                    },
                    "isActive": {
                        "type": "boolean"
                    }
                },
                "additionalProperties": false
            },
            "PictureTypeUpdateRequest": {
                "required": ["code", "name"],
                "type": "object",
                "properties": {
                    "code": {
                        "minLength": 1,
                        "type": "string"
                    },
                    "name": {
                        "minLength": 1,
                        "type": "string"
                    },
                    "isActive": {
                        "type": "boolean"
                    }
                },
                "additionalProperties": false
            },
            "PoExtractionData": {
                "type": "object",
                "properties": {
                    "source_system": {
                        "type": "string",
                        "nullable": true
                    },
                    "po_number": {
                        "type": "string",
                        "nullable": true
                    },
                    "vendor_name": {
                        "type": "string",
                        "nullable": true
                    },
                    "requested_by": {
                        "type": "string",
                        "nullable": true
                    },
                    "vessel_name": {
                        "type": "string",
                        "nullable": true
                    },
                    "total": {
                        "$ref": "#/components/schemas/PoTotal"
                    },
                    "items_description": {
                        "type": "string",
                        "nullable": true
                    },
                    "is_mops": {
                        "type": "boolean",
                        "nullable": true
                    }
                },
                "additionalProperties": false
            },
            "PoTotal": {
                "type": "object",
                "properties": {
                    "amount": {
                        "type": "string",
                        "nullable": true
                    },
                    "currency": {
                        "type": "string",
                        "nullable": true
                    }
                },
                "additionalProperties": false
            },
            "PoUploadResult": {
                "type": "object",
                "properties": {
                    "pendingConfirmationId": {
                        "type": "string",
                        "format": "uuid"
                    },
                    "poNumber": {
                        "type": "string",
                        "nullable": true
                    },
                    "message": {
                        "type": "string",
                        "nullable": true
                    },
                    "confidenceScore": {
                        "type": "number",
                        "format": "double"
                    },
                    "warnings": {
                        "type": "array",
                        "items": {
                            "type": "string"
                        },
                        "nullable": true
                    }
                },
                "additionalProperties": false
            },
            "PortAgentCreateRequest": {
                "required": ["code", "name"],
                "type": "object",
                "properties": {
                    "name": {
                        "minLength": 1,
                        "type": "string"
                    },
                    "code": {
                        "minLength": 1,
                        "type": "string"
                    },
                    "isActive": {
                        "type": "boolean"
                    },
                    "localityId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    }
                },
                "additionalProperties": false
            },
            "PortAgentImportResult": {
                "type": "object",
                "properties": {
                    "totalRowsRead": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "uniqueTuples": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "created": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "skippedAlreadyExisting": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "matchedLocalities": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "unmatchedLocalities": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "unmatchedCountries": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "warnings": {
                        "type": "array",
                        "items": {
                            "type": "string"
                        },
                        "nullable": true
                    }
                },
                "additionalProperties": false
            },
            "PortAgentLookupResult": {
                "type": "object",
                "properties": {
                    "id": {
                        "type": "string",
                        "format": "uuid"
                    },
                    "code": {
                        "type": "string",
                        "nullable": true
                    },
                    "name": {
                        "type": "string",
                        "nullable": true
                    },
                    "isActive": {
                        "type": "boolean"
                    },
                    "localityId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "locality": {
                        "$ref": "#/components/schemas/LocalityLookupResult"
                    }
                },
                "additionalProperties": false
            },
            "PortAgentLookupResultPagedLookupResult": {
                "type": "object",
                "properties": {
                    "items": {
                        "type": "array",
                        "items": {
                            "$ref": "#/components/schemas/PortAgentLookupResult"
                        },
                        "nullable": true
                    },
                    "totalCount": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "hasMore": {
                        "type": "boolean"
                    }
                },
                "additionalProperties": false
            },
            "PortAgentResult": {
                "type": "object",
                "properties": {
                    "id": {
                        "type": "string",
                        "format": "uuid"
                    },
                    "name": {
                        "type": "string",
                        "nullable": true
                    },
                    "code": {
                        "type": "string",
                        "nullable": true
                    },
                    "isActive": {
                        "type": "boolean"
                    },
                    "localityId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "locality": {
                        "$ref": "#/components/schemas/LocalityLookupResult"
                    }
                },
                "additionalProperties": false
            },
            "PortAgentUpdateRequest": {
                "required": ["code", "name"],
                "type": "object",
                "properties": {
                    "name": {
                        "minLength": 1,
                        "type": "string"
                    },
                    "code": {
                        "minLength": 1,
                        "type": "string"
                    },
                    "isActive": {
                        "type": "boolean"
                    },
                    "localityId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    }
                },
                "additionalProperties": false
            },
            "PortVolume": {
                "type": "object",
                "properties": {
                    "port": {
                        "type": "string",
                        "nullable": true
                    },
                    "shipmentCount": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "totalQuantity": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "percentage": {
                        "type": "number",
                        "format": "double"
                    }
                },
                "additionalProperties": false
            },
            "PurchaseOrderAttachmentResult": {
                "type": "object",
                "properties": {
                    "id": {
                        "type": "string",
                        "format": "uuid"
                    },
                    "purchaseOrderId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "kind": {
                        "type": "string",
                        "nullable": true
                    },
                    "fileName": {
                        "type": "string",
                        "nullable": true
                    },
                    "fileType": {
                        "type": "string",
                        "nullable": true
                    },
                    "documentTypeId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "documentType": {
                        "type": "string",
                        "nullable": true
                    },
                    "pictureTypeId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "pictureType": {
                        "type": "string",
                        "nullable": true
                    },
                    "fileSizeBytes": {
                        "type": "integer",
                        "format": "int64"
                    },
                    "filePath": {
                        "type": "string",
                        "nullable": true
                    },
                    "uploadedBy": {
                        "type": "string",
                        "nullable": true
                    },
                    "uploadedAt": {
                        "type": "string",
                        "format": "date-time"
                    },
                    "description": {
                        "type": "string",
                        "nullable": true
                    },
                    "processingStatus": {
                        "type": "string",
                        "nullable": true
                    },
                    "processedAt": {
                        "type": "string",
                        "format": "date-time",
                        "nullable": true
                    },
                    "extractedData": {
                        "$ref": "#/components/schemas/PoExtractionData"
                    },
                    "processingError": {
                        "type": "string",
                        "nullable": true
                    },
                    "extractedPoNumber": {
                        "type": "string",
                        "nullable": true
                    },
                    "webhookSent": {
                        "type": "boolean"
                    },
                    "webhookSentAt": {
                        "type": "string",
                        "format": "date-time",
                        "nullable": true
                    },
                    "emailSent": {
                        "type": "boolean"
                    },
                    "emailSentAt": {
                        "type": "string",
                        "format": "date-time",
                        "nullable": true
                    },
                    "thumbnailPath": {
                        "type": "string",
                        "nullable": true
                    },
                    "caption": {
                        "type": "string",
                        "nullable": true
                    }
                },
                "additionalProperties": false
            },
            "PurchaseOrderResult": {
                "type": "object",
                "properties": {
                    "id": {
                        "type": "string",
                        "format": "uuid"
                    },
                    "poNumber": {
                        "type": "string",
                        "nullable": true
                    },
                    "description": {
                        "type": "string",
                        "nullable": true
                    },
                    "vendorId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "vendorName": {
                        "type": "string",
                        "nullable": true
                    },
                    "vesselId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "vesselName": {
                        "type": "string",
                        "nullable": true
                    },
                    "origin": {
                        "$ref": "#/components/schemas/LocalityLookupResult"
                    },
                    "destination": {
                        "$ref": "#/components/schemas/LocalityLookupResult"
                    },
                    "statusId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "statusName": {
                        "type": "string",
                        "nullable": true
                    },
                    "value": {
                        "type": "number",
                        "format": "double"
                    },
                    "currency": {
                        "type": "string",
                        "nullable": true
                    },
                    "eta": {
                        "type": "string",
                        "format": "date-time",
                        "nullable": true
                    },
                    "etd": {
                        "type": "string",
                        "format": "date-time",
                        "nullable": true
                    },
                    "dob": {
                        "type": "string",
                        "format": "date-time",
                        "nullable": true
                    },
                    "targetDob": {
                        "type": "string",
                        "format": "date-time",
                        "nullable": true
                    },
                    "carrierIdentifiers": {
                        "type": "array",
                        "items": {
                            "type": "string"
                        },
                        "nullable": true
                    },
                    "receivedDate": {
                        "type": "string",
                        "format": "date-time",
                        "nullable": true
                    },
                    "invoiced": {
                        "type": "boolean"
                    },
                    "issuedBy": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "issuedByName": {
                        "type": "string",
                        "nullable": true
                    },
                    "lastUpdatedBy": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "lastUpdatedByName": {
                        "type": "string",
                        "nullable": true
                    },
                    "sourceId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "sourceName": {
                        "type": "string",
                        "nullable": true
                    },
                    "isMops": {
                        "type": "boolean",
                        "nullable": true
                    },
                    "weight": {
                        "type": "number",
                        "format": "double",
                        "nullable": true
                    },
                    "isVirtual": {
                        "type": "boolean"
                    },
                    "warehouseId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "warehouseName": {
                        "type": "string",
                        "nullable": true
                    },
                    "createdAt": {
                        "type": "string",
                        "format": "date-time"
                    },
                    "updatedAt": {
                        "type": "string",
                        "format": "date-time",
                        "nullable": true
                    },
                    "estimatedAmount": {
                        "type": "number",
                        "format": "double",
                        "nullable": true
                    },
                    "finalAmount": {
                        "type": "number",
                        "format": "double",
                        "nullable": true
                    },
                    "parentVirtualPoId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "parentVirtualPoNumber": {
                        "type": "string",
                        "nullable": true
                    }
                },
                "additionalProperties": false
            },
            "QrCodeDetailsResult": {
                "type": "object",
                "properties": {
                    "id": {
                        "type": "string",
                        "format": "uuid"
                    },
                    "poId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "virtualPoId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "poNumber": {
                        "type": "string",
                        "nullable": true
                    },
                    "virtualPoNumber": {
                        "type": "string",
                        "nullable": true
                    },
                    "itemId": {
                        "type": "string",
                        "nullable": true
                    },
                    "description": {
                        "type": "string",
                        "nullable": true
                    },
                    "category": {
                        "type": "string",
                        "nullable": true
                    },
                    "vendorName": {
                        "type": "string",
                        "nullable": true
                    },
                    "vesselName": {
                        "type": "string",
                        "nullable": true
                    },
                    "value": {
                        "type": "number",
                        "format": "double",
                        "nullable": true
                    },
                    "generatedAt": {
                        "type": "string",
                        "format": "date-time"
                    },
                    "generatedByUserName": {
                        "type": "string",
                        "nullable": true
                    }
                },
                "additionalProperties": false
            },
            "QrCodeGenerationRequest": {
                "required": ["description", "itemId"],
                "type": "object",
                "properties": {
                    "poId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "virtualPoId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "itemId": {
                        "maxLength": 100,
                        "minLength": 1,
                        "type": "string"
                    },
                    "description": {
                        "maxLength": 500,
                        "minLength": 1,
                        "type": "string"
                    },
                    "parentPoId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "isReturn": {
                        "type": "boolean"
                    }
                },
                "additionalProperties": false
            },
            "QrCodeResult": {
                "type": "object",
                "properties": {
                    "id": {
                        "type": "string",
                        "format": "uuid"
                    },
                    "poId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "virtualPoId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "itemId": {
                        "type": "string",
                        "nullable": true
                    },
                    "description": {
                        "type": "string",
                        "nullable": true
                    },
                    "parentPoId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "isReturn": {
                        "type": "boolean"
                    },
                    "base64Image": {
                        "type": "string",
                        "nullable": true
                    },
                    "contentType": {
                        "type": "string",
                        "nullable": true
                    },
                    "encodedData": {
                        "type": "string",
                        "nullable": true
                    },
                    "generatedByUserId": {
                        "type": "string",
                        "format": "uuid"
                    },
                    "generatedAt": {
                        "type": "string",
                        "format": "date-time"
                    }
                },
                "additionalProperties": false
            },
            "QrCodeScanAttachmentResult": {
                "type": "object",
                "properties": {
                    "id": {
                        "type": "string",
                        "format": "uuid"
                    },
                    "fileName": {
                        "type": "string",
                        "nullable": true
                    },
                    "fileType": {
                        "type": "string",
                        "nullable": true
                    },
                    "fileSizeBytes": {
                        "type": "integer",
                        "format": "int64"
                    },
                    "filePath": {
                        "type": "string",
                        "nullable": true
                    },
                    "thumbnailPath": {
                        "type": "string",
                        "nullable": true
                    },
                    "uploadedAt": {
                        "type": "string",
                        "format": "date-time"
                    }
                },
                "additionalProperties": false
            },
            "QrCodeScanRequest": {
                "required": ["qrCodeId"],
                "type": "object",
                "properties": {
                    "qrCodeId": {
                        "type": "string",
                        "format": "uuid"
                    },
                    "localityId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "warehouseId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "vesselId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "statusId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "statusOptionId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "transportTypeId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "vendorId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "portAgentId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "routeSegmentId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "notes": {
                        "maxLength": 500,
                        "type": "string",
                        "nullable": true
                    },
                    "latitude": {
                        "type": "number",
                        "format": "double",
                        "nullable": true
                    },
                    "longitude": {
                        "type": "number",
                        "format": "double",
                        "nullable": true
                    },
                    "scanDate": {
                        "type": "string",
                        "format": "date-time",
                        "nullable": true
                    },
                    "image": {
                        "type": "string",
                        "format": "binary",
                        "nullable": true
                    }
                },
                "additionalProperties": false
            },
            "QrCodeScanResult": {
                "type": "object",
                "properties": {
                    "id": {
                        "type": "string",
                        "format": "uuid"
                    },
                    "qrCodeId": {
                        "type": "string",
                        "format": "uuid"
                    },
                    "qrCodeDetails": {
                        "$ref": "#/components/schemas/QrCodeDetailsResult"
                    },
                    "isAnonymous": {
                        "type": "boolean"
                    },
                    "scannedByUserId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "scannedByUserName": {
                        "type": "string",
                        "nullable": true
                    },
                    "locality": {
                        "type": "string",
                        "nullable": true
                    },
                    "scannedAt": {
                        "type": "string",
                        "format": "date"
                    },
                    "notes": {
                        "type": "string",
                        "nullable": true
                    },
                    "latitude": {
                        "type": "number",
                        "format": "double",
                        "nullable": true
                    },
                    "longitude": {
                        "type": "number",
                        "format": "double",
                        "nullable": true
                    },
                    "imagePath": {
                        "type": "string",
                        "nullable": true
                    },
                    "isPartOfVirtualContainer": {
                        "type": "boolean"
                    },
                    "virtualPoId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "containedPurchaseOrders": {
                        "type": "array",
                        "items": {
                            "$ref": "#/components/schemas/ContainedPurchaseOrderResult"
                        },
                        "nullable": true
                    }
                },
                "additionalProperties": false
            },
            "QrEntityDetailsResult": {
                "type": "object",
                "properties": {
                    "entityType": {
                        "$ref": "#/components/schemas/QrEntityType"
                    },
                    "qrCodeId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "poId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "poNumber": {
                        "type": "string",
                        "nullable": true
                    },
                    "virtualPoId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "virtualPoNumber": {
                        "type": "string",
                        "nullable": true
                    },
                    "itemId": {
                        "type": "string",
                        "nullable": true
                    },
                    "description": {
                        "type": "string",
                        "nullable": true
                    },
                    "category": {
                        "type": "string",
                        "nullable": true
                    },
                    "vendorName": {
                        "type": "string",
                        "nullable": true
                    },
                    "vesselName": {
                        "type": "string",
                        "nullable": true
                    },
                    "value": {
                        "type": "number",
                        "format": "double",
                        "nullable": true
                    },
                    "generatedAt": {
                        "type": "string",
                        "format": "date-time",
                        "nullable": true
                    },
                    "generatedByUserName": {
                        "type": "string",
                        "nullable": true
                    },
                    "lgaUniqueId": {
                        "type": "string",
                        "nullable": true
                    },
                    "lgaStatus": {
                        "type": "string",
                        "nullable": true
                    },
                    "portLanded": {
                        "type": "string",
                        "nullable": true
                    },
                    "offloadDate": {
                        "type": "string",
                        "format": "date-time",
                        "nullable": true
                    },
                    "requestorName": {
                        "type": "string",
                        "nullable": true
                    }
                },
                "additionalProperties": false
            },
            "QrEntityType": {
                "enum": ["Po", "Virtual", "Lga"],
                "type": "string"
            },
            "ReportFilterOptionsResult": {
                "type": "object",
                "properties": {
                    "reportTypes": {
                        "type": "array",
                        "items": {
                            "type": "string"
                        },
                        "nullable": true
                    },
                    "ships": {
                        "type": "array",
                        "items": {
                            "type": "string"
                        },
                        "nullable": true
                    },
                    "goodsCategories": {
                        "type": "array",
                        "items": {
                            "type": "string"
                        },
                        "nullable": true
                    },
                    "ports": {
                        "type": "array",
                        "items": {
                            "type": "string"
                        },
                        "nullable": true
                    },
                    "transportTypes": {
                        "type": "array",
                        "items": {
                            "type": "string"
                        },
                        "nullable": true
                    }
                },
                "additionalProperties": false
            },
            "ReportFilterRequest": {
                "type": "object",
                "properties": {
                    "reportType": {
                        "type": "string",
                        "nullable": true
                    },
                    "ship": {
                        "type": "string",
                        "nullable": true
                    },
                    "goodsCategory": {
                        "type": "string",
                        "nullable": true
                    },
                    "port": {
                        "type": "string",
                        "nullable": true
                    },
                    "transportType": {
                        "type": "string",
                        "nullable": true
                    },
                    "startDate": {
                        "type": "string",
                        "format": "date-time",
                        "nullable": true
                    },
                    "endDate": {
                        "type": "string",
                        "format": "date-time",
                        "nullable": true
                    }
                },
                "additionalProperties": false
            },
            "ReportKpisResult": {
                "type": "object",
                "properties": {
                    "averageDeliveryTime": {
                        "type": "number",
                        "format": "double"
                    },
                    "onTimeDeliveryRate": {
                        "type": "number",
                        "format": "double"
                    },
                    "noConformityRate": {
                        "type": "number",
                        "format": "double"
                    },
                    "customsClearanceTime": {
                        "type": "number",
                        "format": "double"
                    }
                },
                "additionalProperties": false
            },
            "RoleOptionResult": {
                "type": "object",
                "properties": {
                    "code": {
                        "type": "string",
                        "nullable": true
                    },
                    "name": {
                        "type": "string",
                        "nullable": true
                    }
                },
                "additionalProperties": false
            },
            "RoleResult": {
                "type": "object",
                "properties": {
                    "id": {
                        "type": "string",
                        "nullable": true
                    },
                    "name": {
                        "type": "string",
                        "nullable": true
                    },
                    "description": {
                        "type": "string",
                        "nullable": true
                    }
                },
                "additionalProperties": false
            },
            "RouteChangeLogResult": {
                "type": "object",
                "properties": {
                    "id": {
                        "type": "string",
                        "format": "uuid"
                    },
                    "changeType": {
                        "type": "string",
                        "nullable": true
                    },
                    "description": {
                        "type": "string",
                        "nullable": true
                    },
                    "oldValue": {
                        "type": "string",
                        "nullable": true
                    },
                    "newValue": {
                        "type": "string",
                        "nullable": true
                    },
                    "routeSummary": {
                        "type": "string",
                        "nullable": true
                    },
                    "fieldChanges": {
                        "type": "array",
                        "items": {
                            "type": "string"
                        },
                        "nullable": true
                    },
                    "changedBy": {
                        "type": "string",
                        "nullable": true
                    },
                    "changedAt": {
                        "type": "string",
                        "format": "date-time"
                    }
                },
                "additionalProperties": false
            },
            "RouteCurrentPositionResult": {
                "type": "object",
                "properties": {
                    "onSegmentSequence": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "status": {
                        "type": "string",
                        "nullable": true
                    },
                    "locationName": {
                        "type": "string",
                        "nullable": true
                    },
                    "latitude": {
                        "type": "number",
                        "format": "double",
                        "nullable": true
                    },
                    "longitude": {
                        "type": "number",
                        "format": "double",
                        "nullable": true
                    }
                },
                "additionalProperties": false
            },
            "RouteMapResult": {
                "type": "object",
                "properties": {
                    "nodes": {
                        "type": "array",
                        "items": {
                            "$ref": "#/components/schemas/RouteNodeResult"
                        },
                        "nullable": true
                    },
                    "segments": {
                        "type": "array",
                        "items": {
                            "$ref": "#/components/schemas/RouteMapSegmentResult"
                        },
                        "nullable": true
                    },
                    "currentPosition": {
                        "$ref": "#/components/schemas/RouteCurrentPositionResult"
                    }
                },
                "additionalProperties": false
            },
            "RouteMapSegmentResult": {
                "type": "object",
                "properties": {
                    "segmentOrder": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "fromLocationName": {
                        "type": "string",
                        "nullable": true
                    },
                    "toLocationName": {
                        "type": "string",
                        "nullable": true
                    },
                    "transportTypeCode": {
                        "type": "string",
                        "nullable": true
                    },
                    "transportTypeIcon": {
                        "type": "string",
                        "nullable": true
                    },
                    "departureStepTypeIcon": {
                        "type": "string",
                        "nullable": true
                    },
                    "departureStepTypeCode": {
                        "type": "string",
                        "nullable": true
                    },
                    "arrivalStepTypeIcon": {
                        "type": "string",
                        "nullable": true
                    },
                    "arrivalStepTypeCode": {
                        "type": "string",
                        "nullable": true
                    },
                    "status": {
                        "type": "string",
                        "nullable": true
                    },
                    "departureDate": {
                        "type": "string",
                        "format": "date-time",
                        "nullable": true
                    },
                    "arrivalDate": {
                        "type": "string",
                        "format": "date-time",
                        "nullable": true
                    }
                },
                "additionalProperties": false
            },
            "RouteNodeResult": {
                "type": "object",
                "properties": {
                    "sequence": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "locationName": {
                        "type": "string",
                        "nullable": true
                    },
                    "locationType": {
                        "type": "string",
                        "nullable": true
                    },
                    "latitude": {
                        "type": "number",
                        "format": "double",
                        "nullable": true
                    },
                    "longitude": {
                        "type": "number",
                        "format": "double",
                        "nullable": true
                    },
                    "isOrigin": {
                        "type": "boolean"
                    },
                    "isDestination": {
                        "type": "boolean"
                    },
                    "isReached": {
                        "type": "boolean"
                    },
                    "departureDate": {
                        "type": "string",
                        "format": "date-time",
                        "nullable": true
                    },
                    "arrivalDate": {
                        "type": "string",
                        "format": "date-time",
                        "nullable": true
                    },
                    "stepTypeCode": {
                        "type": "string",
                        "nullable": true
                    },
                    "stepTypeIcon": {
                        "type": "string",
                        "nullable": true
                    }
                },
                "additionalProperties": false
            },
            "RouteSegmentCreateRequest": {
                "required": ["transportTypeId"],
                "type": "object",
                "properties": {
                    "description": {
                        "type": "string",
                        "nullable": true
                    },
                    "departureLocalityId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "departureWarehouseId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "departurePortAgentId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "departureDate": {
                        "type": "string",
                        "format": "date-time",
                        "nullable": true
                    },
                    "departureStepTypeId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "departureNotes": {
                        "type": "string",
                        "nullable": true
                    },
                    "arrivalLocalityId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "arrivalWarehouseId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "arrivalPortAgentId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "arrivalStepTypeId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "arrivalDate": {
                        "type": "string",
                        "format": "date-time",
                        "nullable": true
                    },
                    "isArrivalDateDob": {
                        "type": "boolean"
                    },
                    "arrivalNotes": {
                        "type": "string",
                        "nullable": true
                    },
                    "transportTypeId": {
                        "type": "string",
                        "format": "uuid"
                    },
                    "carrierIdentifier": {
                        "maxLength": 64,
                        "type": "string",
                        "nullable": true
                    },
                    "departureVendorId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "departureVesselId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "arrivalVendorId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "arrivalVesselId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "estimatedAmount": {
                        "type": "number",
                        "format": "double",
                        "nullable": true
                    },
                    "finalAmount": {
                        "type": "number",
                        "format": "double",
                        "nullable": true
                    },
                    "valueCurrencyId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "isPaidByVendor": {
                        "type": "boolean"
                    }
                },
                "additionalProperties": false
            },
            "RouteSegmentReorderRequest": {
                "type": "object",
                "properties": {
                    "segmentIds": {
                        "type": "array",
                        "items": {
                            "type": "string",
                            "format": "uuid"
                        },
                        "nullable": true
                    }
                },
                "additionalProperties": false
            },
            "RouteSegmentResult": {
                "type": "object",
                "properties": {
                    "id": {
                        "type": "string",
                        "format": "uuid"
                    },
                    "sequence": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "description": {
                        "type": "string",
                        "nullable": true
                    },
                    "departureLocalityId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "departureLocalityName": {
                        "type": "string",
                        "nullable": true
                    },
                    "departureLocalityCode": {
                        "type": "string",
                        "nullable": true
                    },
                    "departureWarehouseId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "departureWarehouseName": {
                        "type": "string",
                        "nullable": true
                    },
                    "departurePortAgentId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "departurePortAgentName": {
                        "type": "string",
                        "nullable": true
                    },
                    "departureDate": {
                        "type": "string",
                        "format": "date-time",
                        "nullable": true
                    },
                    "departureStepTypeId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "departureStepTypeName": {
                        "type": "string",
                        "nullable": true
                    },
                    "departureStepTypeCode": {
                        "type": "string",
                        "nullable": true
                    },
                    "departureStepTypeIcon": {
                        "type": "string",
                        "nullable": true
                    },
                    "departureNotes": {
                        "type": "string",
                        "nullable": true
                    },
                    "arrivalLocalityId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "arrivalLocalityName": {
                        "type": "string",
                        "nullable": true
                    },
                    "arrivalLocalityCode": {
                        "type": "string",
                        "nullable": true
                    },
                    "arrivalWarehouseId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "arrivalWarehouseName": {
                        "type": "string",
                        "nullable": true
                    },
                    "arrivalPortAgentId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "arrivalPortAgentName": {
                        "type": "string",
                        "nullable": true
                    },
                    "arrivalDate": {
                        "type": "string",
                        "format": "date-time",
                        "nullable": true
                    },
                    "isArrivalDateDob": {
                        "type": "boolean"
                    },
                    "arrivalStepTypeId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "arrivalStepTypeName": {
                        "type": "string",
                        "nullable": true
                    },
                    "arrivalStepTypeCode": {
                        "type": "string",
                        "nullable": true
                    },
                    "arrivalStepTypeIcon": {
                        "type": "string",
                        "nullable": true
                    },
                    "arrivalNotes": {
                        "type": "string",
                        "nullable": true
                    },
                    "transportTypeId": {
                        "type": "string",
                        "format": "uuid"
                    },
                    "transportTypeName": {
                        "type": "string",
                        "nullable": true
                    },
                    "transportTypeCode": {
                        "type": "string",
                        "nullable": true
                    },
                    "transportTypeIcon": {
                        "type": "string",
                        "nullable": true
                    },
                    "carrierIdentifier": {
                        "type": "string",
                        "nullable": true
                    },
                    "departureVendorId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "departureVendorName": {
                        "type": "string",
                        "nullable": true
                    },
                    "departureVesselId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "departureVesselName": {
                        "type": "string",
                        "nullable": true
                    },
                    "arrivalVendorId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "arrivalVendorName": {
                        "type": "string",
                        "nullable": true
                    },
                    "arrivalVesselId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "arrivalVesselName": {
                        "type": "string",
                        "nullable": true
                    },
                    "estimatedAmount": {
                        "type": "number",
                        "format": "double",
                        "nullable": true
                    },
                    "finalAmount": {
                        "type": "number",
                        "format": "double",
                        "nullable": true
                    },
                    "valueCurrencyId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "valueCurrencyCode": {
                        "type": "string",
                        "nullable": true
                    },
                    "isPaidByVendor": {
                        "type": "boolean"
                    },
                    "sourceVirtualPurchaseOrderId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "sourceVirtualPoNumber": {
                        "type": "string",
                        "nullable": true
                    },
                    "status": {
                        "type": "string",
                        "nullable": true
                    },
                    "isCompleted": {
                        "type": "boolean"
                    },
                    "isStartPoint": {
                        "type": "boolean"
                    },
                    "isDestinationPoint": {
                        "type": "boolean"
                    },
                    "completedAt": {
                        "type": "string",
                        "format": "date-time",
                        "nullable": true
                    },
                    "createdAt": {
                        "type": "string",
                        "format": "date-time"
                    }
                },
                "additionalProperties": false
            },
            "RouteSegmentUpdateRequest": {
                "required": ["transportTypeId"],
                "type": "object",
                "properties": {
                    "description": {
                        "type": "string",
                        "nullable": true
                    },
                    "departureLocalityId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "departureWarehouseId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "departurePortAgentId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "departureDate": {
                        "type": "string",
                        "format": "date-time",
                        "nullable": true
                    },
                    "departureStepTypeId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "departureNotes": {
                        "type": "string",
                        "nullable": true
                    },
                    "arrivalLocalityId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "arrivalWarehouseId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "arrivalPortAgentId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "arrivalStepTypeId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "arrivalDate": {
                        "type": "string",
                        "format": "date-time",
                        "nullable": true
                    },
                    "isArrivalDateDob": {
                        "type": "boolean"
                    },
                    "arrivalNotes": {
                        "type": "string",
                        "nullable": true
                    },
                    "transportTypeId": {
                        "type": "string",
                        "format": "uuid"
                    },
                    "carrierIdentifier": {
                        "maxLength": 64,
                        "type": "string",
                        "nullable": true
                    },
                    "departureVendorId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "departureVesselId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "arrivalVendorId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "arrivalVesselId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "estimatedAmount": {
                        "type": "number",
                        "format": "double",
                        "nullable": true
                    },
                    "finalAmount": {
                        "type": "number",
                        "format": "double",
                        "nullable": true
                    },
                    "valueCurrencyId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "isPaidByVendor": {
                        "type": "boolean"
                    },
                    "isCompleted": {
                        "type": "boolean",
                        "nullable": true
                    }
                },
                "additionalProperties": false
            },
            "ShipmentLocationResult": {
                "type": "object",
                "properties": {
                    "id": {
                        "type": "string",
                        "format": "uuid"
                    },
                    "latitude": {
                        "type": "number",
                        "format": "double"
                    },
                    "longitude": {
                        "type": "number",
                        "format": "double"
                    },
                    "locationName": {
                        "type": "string",
                        "nullable": true
                    },
                    "timestamp": {
                        "type": "string",
                        "format": "date"
                    },
                    "notes": {
                        "type": "string",
                        "nullable": true
                    },
                    "isAnonymous": {
                        "type": "boolean"
                    },
                    "scannedByUserId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "scannedByUserName": {
                        "type": "string",
                        "nullable": true
                    },
                    "localityId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "localityName": {
                        "type": "string",
                        "nullable": true
                    },
                    "warehouseId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "warehouseName": {
                        "type": "string",
                        "nullable": true
                    },
                    "transportTypeId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "transportTypeName": {
                        "type": "string",
                        "nullable": true
                    },
                    "transportTypeIcon": {
                        "type": "string",
                        "nullable": true
                    },
                    "vesselId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "vesselName": {
                        "type": "string",
                        "nullable": true
                    },
                    "portAgentId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "portAgentName": {
                        "type": "string",
                        "nullable": true
                    },
                    "statusId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "status": {
                        "type": "string",
                        "nullable": true
                    },
                    "statusOptionsId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "statusOptionName": {
                        "type": "string",
                        "nullable": true
                    },
                    "virtualContainer": {
                        "$ref": "#/components/schemas/VirtualContainerInfo"
                    },
                    "isFromVirtualContainer": {
                        "type": "boolean"
                    },
                    "attachments": {
                        "type": "array",
                        "items": {
                            "$ref": "#/components/schemas/QrCodeScanAttachmentResult"
                        },
                        "nullable": true
                    }
                },
                "additionalProperties": false
            },
            "ShipmentTrackingResult": {
                "type": "object",
                "properties": {
                    "shipmentId": {
                        "type": "string",
                        "format": "uuid"
                    },
                    "shipmentNumber": {
                        "type": "string",
                        "nullable": true
                    },
                    "poId": {
                        "type": "string",
                        "nullable": true
                    },
                    "description": {
                        "type": "string",
                        "nullable": true
                    },
                    "ship": {
                        "type": "string",
                        "nullable": true
                    },
                    "vendor": {
                        "type": "string",
                        "nullable": true
                    },
                    "origin": {
                        "$ref": "#/components/schemas/LocalityLookupResult"
                    },
                    "destination": {
                        "$ref": "#/components/schemas/LocalityLookupResult"
                    },
                    "status": {
                        "type": "string",
                        "nullable": true
                    },
                    "isVirtual": {
                        "type": "boolean"
                    },
                    "parentVirtualPoId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "parentVirtualPoNumber": {
                        "type": "string",
                        "nullable": true
                    },
                    "totalShipmentCost": {
                        "type": "number",
                        "format": "double",
                        "nullable": true
                    },
                    "departureDate": {
                        "type": "string",
                        "format": "date-time",
                        "nullable": true
                    },
                    "arrivalDate": {
                        "type": "string",
                        "format": "date-time",
                        "nullable": true
                    },
                    "targetDob": {
                        "type": "string",
                        "format": "date-time",
                        "nullable": true
                    },
                    "currentLocation": {
                        "$ref": "#/components/schemas/ShipmentLocationResult"
                    },
                    "locationHistory": {
                        "type": "array",
                        "items": {
                            "$ref": "#/components/schemas/ShipmentLocationResult"
                        },
                        "nullable": true
                    },
                    "virtualContainerHistory": {
                        "type": "array",
                        "items": {
                            "$ref": "#/components/schemas/VirtualContainerInfo"
                        },
                        "nullable": true
                    }
                },
                "additionalProperties": false
            },
            "ShippingVolumeByPortResult": {
                "type": "object",
                "properties": {
                    "originPorts": {
                        "type": "array",
                        "items": {
                            "$ref": "#/components/schemas/PortVolume"
                        },
                        "nullable": true
                    },
                    "destinationPorts": {
                        "type": "array",
                        "items": {
                            "$ref": "#/components/schemas/PortVolume"
                        },
                        "nullable": true
                    },
                    "totalShipments": {
                        "type": "integer",
                        "format": "int32"
                    }
                },
                "additionalProperties": false
            },
            "SourceCreateRequest": {
                "required": ["code", "name"],
                "type": "object",
                "properties": {
                    "code": {
                        "minLength": 1,
                        "type": "string"
                    },
                    "name": {
                        "minLength": 1,
                        "type": "string"
                    },
                    "description": {
                        "type": "string",
                        "nullable": true
                    },
                    "sortOrder": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "isActive": {
                        "type": "boolean"
                    }
                },
                "additionalProperties": false
            },
            "SourceLookupResult": {
                "type": "object",
                "properties": {
                    "id": {
                        "type": "string",
                        "format": "uuid"
                    },
                    "code": {
                        "type": "string",
                        "nullable": true
                    },
                    "name": {
                        "type": "string",
                        "nullable": true
                    },
                    "description": {
                        "type": "string",
                        "nullable": true
                    },
                    "sortOrder": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "isActive": {
                        "type": "boolean"
                    }
                },
                "additionalProperties": false
            },
            "SourceUpdateRequest": {
                "required": ["code", "name"],
                "type": "object",
                "properties": {
                    "code": {
                        "minLength": 1,
                        "type": "string"
                    },
                    "name": {
                        "minLength": 1,
                        "type": "string"
                    },
                    "description": {
                        "type": "string",
                        "nullable": true
                    },
                    "sortOrder": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "isActive": {
                        "type": "boolean"
                    }
                },
                "additionalProperties": false
            },
            "StatusCreateRequest": {
                "required": ["code", "name"],
                "type": "object",
                "properties": {
                    "code": {
                        "minLength": 1,
                        "type": "string"
                    },
                    "name": {
                        "minLength": 1,
                        "type": "string"
                    },
                    "description": {
                        "type": "string",
                        "nullable": true
                    },
                    "icon": {
                        "type": "string",
                        "nullable": true
                    },
                    "color": {
                        "type": "string",
                        "nullable": true
                    },
                    "sortOrder": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "priorityOrder": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "isActive": {
                        "type": "boolean"
                    }
                },
                "additionalProperties": false
            },
            "StatusHiddenRolePair": {
                "type": "object",
                "properties": {
                    "statusId": {
                        "type": "string",
                        "format": "uuid"
                    },
                    "roleCode": {
                        "type": "string",
                        "nullable": true
                    }
                },
                "additionalProperties": false
            },
            "StatusLookupResult": {
                "type": "object",
                "properties": {
                    "id": {
                        "type": "string",
                        "format": "uuid"
                    },
                    "code": {
                        "type": "string",
                        "nullable": true
                    },
                    "name": {
                        "type": "string",
                        "nullable": true
                    },
                    "description": {
                        "type": "string",
                        "nullable": true
                    },
                    "icon": {
                        "type": "string",
                        "nullable": true
                    },
                    "color": {
                        "type": "string",
                        "nullable": true
                    },
                    "sortOrder": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "priorityOrder": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "isActive": {
                        "type": "boolean"
                    }
                },
                "additionalProperties": false
            },
            "StatusOptionCreateRequest": {
                "required": ["code", "name"],
                "type": "object",
                "properties": {
                    "code": {
                        "minLength": 1,
                        "type": "string"
                    },
                    "name": {
                        "minLength": 1,
                        "type": "string"
                    },
                    "description": {
                        "type": "string",
                        "nullable": true
                    },
                    "icon": {
                        "type": "string",
                        "nullable": true
                    },
                    "color": {
                        "type": "string",
                        "nullable": true
                    },
                    "sortOrder": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "isActive": {
                        "type": "boolean"
                    }
                },
                "additionalProperties": false
            },
            "StatusOptionLookupResult": {
                "type": "object",
                "properties": {
                    "id": {
                        "type": "string",
                        "format": "uuid"
                    },
                    "code": {
                        "type": "string",
                        "nullable": true
                    },
                    "name": {
                        "type": "string",
                        "nullable": true
                    },
                    "description": {
                        "type": "string",
                        "nullable": true
                    },
                    "icon": {
                        "type": "string",
                        "nullable": true
                    },
                    "color": {
                        "type": "string",
                        "nullable": true
                    },
                    "sortOrder": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "isActive": {
                        "type": "boolean"
                    }
                },
                "additionalProperties": false
            },
            "StatusOptionUpdateRequest": {
                "required": ["code", "name"],
                "type": "object",
                "properties": {
                    "code": {
                        "minLength": 1,
                        "type": "string"
                    },
                    "name": {
                        "minLength": 1,
                        "type": "string"
                    },
                    "description": {
                        "type": "string",
                        "nullable": true
                    },
                    "icon": {
                        "type": "string",
                        "nullable": true
                    },
                    "color": {
                        "type": "string",
                        "nullable": true
                    },
                    "sortOrder": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "isActive": {
                        "type": "boolean"
                    }
                },
                "additionalProperties": false
            },
            "StatusUpdateMetricsResult": {
                "type": "object",
                "properties": {
                    "totalShipments": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "shipmentsWithCompleteTracking": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "completeTrackingPercentage": {
                        "type": "number",
                        "format": "double"
                    },
                    "shipmentsWithMissingScans": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "missingScansPercentage": {
                        "type": "number",
                        "format": "double"
                    },
                    "delayedStatusReports": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "delayedReportsPercentage": {
                        "type": "number",
                        "format": "double"
                    }
                },
                "additionalProperties": false
            },
            "StatusUpdateRequest": {
                "required": ["code", "name"],
                "type": "object",
                "properties": {
                    "code": {
                        "minLength": 1,
                        "type": "string"
                    },
                    "name": {
                        "minLength": 1,
                        "type": "string"
                    },
                    "description": {
                        "type": "string",
                        "nullable": true
                    },
                    "icon": {
                        "type": "string",
                        "nullable": true
                    },
                    "color": {
                        "type": "string",
                        "nullable": true
                    },
                    "sortOrder": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "priorityOrder": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "isActive": {
                        "type": "boolean"
                    }
                },
                "additionalProperties": false
            },
            "StatusVisibilityHiddenPair": {
                "required": ["roleCode", "statusId"],
                "type": "object",
                "properties": {
                    "statusId": {
                        "type": "string",
                        "format": "uuid"
                    },
                    "roleCode": {
                        "minLength": 1,
                        "type": "string"
                    }
                },
                "additionalProperties": false
            },
            "StatusVisibilityMatrixResult": {
                "type": "object",
                "properties": {
                    "statuses": {
                        "type": "array",
                        "items": {
                            "$ref": "#/components/schemas/StatusLookupResult"
                        },
                        "nullable": true
                    },
                    "roles": {
                        "type": "array",
                        "items": {
                            "$ref": "#/components/schemas/RoleOptionResult"
                        },
                        "nullable": true
                    },
                    "hiddenPairs": {
                        "type": "array",
                        "items": {
                            "$ref": "#/components/schemas/StatusHiddenRolePair"
                        },
                        "nullable": true
                    }
                },
                "additionalProperties": false
            },
            "StatusVisibilityUpdateRequest": {
                "required": ["hiddenPairs"],
                "type": "object",
                "properties": {
                    "hiddenPairs": {
                        "type": "array",
                        "items": {
                            "$ref": "#/components/schemas/StatusVisibilityHiddenPair"
                        }
                    }
                },
                "additionalProperties": false
            },
            "StepTypeCreateRequest": {
                "required": ["code", "name"],
                "type": "object",
                "properties": {
                    "code": {
                        "minLength": 1,
                        "type": "string"
                    },
                    "name": {
                        "minLength": 1,
                        "type": "string"
                    },
                    "description": {
                        "type": "string",
                        "nullable": true
                    },
                    "icon": {
                        "type": "string",
                        "nullable": true
                    },
                    "color": {
                        "type": "string",
                        "nullable": true
                    },
                    "sortOrder": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "isActive": {
                        "type": "boolean"
                    }
                },
                "additionalProperties": false
            },
            "StepTypeLookupResult": {
                "type": "object",
                "properties": {
                    "id": {
                        "type": "string",
                        "format": "uuid"
                    },
                    "code": {
                        "type": "string",
                        "nullable": true
                    },
                    "name": {
                        "type": "string",
                        "nullable": true
                    },
                    "description": {
                        "type": "string",
                        "nullable": true
                    },
                    "icon": {
                        "type": "string",
                        "nullable": true
                    },
                    "color": {
                        "type": "string",
                        "nullable": true
                    },
                    "sortOrder": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "isActive": {
                        "type": "boolean"
                    }
                },
                "additionalProperties": false
            },
            "StepTypeUpdateRequest": {
                "required": ["code", "name"],
                "type": "object",
                "properties": {
                    "code": {
                        "minLength": 1,
                        "type": "string"
                    },
                    "name": {
                        "minLength": 1,
                        "type": "string"
                    },
                    "description": {
                        "type": "string",
                        "nullable": true
                    },
                    "icon": {
                        "type": "string",
                        "nullable": true
                    },
                    "color": {
                        "type": "string",
                        "nullable": true
                    },
                    "sortOrder": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "isActive": {
                        "type": "boolean"
                    }
                },
                "additionalProperties": false
            },
            "TransportTypeCreateRequest": {
                "required": ["code", "name"],
                "type": "object",
                "properties": {
                    "code": {
                        "minLength": 1,
                        "type": "string"
                    },
                    "name": {
                        "minLength": 1,
                        "type": "string"
                    },
                    "description": {
                        "type": "string",
                        "nullable": true
                    },
                    "icon": {
                        "type": "string",
                        "nullable": true
                    },
                    "color": {
                        "type": "string",
                        "nullable": true
                    },
                    "sortOrder": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "isActive": {
                        "type": "boolean"
                    }
                },
                "additionalProperties": false
            },
            "TransportTypeLookupResult": {
                "type": "object",
                "properties": {
                    "id": {
                        "type": "string",
                        "format": "uuid"
                    },
                    "code": {
                        "type": "string",
                        "nullable": true
                    },
                    "name": {
                        "type": "string",
                        "nullable": true
                    },
                    "description": {
                        "type": "string",
                        "nullable": true
                    },
                    "icon": {
                        "type": "string",
                        "nullable": true
                    },
                    "color": {
                        "type": "string",
                        "nullable": true
                    },
                    "sortOrder": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "isActive": {
                        "type": "boolean"
                    }
                },
                "additionalProperties": false
            },
            "TransportTypeUpdateRequest": {
                "required": ["code", "name"],
                "type": "object",
                "properties": {
                    "code": {
                        "minLength": 1,
                        "type": "string"
                    },
                    "name": {
                        "minLength": 1,
                        "type": "string"
                    },
                    "description": {
                        "type": "string",
                        "nullable": true
                    },
                    "icon": {
                        "type": "string",
                        "nullable": true
                    },
                    "color": {
                        "type": "string",
                        "nullable": true
                    },
                    "sortOrder": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "isActive": {
                        "type": "boolean"
                    }
                },
                "additionalProperties": false
            },
            "UnifiedMapNodeResult": {
                "type": "object",
                "properties": {
                    "sequence": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "locationName": {
                        "type": "string",
                        "nullable": true
                    },
                    "locationType": {
                        "type": "string",
                        "nullable": true
                    },
                    "latitude": {
                        "type": "number",
                        "format": "double",
                        "nullable": true
                    },
                    "longitude": {
                        "type": "number",
                        "format": "double",
                        "nullable": true
                    },
                    "isOrigin": {
                        "type": "boolean"
                    },
                    "isDestination": {
                        "type": "boolean"
                    },
                    "isReached": {
                        "type": "boolean"
                    },
                    "departureDate": {
                        "type": "string",
                        "format": "date-time",
                        "nullable": true
                    },
                    "arrivalDate": {
                        "type": "string",
                        "format": "date-time",
                        "nullable": true
                    },
                    "stepTypeCode": {
                        "type": "string",
                        "nullable": true
                    },
                    "stepTypeIcon": {
                        "type": "string",
                        "nullable": true
                    },
                    "warehouseId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "localityId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "portAgentId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "sourceVirtualPoNumber": {
                        "type": "string",
                        "nullable": true
                    },
                    "scans": {
                        "type": "array",
                        "items": {
                            "$ref": "#/components/schemas/ShipmentLocationResult"
                        },
                        "nullable": true
                    }
                },
                "additionalProperties": false
            },
            "UnifiedMapResult": {
                "type": "object",
                "properties": {
                    "nodes": {
                        "type": "array",
                        "items": {
                            "$ref": "#/components/schemas/UnifiedMapNodeResult"
                        },
                        "nullable": true
                    },
                    "segments": {
                        "type": "array",
                        "items": {
                            "$ref": "#/components/schemas/RouteMapSegmentResult"
                        },
                        "nullable": true
                    },
                    "currentPosition": {
                        "$ref": "#/components/schemas/RouteCurrentPositionResult"
                    },
                    "offRouteScans": {
                        "type": "array",
                        "items": {
                            "$ref": "#/components/schemas/ShipmentLocationResult"
                        },
                        "nullable": true
                    }
                },
                "additionalProperties": false
            },
            "UpdatePendingConfirmationRequest": {
                "type": "object",
                "properties": {
                    "poNumber": {
                        "type": "string",
                        "nullable": true
                    },
                    "vendorId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "description": {
                        "type": "string",
                        "nullable": true
                    },
                    "vesselId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "value": {
                        "type": "number",
                        "format": "double",
                        "nullable": true
                    },
                    "currency": {
                        "type": "string",
                        "nullable": true
                    },
                    "issuedById": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "sourceId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "isMops": {
                        "type": "boolean",
                        "nullable": true
                    },
                    "weight": {
                        "type": "number",
                        "format": "double",
                        "nullable": true
                    },
                    "targetDob": {
                        "type": "string",
                        "format": "date-time",
                        "nullable": true
                    }
                },
                "additionalProperties": false
            },
            "UpdatePurchaseOrderVirtualRequest": {
                "type": "object",
                "properties": {
                    "purchaseOrderIds": {
                        "type": "array",
                        "items": {
                            "type": "string",
                            "format": "uuid"
                        },
                        "nullable": true
                    }
                },
                "additionalProperties": false
            },
            "UpdateRolePermissionsRequest": {
                "type": "object",
                "properties": {
                    "permissions": {
                        "type": "array",
                        "items": {
                            "type": "string"
                        },
                        "nullable": true
                    }
                },
                "additionalProperties": false
            },
            "UpdateUserPermissionsRequest": {
                "type": "object",
                "properties": {
                    "permissions": {
                        "type": "array",
                        "items": {
                            "type": "string"
                        },
                        "nullable": true
                    }
                },
                "additionalProperties": false
            },
            "UpdateUserRequest": {
                "type": "object",
                "properties": {
                    "firstName": {
                        "type": "string",
                        "nullable": true
                    },
                    "lastName": {
                        "type": "string",
                        "nullable": true
                    },
                    "email": {
                        "type": "string",
                        "nullable": true
                    },
                    "enabled": {
                        "type": "boolean",
                        "nullable": true
                    },
                    "vendorId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "portAgentId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "warehouseId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "vesselId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    }
                },
                "additionalProperties": false
            },
            "UpdateUserRolesRequest": {
                "type": "object",
                "properties": {
                    "roles": {
                        "type": "array",
                        "items": {
                            "type": "string"
                        },
                        "nullable": true
                    }
                },
                "additionalProperties": false
            },
            "UpdateVirtualPurchaseOrderRequest": {
                "type": "object",
                "properties": {
                    "description": {
                        "maxLength": 1000,
                        "type": "string",
                        "nullable": true
                    },
                    "statusId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "vesselId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "issuedBy": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "targetDob": {
                        "type": "string",
                        "format": "date-time",
                        "nullable": true
                    },
                    "purchaseOrderIds": {
                        "type": "array",
                        "items": {
                            "type": "string",
                            "format": "uuid"
                        },
                        "nullable": true
                    },
                    "lgaDocumentIds": {
                        "type": "array",
                        "items": {
                            "type": "string",
                            "format": "uuid"
                        },
                        "nullable": true
                    }
                },
                "additionalProperties": false
            },
            "UserDetailResult": {
                "type": "object",
                "properties": {
                    "id": {
                        "type": "string",
                        "nullable": true
                    },
                    "username": {
                        "type": "string",
                        "nullable": true
                    },
                    "email": {
                        "type": "string",
                        "nullable": true
                    },
                    "firstName": {
                        "type": "string",
                        "nullable": true
                    },
                    "lastName": {
                        "type": "string",
                        "nullable": true
                    },
                    "enabled": {
                        "type": "boolean"
                    },
                    "createdTimestamp": {
                        "type": "integer",
                        "format": "int64",
                        "nullable": true
                    },
                    "roles": {
                        "type": "array",
                        "items": {
                            "type": "string"
                        },
                        "nullable": true
                    },
                    "permissions": {
                        "type": "array",
                        "items": {
                            "type": "string"
                        },
                        "nullable": true
                    },
                    "vendorId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "portAgentId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "warehouseId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "vesselId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    }
                },
                "additionalProperties": false
            },
            "UserLookupResult": {
                "type": "object",
                "properties": {
                    "id": {
                        "type": "string",
                        "format": "uuid"
                    },
                    "username": {
                        "type": "string",
                        "nullable": true
                    },
                    "firstName": {
                        "type": "string",
                        "nullable": true
                    },
                    "lastName": {
                        "type": "string",
                        "nullable": true
                    },
                    "email": {
                        "type": "string",
                        "nullable": true
                    },
                    "displayName": {
                        "type": "string",
                        "nullable": true,
                        "readOnly": true
                    }
                },
                "additionalProperties": false
            },
            "UserPermissionsResult": {
                "type": "object",
                "properties": {
                    "roles": {
                        "type": "array",
                        "items": {
                            "type": "string"
                        },
                        "nullable": true
                    },
                    "permissions": {
                        "type": "object",
                        "additionalProperties": {
                            "type": "string"
                        },
                        "nullable": true
                    }
                },
                "additionalProperties": false
            },
            "ValueCurrencyCreateRequest": {
                "required": ["code", "name"],
                "type": "object",
                "properties": {
                    "code": {
                        "minLength": 1,
                        "type": "string"
                    },
                    "name": {
                        "minLength": 1,
                        "type": "string"
                    },
                    "icon": {
                        "type": "string",
                        "nullable": true
                    },
                    "isActive": {
                        "type": "boolean"
                    }
                },
                "additionalProperties": false
            },
            "ValueCurrencyTypeLookupResult": {
                "type": "object",
                "properties": {
                    "id": {
                        "type": "string",
                        "format": "uuid"
                    },
                    "code": {
                        "type": "string",
                        "nullable": true
                    },
                    "name": {
                        "type": "string",
                        "nullable": true
                    },
                    "icon": {
                        "type": "string",
                        "nullable": true
                    },
                    "isActive": {
                        "type": "boolean"
                    }
                },
                "additionalProperties": false
            },
            "ValueCurrencyUpdateRequest": {
                "required": ["code", "name"],
                "type": "object",
                "properties": {
                    "code": {
                        "minLength": 1,
                        "type": "string"
                    },
                    "name": {
                        "minLength": 1,
                        "type": "string"
                    },
                    "icon": {
                        "type": "string",
                        "nullable": true
                    },
                    "isActive": {
                        "type": "boolean"
                    }
                },
                "additionalProperties": false
            },
            "VendorCreateRequest": {
                "required": ["code", "name"],
                "type": "object",
                "properties": {
                    "code": {
                        "minLength": 1,
                        "type": "string"
                    },
                    "name": {
                        "minLength": 1,
                        "type": "string"
                    },
                    "localityId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "contactEmail": {
                        "type": "string",
                        "format": "email",
                        "nullable": true
                    },
                    "contactPhone": {
                        "type": "string",
                        "format": "tel",
                        "nullable": true
                    },
                    "address": {
                        "type": "string",
                        "nullable": true
                    },
                    "isActive": {
                        "type": "boolean"
                    }
                },
                "additionalProperties": false
            },
            "VendorLookupResult": {
                "type": "object",
                "properties": {
                    "id": {
                        "type": "string",
                        "format": "uuid"
                    },
                    "code": {
                        "type": "string",
                        "nullable": true
                    },
                    "name": {
                        "type": "string",
                        "nullable": true
                    },
                    "isActive": {
                        "type": "boolean"
                    },
                    "localityId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "contactEmail": {
                        "type": "string",
                        "nullable": true
                    },
                    "contactPhone": {
                        "type": "string",
                        "nullable": true
                    },
                    "address": {
                        "type": "string",
                        "nullable": true
                    }
                },
                "additionalProperties": false
            },
            "VendorLookupResultPagedLookupResult": {
                "type": "object",
                "properties": {
                    "items": {
                        "type": "array",
                        "items": {
                            "$ref": "#/components/schemas/VendorLookupResult"
                        },
                        "nullable": true
                    },
                    "totalCount": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "hasMore": {
                        "type": "boolean"
                    }
                },
                "additionalProperties": false
            },
            "VendorUpdateRequest": {
                "required": ["code", "name"],
                "type": "object",
                "properties": {
                    "code": {
                        "minLength": 1,
                        "type": "string"
                    },
                    "name": {
                        "minLength": 1,
                        "type": "string"
                    },
                    "localityId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "contactEmail": {
                        "type": "string",
                        "format": "email",
                        "nullable": true
                    },
                    "contactPhone": {
                        "type": "string",
                        "format": "tel",
                        "nullable": true
                    },
                    "address": {
                        "type": "string",
                        "nullable": true
                    },
                    "isActive": {
                        "type": "boolean"
                    }
                },
                "additionalProperties": false
            },
            "VersionRet": {
                "type": "object",
                "properties": {
                    "version": {
                        "type": "string",
                        "nullable": true
                    }
                },
                "additionalProperties": false
            },
            "VesselCreateRequest": {
                "required": ["code", "name"],
                "type": "object",
                "properties": {
                    "code": {
                        "minLength": 1,
                        "type": "string"
                    },
                    "name": {
                        "minLength": 1,
                        "type": "string"
                    },
                    "imoNumber": {
                        "type": "string",
                        "nullable": true
                    },
                    "capacity": {
                        "type": "integer",
                        "format": "int32",
                        "nullable": true
                    },
                    "isActive": {
                        "type": "boolean"
                    }
                },
                "additionalProperties": false
            },
            "VesselLookupResult": {
                "type": "object",
                "properties": {
                    "id": {
                        "type": "string",
                        "format": "uuid"
                    },
                    "code": {
                        "type": "string",
                        "nullable": true
                    },
                    "name": {
                        "type": "string",
                        "nullable": true
                    },
                    "isActive": {
                        "type": "boolean"
                    },
                    "imoNumber": {
                        "type": "string",
                        "nullable": true
                    },
                    "capacity": {
                        "type": "integer",
                        "format": "int32",
                        "nullable": true
                    }
                },
                "additionalProperties": false
            },
            "VesselLookupResultPagedLookupResult": {
                "type": "object",
                "properties": {
                    "items": {
                        "type": "array",
                        "items": {
                            "$ref": "#/components/schemas/VesselLookupResult"
                        },
                        "nullable": true
                    },
                    "totalCount": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "hasMore": {
                        "type": "boolean"
                    }
                },
                "additionalProperties": false
            },
            "VesselUpdateRequest": {
                "required": ["code", "name"],
                "type": "object",
                "properties": {
                    "code": {
                        "minLength": 1,
                        "type": "string"
                    },
                    "name": {
                        "minLength": 1,
                        "type": "string"
                    },
                    "imoNumber": {
                        "type": "string",
                        "nullable": true
                    },
                    "capacity": {
                        "type": "integer",
                        "format": "int32",
                        "nullable": true
                    },
                    "isActive": {
                        "type": "boolean"
                    }
                },
                "additionalProperties": false
            },
            "VirtualBatchScanRequest": {
                "required": ["virtualPoId"],
                "type": "object",
                "properties": {
                    "virtualPoId": {
                        "type": "string",
                        "format": "uuid"
                    },
                    "localityId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "warehouseId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "transportTypeId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "vesselId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "statusId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "statusOptionId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "vendorId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "portAgentId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "notes": {
                        "maxLength": 500,
                        "type": "string",
                        "nullable": true
                    },
                    "latitude": {
                        "type": "number",
                        "format": "double",
                        "nullable": true
                    },
                    "longitude": {
                        "type": "number",
                        "format": "double",
                        "nullable": true
                    },
                    "scanDate": {
                        "type": "string",
                        "format": "date-time",
                        "nullable": true
                    }
                },
                "additionalProperties": false
            },
            "VirtualBatchScanResult": {
                "type": "object",
                "properties": {
                    "virtualPoId": {
                        "type": "string",
                        "format": "uuid"
                    },
                    "virtualParentScanId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "totalUpdated": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "dissolved": {
                        "type": "boolean"
                    },
                    "updatedPurchaseOrders": {
                        "type": "array",
                        "items": {
                            "$ref": "#/components/schemas/ContainedPurchaseOrderResult"
                        },
                        "nullable": true
                    }
                },
                "additionalProperties": false
            },
            "VirtualContainerInfo": {
                "type": "object",
                "properties": {
                    "virtualPoId": {
                        "type": "string",
                        "format": "uuid"
                    },
                    "virtualPoNumber": {
                        "type": "string",
                        "nullable": true
                    },
                    "joinedAt": {
                        "type": "string",
                        "format": "date-time"
                    },
                    "leftAt": {
                        "type": "string",
                        "format": "date-time",
                        "nullable": true
                    }
                },
                "additionalProperties": false
            },
            "VirtualPurchaseOrderLinkResult": {
                "type": "object",
                "properties": {
                    "id": {
                        "type": "string",
                        "format": "uuid"
                    },
                    "virtualPurchaseOrderId": {
                        "type": "string",
                        "format": "uuid"
                    },
                    "purchaseOrderId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "lgaDocumentId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "createdAt": {
                        "type": "string",
                        "format": "date-time"
                    },
                    "poNumber": {
                        "type": "string",
                        "nullable": true
                    },
                    "description": {
                        "type": "string",
                        "nullable": true
                    },
                    "vendorName": {
                        "type": "string",
                        "nullable": true
                    },
                    "statusName": {
                        "type": "string",
                        "nullable": true
                    },
                    "targetDob": {
                        "type": "string",
                        "format": "date-time",
                        "nullable": true
                    },
                    "lgaUniqueId": {
                        "type": "string",
                        "nullable": true
                    }
                },
                "additionalProperties": false
            },
            "VirtualPurchaseOrderResult": {
                "type": "object",
                "properties": {
                    "id": {
                        "type": "string",
                        "format": "uuid"
                    },
                    "virtualPoNumber": {
                        "type": "string",
                        "nullable": true
                    },
                    "description": {
                        "type": "string",
                        "nullable": true
                    },
                    "warehouseId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "warehouseName": {
                        "type": "string",
                        "nullable": true
                    },
                    "statusId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "statusName": {
                        "type": "string",
                        "nullable": true
                    },
                    "vesselId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "vesselName": {
                        "type": "string",
                        "nullable": true
                    },
                    "issuedBy": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "issuedByName": {
                        "type": "string",
                        "nullable": true
                    },
                    "targetDob": {
                        "type": "string",
                        "format": "date-time",
                        "nullable": true
                    },
                    "isVirtual": {
                        "type": "boolean"
                    },
                    "createdAt": {
                        "type": "string",
                        "format": "date-time"
                    },
                    "updatedAt": {
                        "type": "string",
                        "format": "date-time",
                        "nullable": true
                    }
                },
                "additionalProperties": false
            },
            "WarehouseCreateRequest": {
                "required": ["code", "name", "streetAddress"],
                "type": "object",
                "properties": {
                    "name": {
                        "minLength": 1,
                        "type": "string"
                    },
                    "code": {
                        "minLength": 1,
                        "type": "string"
                    },
                    "streetAddress": {
                        "minLength": 1,
                        "type": "string"
                    },
                    "localityId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "email": {
                        "type": "string",
                        "format": "email",
                        "nullable": true
                    },
                    "telephone": {
                        "type": "string",
                        "format": "tel",
                        "nullable": true
                    },
                    "isActive": {
                        "type": "boolean"
                    }
                },
                "additionalProperties": false
            },
            "WarehouseDetailStatisticsResult": {
                "type": "object",
                "properties": {
                    "posAtWarehouse": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "expectedArrivals": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "dailyMovements": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "lateArrivals": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "consolidatedShipments": {
                        "type": "integer",
                        "format": "int32"
                    }
                },
                "additionalProperties": false
            },
            "WarehouseLookupResult": {
                "type": "object",
                "properties": {
                    "id": {
                        "type": "string",
                        "format": "uuid"
                    },
                    "code": {
                        "type": "string",
                        "nullable": true
                    },
                    "name": {
                        "type": "string",
                        "nullable": true
                    },
                    "isActive": {
                        "type": "boolean"
                    },
                    "localityId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "localityName": {
                        "type": "string",
                        "nullable": true
                    },
                    "locality": {
                        "$ref": "#/components/schemas/LocalityLookupResult"
                    }
                },
                "additionalProperties": false
            },
            "WarehouseLookupResultPagedLookupResult": {
                "type": "object",
                "properties": {
                    "items": {
                        "type": "array",
                        "items": {
                            "$ref": "#/components/schemas/WarehouseLookupResult"
                        },
                        "nullable": true
                    },
                    "totalCount": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "hasMore": {
                        "type": "boolean"
                    }
                },
                "additionalProperties": false
            },
            "WarehouseMapLocationResult": {
                "type": "object",
                "properties": {
                    "id": {
                        "type": "string",
                        "format": "uuid"
                    },
                    "name": {
                        "type": "string",
                        "nullable": true
                    },
                    "localityName": {
                        "type": "string",
                        "nullable": true
                    },
                    "countryName": {
                        "type": "string",
                        "nullable": true
                    },
                    "latitude": {
                        "type": "number",
                        "format": "double",
                        "nullable": true
                    },
                    "longitude": {
                        "type": "number",
                        "format": "double",
                        "nullable": true
                    },
                    "statistics": {
                        "$ref": "#/components/schemas/WarehouseDetailStatisticsResult"
                    }
                },
                "additionalProperties": false
            },
            "WarehouseResult": {
                "type": "object",
                "properties": {
                    "id": {
                        "type": "string",
                        "format": "uuid"
                    },
                    "name": {
                        "type": "string",
                        "nullable": true
                    },
                    "code": {
                        "type": "string",
                        "nullable": true
                    },
                    "streetAddress": {
                        "type": "string",
                        "nullable": true
                    },
                    "localityId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "locality": {
                        "$ref": "#/components/schemas/LocalityLookupResult"
                    },
                    "telephone": {
                        "type": "string",
                        "nullable": true
                    },
                    "email": {
                        "type": "string",
                        "nullable": true
                    },
                    "isActive": {
                        "type": "boolean"
                    },
                    "statistics": {
                        "$ref": "#/components/schemas/WarehouseDetailStatisticsResult"
                    }
                },
                "additionalProperties": false
            },
            "WarehouseStatisticsResult": {
                "type": "object",
                "properties": {
                    "totalWarehouses": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "totalLateArrivals": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "expectedArrivals": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "totalInventory": {
                        "type": "integer",
                        "format": "int32"
                    },
                    "totalConsolidatedShipments": {
                        "type": "integer",
                        "format": "int32"
                    }
                },
                "additionalProperties": false
            },
            "WarehouseUpdateRequest": {
                "required": ["code", "name", "streetAddress"],
                "type": "object",
                "properties": {
                    "name": {
                        "minLength": 1,
                        "type": "string"
                    },
                    "code": {
                        "minLength": 1,
                        "type": "string"
                    },
                    "streetAddress": {
                        "minLength": 1,
                        "type": "string"
                    },
                    "localityId": {
                        "type": "string",
                        "format": "uuid",
                        "nullable": true
                    },
                    "email": {
                        "type": "string",
                        "format": "email",
                        "nullable": true
                    },
                    "telephone": {
                        "type": "string",
                        "format": "tel",
                        "nullable": true
                    },
                    "isActive": {
                        "type": "boolean"
                    }
                },
                "additionalProperties": false
            }
        },
        "securitySchemes": {
            "Keycloak": {
                "type": "oauth2",
                "flows": {
                    "implicit": {
                        "authorizationUrl": "http://localhost:8080/realms/Navirina/protocol/openid-connect/auth",
                        "scopes": {
                            "openid": "OpenID Connect",
                            "profile": "User profile",
                            "email": "User email and verification status"
                        }
                    }
                }
            }
        }
    },
    "security": [
        {
            "Keycloak": []
        }
    ]
}
